(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.ce.aA === region.cz.aA)
	{
		return 'on line ' + region.ce.aA;
	}
	return 'on lines ' + region.ce.aA + ' through ' + region.cz.aA;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d1,
		impl.eD,
		impl.ep,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		bQ: func(record.bQ),
		cf: record.cf,
		b$: record.b$
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.bQ;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cf;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.b$) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d1,
		impl.eD,
		impl.ep,
		function(sendToApp, initialModel) {
			var view = impl.ab;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.d1,
		impl.eD,
		impl.ep,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.b3 && impl.b3(sendToApp)
			var view = impl.ab;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.co);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.et) && (_VirtualDom_doc.title = title = doc.et);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.ea;
	var onUrlRequest = impl.eb;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		b3: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.c8 === next.c8
							&& curr.ay === next.ay
							&& curr.c_.a === next.c_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		d1: function(flags)
		{
			return A3(impl.d1, flags, _Browser_getUrl(), key);
		},
		ab: impl.ab,
		eD: impl.eD,
		ep: impl.ep
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { aZ: 'hidden', dD: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { aZ: 'mozHidden', dD: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { aZ: 'msHidden', dD: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { aZ: 'webkitHidden', dD: 'webkitvisibilitychange' }
		: { aZ: 'hidden', dD: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dg: _Browser_getScene(),
		ds: {
			dt: _Browser_window.pageXOffset,
			du: _Browser_window.pageYOffset,
			bk: _Browser_doc.documentElement.clientWidth,
			cF: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		bk: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cF: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dg: {
				bk: node.scrollWidth,
				cF: node.scrollHeight
			},
			ds: {
				dt: node.scrollLeft,
				du: node.scrollTop,
				bk: node.clientWidth,
				cF: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dg: _Browser_getScene(),
			ds: {
				dt: x,
				du: y,
				bk: _Browser_doc.documentElement.clientWidth,
				cF: _Browser_doc.documentElement.clientHeight
			},
			dR: {
				dt: x + rect.left,
				du: y + rect.top,
				bk: rect.width,
				cF: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.dU.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.dU.b, xhr)); });
		$elm$core$Maybe$isJust(request.eB) && _Http_track(router, xhr, request.eB.a);

		try {
			xhr.open(request.d6, request.aO, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aO));
		}

		_Http_configureRequest(xhr, request);

		request.co.a && xhr.setRequestHeader('Content-Type', request.co.a);
		xhr.send(request.co.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.cE; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.aa.a || 0;
	xhr.responseType = request.dU.d;
	xhr.withCredentials = request.dz;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aO: xhr.responseURL,
		dm: xhr.status,
		en: xhr.statusText,
		cE: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			em: event.loaded,
			dj: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			ef: event.loaded,
			dj: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}



// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.i) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.k);
		} else {
			var treeLen = builder.i * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.l) : builder.l;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.i);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.k) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.k);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{l: nodeList, i: (len / $elm$core$Array$branchFactor) | 0, k: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {cD: fragment, ay: host, cY: path, c_: port_, c8: protocol, c9: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Carwow$StockSearch$InitialLoad = 0;
var $author$project$Carwow$StockSearch$Location = F2(
	function (postcode, coordinates) {
		return {ct: coordinates, c1: postcode};
	});
var $author$project$Carwow$StockSearch$Unrendered = 0;
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Carwow$Search$Response = $elm$core$Basics$identity;
var $author$project$Carwow$Search$DecoderStruct = F4(
	function (filters, pagination, data, sortOrder) {
		return {A: data, a: filters, p: pagination, h: sortOrder};
	});
var $author$project$Carwow$Search$Filters$Filters = $elm$core$Basics$identity;
var $author$project$Carwow$Search$Filters$Filter = function (key) {
	return function (label) {
		return function (description) {
			return function (parent) {
				return function (typeOf) {
					return function (value) {
						return function (open) {
							return function (chip) {
								return function (condition) {
									return function (hidden) {
										return {D: chip, cs: condition, cw: description, aZ: hidden, u: key, d3: label, z: open, cX: parent, eC: typeOf, g: value};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$Carwow$Theme$ChipDropdown$ChipDropdown = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Carwow$Theme$ChipDropdown$Closed = 1;
var $author$project$Carwow$Theme$Modal$Closed = 1;
var $author$project$Carwow$Theme$Modal$Modal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Carwow$Theme$Modal$init = function (id) {
	return A2($author$project$Carwow$Theme$Modal$Modal, id, 1);
};
var $author$project$Carwow$Theme$ChipDropdown$init = function (id) {
	return A2(
		$author$project$Carwow$Theme$ChipDropdown$ChipDropdown,
		1,
		$author$project$Carwow$Theme$Modal$init(id));
};
var $author$project$Carwow$Search$Filters$decodeChip = function (key) {
	return $elm$json$Json$Decode$succeed(
		$author$project$Carwow$Theme$ChipDropdown$init('chip-filter-' + key));
};
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Carwow$Search$Filters$decoderFilter = function (valueDecoder) {
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'hidden', $elm$json$Json$Decode$bool)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'condition', $elm$json$Json$Decode$string)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$andThen,
					$author$project$Carwow$Search$Filters$decodeChip,
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					$elm$json$Json$Decode$succeed(false),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$andThen,
							A2(
								$elm$core$Basics$composeR,
								valueDecoder,
								$elm$json$Json$Decode$field('value')),
							A2($elm$json$Json$Decode$field, 'type_of', $elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'type_of', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'parent',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									$elm$json$Json$Decode$maybe(
										A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'label', $elm$json$Json$Decode$string),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Filter)))))))))));
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Carwow$Search$Filters$decoder = function (_v0) {
	var filters = _v0;
	return A2(
		$elm$json$Json$Decode$map,
		function (newFilters) {
			return _Utils_update(
				filters,
				{a: newFilters});
		},
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Dict$fromList,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$List$map(
					function (filter) {
						return _Utils_Tuple2(filter.u, filter);
					}),
				$elm$json$Json$Decode$list(
					$author$project$Carwow$Search$Filters$decoderFilter(filters.av)))));
};
var $author$project$Carwow$Search$SortOrder$Legacy = 0;
var $author$project$Carwow$Search$SortOrder$SortOrder = $elm$core$Basics$identity;
var $author$project$Carwow$Search$SortOrder$Struct = F5(
	function (key, label, options, chip, format) {
		return {D: chip, bE: format, u: key, d3: label, o: options};
	});
var $author$project$Carwow$Search$SortOrder$SortOption = F4(
	function (key, label, direction, selected) {
		return {bA: direction, u: key, d3: label, ek: selected};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Carwow$Search$SortOrder$decoderSortOption = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'selected',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'direction',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Carwow$Search$SortOrder$SortOption)))));
var $author$project$Carwow$Search$SortOrder$JsonApi = 1;
var $author$project$Carwow$Search$SortOrder$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'json_api') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Carwow$Search$SortOrder$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'format',
		$author$project$Carwow$Search$SortOrder$formatDecoder,
		0,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			$author$project$Carwow$Theme$ChipDropdown$init('sort-order'),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'options',
				$elm$json$Json$Decode$list($author$project$Carwow$Search$SortOrder$decoderSortOption),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'label',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'key',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Carwow$Search$SortOrder$Struct)))))));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Carwow$Theme$Pagination$PaginationProperties = F4(
	function (totalCount, totalPages, perPage, currentPage) {
		return {au: currentPage, ec: perPage, ez: totalCount, eA: totalPages};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Carwow$Search$paginationDecode = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Carwow$Theme$Pagination$PaginationProperties,
	A2($elm$json$Json$Decode$field, 'total', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_pages', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'per_page', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'current_page', $elm$json$Json$Decode$int));
var $author$project$Carwow$Search$decoderStruct = function (response) {
	return A5(
		$elm$json$Json$Decode$map4,
		$author$project$Carwow$Search$DecoderStruct,
		A2(
			$elm$json$Json$Decode$field,
			'filters',
			$author$project$Carwow$Search$Filters$decoder(response.a)),
		A2($elm$json$Json$Decode$field, 'pagination', $author$project$Carwow$Search$paginationDecode),
		A2($elm$json$Json$Decode$field, 'data', response.Q),
		A2($elm$json$Json$Decode$field, 'sort_order', $author$project$Carwow$Search$SortOrder$decoder));
};
var $author$project$Carwow$Search$decoder = function (response) {
	return A2(
		$elm$json$Json$Decode$map,
		function (struct) {
			return _Utils_update(
				response,
				{A: struct.A, a: struct.a, p: struct.p, h: struct.h});
		},
		$author$project$Carwow$Search$decoderStruct(response));
};
var $author$project$Carwow$Search$decode = function (_v0) {
	var response = _v0;
	return $elm$json$Json$Decode$decodeString(
		$author$project$Carwow$Search$decoder(response));
};
var $author$project$Carwow$StockSearch$StockDeal$StockDeal = F4(
	function (id, dealType, distance, deliveryOnly) {
		return {dJ: dealType, dO: deliveryOnly, dP: distance, d_: id};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Carwow$StockSearch$StockDeal$decoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Carwow$StockSearch$StockDeal$StockDeal,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'distance', $elm$json$Json$Decode$float)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'delivery_only', $elm$json$Json$Decode$bool)));
var $author$project$Carwow$Search$FilterOptions$defaultFilterOptions = {dA: _List_Nil, dM: _List_Nil, dN: _List_Nil, dT: _List_Nil, dZ: _List_Nil};
var $author$project$Carwow$Http$Client = $elm$core$Basics$identity;
var $author$project$Carwow$Http$Get = 0;
var $author$project$Carwow$Http$get = function (_v0) {
	var client = _v0;
	return _Utils_update(
		client,
		{d6: 0});
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Carwow$Http$defaultTimeoutSecs = 10;
var $author$project$Carwow$Http$secsToMs = function (secs) {
	return $elm$core$Maybe$Just(secs * 1000);
};
var $author$project$Carwow$Http$defaultTimeoutMs = $author$project$Carwow$Http$secsToMs($author$project$Carwow$Http$defaultTimeoutSecs);
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Carwow$Http$defaultClient = {
	co: $elm$http$Http$emptyBody,
	aX: _List_Nil,
	cE: _List_fromArray(
		[
			_Utils_Tuple2('X-User-Agent', 'carwow/browser (Carwow.Http 1.0.2)'),
			_Utils_Tuple2(
			'X-Client-Timeout',
			$elm$core$String$fromInt($author$project$Carwow$Http$defaultTimeoutSecs))
		]),
	ay: $elm$url$Url$Builder$absolute,
	d6: 0,
	U: _List_Nil,
	aa: $author$project$Carwow$Http$defaultTimeoutMs,
	aP: false
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Carwow$Http$relative = _Utils_update(
	$author$project$Carwow$Http$defaultClient,
	{ay: $elm$url$Url$Builder$relative});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Carwow$Search$init = F2(
	function (data, config) {
		return {
			P: $author$project$Carwow$Http$get($author$project$Carwow$Http$relative),
			aR: config.aR,
			A: data,
			Q: config.Q,
			ax: A2($elm$core$Maybe$withDefault, $author$project$Carwow$Search$FilterOptions$defaultFilterOptions, config.ax),
			a: config.a,
			T: config.T,
			p: A4($author$project$Carwow$Theme$Pagination$PaginationProperties, 0, 0, 5, 1),
			h: config.h,
			aL: config.aL,
			an: 0
		};
	});
var $author$project$Carwow$Search$SortOrder$init = {
	D: $author$project$Carwow$Theme$ChipDropdown$init('sort-order'),
	bE: 0,
	u: '',
	d3: '',
	o: _List_Nil
};
var $author$project$Carwow$StockSearch$PrismicPreview$NotPrismicPreview = {$: 1};
var $author$project$Carwow$StockSearch$PrismicPreview$PrismicPreview = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Carwow$StockSearch$PrismicPreview$importantPrismicQueryParams = _List_fromArray(
	['documentId', 'token', 'page_selection']);
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Carwow$StockSearch$PrismicPreview$init = function (searchParams) {
	var prismicParams = A2(
		$elm$core$List$sortBy,
		$elm$core$Tuple$first,
		A2(
			$elm$core$List$filter,
			function (_v9) {
				var name = _v9.a;
				return A2($elm$core$List$member, name, $author$project$Carwow$StockSearch$PrismicPreview$importantPrismicQueryParams);
			},
			searchParams));
	_v0$2:
	while (true) {
		if ((prismicParams.b && (prismicParams.a.a === 'documentId')) && prismicParams.b.b) {
			if (prismicParams.b.b.b) {
				if (((prismicParams.b.a.a === 'page_selection') && (prismicParams.b.b.a.a === 'token')) && (!prismicParams.b.b.b.b)) {
					var _v1 = prismicParams.a;
					var documentId = _v1.b;
					var _v2 = prismicParams.b;
					var _v3 = _v2.a;
					var pageSelection = _v3.b;
					var _v4 = _v2.b;
					var _v5 = _v4.a;
					var token = _v5.b;
					return $author$project$Carwow$StockSearch$PrismicPreview$PrismicPreview(
						{
							aV: documentId,
							a6: $elm$core$Maybe$Just(pageSelection),
							bh: token
						});
				} else {
					break _v0$2;
				}
			} else {
				if (prismicParams.b.a.a === 'token') {
					var _v6 = prismicParams.a;
					var documentId = _v6.b;
					var _v7 = prismicParams.b;
					var _v8 = _v7.a;
					var token = _v8.b;
					return $author$project$Carwow$StockSearch$PrismicPreview$PrismicPreview(
						{aV: documentId, a6: $elm$core$Maybe$Nothing, bh: token});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $author$project$Carwow$StockSearch$PrismicPreview$NotPrismicPreview;
};
var $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSlider = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$Radio = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$Select = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$SelectRanges = function (a) {
	return {$: 4, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$SingleSlider = function (a) {
	return {$: 3, a: a};
};
var $author$project$Carwow$Search$Filters$ClientChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Search$Filters$clientChanged = $author$project$Carwow$Search$Filters$ClientChanged;
var $author$project$Carwow$Search$Filters$DoubleSlider$changed = function (_v0) {
	var slider = _v0;
	return slider.bq;
};
var $author$project$Carwow$Search$Filters$SingleSlider$changed = function (_v0) {
	var slider = _v0;
	return slider.bq;
};
var $author$project$Carwow$Search$Filters$ServerChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Search$Filters$serverChanged = $author$project$Carwow$Search$Filters$ServerChanged;
var $author$project$Carwow$StockSearch$StockDealsFilters$handleSliderChanged = F2(
	function (filter, changed) {
		return changed ? $author$project$Carwow$Search$Filters$serverChanged(filter) : $author$project$Carwow$Search$Filters$clientChanged(filter);
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged = function (filter) {
	switch (filter.$) {
		case 2:
			var slider = filter.a;
			return A2(
				$author$project$Carwow$StockSearch$StockDealsFilters$handleSliderChanged,
				filter,
				$author$project$Carwow$Search$Filters$DoubleSlider$changed(slider));
		case 3:
			var slider = filter.a;
			return A2(
				$author$project$Carwow$StockSearch$StockDealsFilters$handleSliderChanged,
				filter,
				$author$project$Carwow$Search$Filters$SingleSlider$changed(slider));
		default:
			return $author$project$Carwow$Search$Filters$serverChanged(filter);
	}
};
var $author$project$Carwow$Search$Filters$DoubleSlider$DoubleSlider = $elm$core$Basics$identity;
var $elm$core$String$fromFloat = _String_fromNumber;
var $carwow$elm_slider_old$DoubleSliderOld$defaultCurrentRangeFormatter = F4(
	function (lowValue, highValue, min, max) {
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$elm$core$String$fromFloat(lowValue),
					'-',
					$elm$core$String$fromFloat(highValue)
				]));
	});
var $carwow$elm_slider_old$DoubleSliderOld$defaultModel = {aS: $carwow$elm_slider_old$DoubleSliderOld$defaultCurrentRangeFormatter, r: 100, s: 0, F: 100, cN: $elm$core$String$fromFloat, G: 0, cP: $elm$core$String$fromFloat, a5: 1, aG: 10};
var $author$project$AutomaticTranslations$Number$Currency$Format$delimiter = '.';
var $author$project$AutomaticTranslations$Number$Currency$Format$format = '%n %u';
var $author$project$AutomaticTranslations$Number$Currency$Format$precision = '0';
var $author$project$AutomaticTranslations$Number$Currency$Format$separator = ',';
var $author$project$AutomaticTranslations$Number$Currency$Format$significant = '';
var $author$project$AutomaticTranslations$Number$Currency$Format$stripInsignificantZeros = '';
var $author$project$AutomaticTranslations$Number$Currency$Format$unit = '€';
var $author$project$Carwow$I18n$Currency$defaultConfig = {
	bz: $author$project$AutomaticTranslations$Number$Currency$Format$delimiter,
	bE: $author$project$AutomaticTranslations$Number$Currency$Format$format,
	bZ: A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt($author$project$AutomaticTranslations$Number$Currency$Format$precision)),
	b2: $author$project$AutomaticTranslations$Number$Currency$Format$separator,
	di: $author$project$AutomaticTranslations$Number$Currency$Format$significant,
	dn: $author$project$AutomaticTranslations$Number$Currency$Format$stripInsignificantZeros,
	ci: $author$project$AutomaticTranslations$Number$Currency$Format$unit
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	dK: '.',
	dL: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	bW: '−',
	bX: '',
	c$: '',
	c0: '',
	bg: 0,
	es: '',
	dx: '',
	dy: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		dL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		es: ','
	});
var $author$project$Carwow$I18n$Currency$defaultLocale = $cuducos$elm_format_number$FormatNumber$Locales$usLocale;
var $author$project$Carwow$I18n$Currency$configToLocale = function (config) {
	return _Utils_update(
		$author$project$Carwow$I18n$Currency$defaultLocale,
		{
			dK: config.b2,
			dL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(config.bZ),
			es: config.bz
		});
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {dL: decimals, cK: integers, cW: original, a8: prefix, be: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.cK,
				$elm$core$List$singleton(formatted.dL))));
	return onlyZeros ? 1 : ((formatted.cW < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.dL;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$not = _Basics_not;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.dL;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.bg,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{a8: locale.bW, be: locale.bX});
			case 0:
				return _Utils_update(
					partial,
					{a8: locale.c$, be: locale.c0});
			default:
				return _Utils_update(
					partial,
					{a8: locale.dx, be: locale.dy});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.dK, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.es, formatted.cK);
		var decimals = stringfyDecimals(formatted.dL);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.a8, integers, decimals, formatted.be]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Carwow$I18n$Currency$format = F3(
	function (valueToFloat, config, value) {
		var formattedValue = A2(
			$cuducos$elm_format_number$FormatNumber$format,
			$author$project$Carwow$I18n$Currency$configToLocale(config),
			valueToFloat(value));
		return A3(
			$elm$core$String$replace,
			'%n',
			formattedValue,
			A3($elm$core$String$replace, '%u', config.ci, config.bE));
	});
var $author$project$Carwow$I18n$Currency$formatFloatWithConfig = $author$project$Carwow$I18n$Currency$format($elm$core$Basics$identity);
var $author$project$Carwow$I18n$Currency$formatFloat = $author$project$Carwow$I18n$Currency$formatFloatWithConfig($author$project$Carwow$I18n$Currency$defaultConfig);
var $author$project$Carwow$Search$Filters$DoubleSlider$currencyFormatter = F4(
	function (lowValue, highValue, _v0, _v1) {
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					$author$project$Carwow$I18n$Currency$formatFloat(lowValue),
					'-',
					$author$project$Carwow$I18n$Currency$formatFloat(highValue)
				]));
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$integerUsLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{
		dL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(0)
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$mileageMaxFormatter = function (number) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Carwow$Search$Filters$DoubleSlider$integerUsLocale, number) + '+';
};
var $author$project$Carwow$Search$Filters$DoubleSlider$mileageMinFormatter = function (number) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Carwow$Search$Filters$DoubleSlider$integerUsLocale, number);
};
var $author$project$AutomaticTranslations$Search$Filters$miles = 'km';
var $author$project$Carwow$Search$Filters$DoubleSlider$mileageRangeFormatter = F4(
	function (lowValue, highValue, _v0, max) {
		var suffix = _Utils_eq(highValue, max) ? '+' : '';
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Carwow$Search$Filters$DoubleSlider$integerUsLocale, lowValue),
					'-',
					_Utils_ap(
					A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Carwow$Search$Filters$DoubleSlider$integerUsLocale, highValue),
					suffix),
					$author$project$AutomaticTranslations$Search$Filters$miles
				]));
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$withFormat = F2(
	function (format, model) {
		switch (format) {
			case 1:
				return _Utils_update(
					model,
					{aS: $author$project$Carwow$Search$Filters$DoubleSlider$currencyFormatter, cN: $author$project$Carwow$I18n$Currency$formatFloat, cP: $author$project$Carwow$I18n$Currency$formatFloat});
			case 2:
				return _Utils_update(
					model,
					{aS: $author$project$Carwow$Search$Filters$DoubleSlider$mileageRangeFormatter, cN: $author$project$Carwow$Search$Filters$DoubleSlider$mileageMaxFormatter, cP: $author$project$Carwow$Search$Filters$DoubleSlider$mileageMinFormatter});
			default:
				return model;
		}
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$toSliderModel = function (sliderOptions) {
	var defaultModel = A2($author$project$Carwow$Search$Filters$DoubleSlider$withFormat, sliderOptions.bE, $carwow$elm_slider_old$DoubleSliderOld$defaultModel);
	return _Utils_update(
		defaultModel,
		{r: sliderOptions.r, s: sliderOptions.s, F: sliderOptions.F, G: sliderOptions.G, aG: sliderOptions.aG});
};
var $author$project$Carwow$Search$Filters$DoubleSlider$selected = function (model) {
	return (_Utils_cmp(model.s, model.G) > 0) || (_Utils_cmp(model.r, model.F) < 0);
};
var $author$project$Carwow$Search$Filters$DoubleSlider$toSliderOptions = F3(
	function (model, prevSlider, isChanged) {
		return {
			bq: isChanged,
			bE: prevSlider.bE,
			r: model.r,
			u: prevSlider.u,
			s: model.s,
			F: model.F,
			G: model.G,
			ek: $author$project$Carwow$Search$Filters$DoubleSlider$selected(model),
			aG: model.aG
		};
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$Basics$round = _Basics_round;
var $carwow$elm_slider_old$DoubleSliderOld$snapValue = F2(
	function (value, step) {
		return (($elm$core$Basics$round(value) / step) | 0) * step;
	});
var $elm$core$String$toFloat = _String_toFloat;
var $carwow$elm_slider_old$DoubleSliderOld$update = F2(
	function (message, model) {
		if (message.$ === 1) {
			var valueType = message.a;
			var newValue = message.b;
			var shouldFetchModels = message.c;
			var convertedValue = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toFloat(newValue));
			var newModel = function () {
				switch (valueType) {
					case 0:
						var newLowValue = A2($elm$core$Basics$min, convertedValue, model.r - (model.aG * model.a5));
						return _Utils_update(
							model,
							{s: newLowValue});
					case 1:
						var newHighValue = A2($elm$core$Basics$max, convertedValue, model.s + (model.aG * model.a5));
						return _Utils_update(
							model,
							{r: newHighValue});
					default:
						return model;
				}
			}();
			return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, shouldFetchModels);
		} else {
			var valueType = message.a;
			var newValue = message.b;
			var convertedValue = A2(
				$carwow$elm_slider_old$DoubleSliderOld$snapValue,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(newValue)),
				model.aG);
			var newModel = function () {
				switch (valueType) {
					case 0:
						return _Utils_update(
							model,
							{s: convertedValue});
					case 1:
						return _Utils_update(
							model,
							{r: convertedValue});
					default:
						return model;
				}
			}();
			return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, true);
		}
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$select = F2(
	function (msg, _v0) {
		var slider = _v0;
		var model = $author$project$Carwow$Search$Filters$DoubleSlider$toSliderModel(slider);
		var _v1 = A2($carwow$elm_slider_old$DoubleSliderOld$update, msg, model);
		var newSliderModel = _v1.a;
		var isChanged = _v1.c;
		return A3($author$project$Carwow$Search$Filters$DoubleSlider$toSliderOptions, newSliderModel, slider, isChanged);
	});
var $author$project$Carwow$Search$Filters$Radio$Radio = $elm$core$Basics$identity;
var $author$project$Carwow$Search$Filters$Radio$select = F2(
	function (key, _v0) {
		var radio = _v0;
		var updater = function (option) {
			return _Utils_update(
				option,
				{
					ek: _Utils_eq(key, option.u)
				});
		};
		var newOptions = A2($elm$core$List$map, updater, radio.o);
		return _Utils_update(
			radio,
			{o: newOptions});
	});
var $author$project$Carwow$Search$Filters$SingleSlider$SingleSlider = $elm$core$Basics$identity;
var $carwow$elm_slider_old$SingleSliderOld$ProgressLeft = 0;
var $carwow$elm_slider_old$SingleSliderOld$ProgressRight = 1;
var $carwow$elm_slider_old$SingleSliderOld$defaultCurrentValueFormatter = F2(
	function (currentValue, max) {
		return _Utils_eq(currentValue, max) ? '' : $elm$core$String$fromFloat(currentValue);
	});
var $carwow$elm_slider_old$SingleSliderOld$defaultModel = {aT: $carwow$elm_slider_old$SingleSliderOld$defaultCurrentValueFormatter, bB: false, F: 100, cN: $elm$core$String$fromFloat, G: 0, cP: $elm$core$String$fromFloat, ed: 0, M: false, aG: 10, g: 0};
var $author$project$AutomaticTranslations$Search$Filters$upToManyYears = function (years) {
	return 'Bis zu ' + (years + ' Jahre');
};
var $author$project$AutomaticTranslations$Search$Filters$upToOneYear = 'Bis zu einem Jahr';
var $author$project$Carwow$Search$Filters$SingleSlider$currentAgeFormatter = F2(
	function (currentValue, max) {
		return (currentValue <= 1) ? $author$project$AutomaticTranslations$Search$Filters$upToOneYear : (_Utils_eq(currentValue, max) ? '' : $author$project$AutomaticTranslations$Search$Filters$upToManyYears(
			$elm$core$String$fromFloat(currentValue)));
	});
var $author$project$Carwow$Search$Filters$SingleSlider$withUnit = function (unit) {
	return $elm$core$String$isEmpty(unit) ? unit : (' ' + unit);
};
var $author$project$Carwow$Search$Filters$SingleSlider$currentDefaultFormatter = F3(
	function (_v0, currentValue, _v1) {
		var unit = _v0.ci;
		var minLabel = _v0.cQ;
		var maxLabel = _v0.cO;
		var min = _v0.G;
		var max = _v0.F;
		return _Utils_eq(currentValue, max) ? '' : (_Utils_eq(currentValue, min) ? A2(
			$elm$core$Maybe$withDefault,
			_Utils_ap(
				$elm$core$String$fromFloat(currentValue),
				$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit)),
			minLabel) : _Utils_ap(
			$elm$core$String$fromFloat(currentValue),
			$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit)));
	});
var $author$project$AutomaticTranslations$Search$Filters$upTo = function (amount) {
	return 'bis zu ' + (amount + '');
};
var $author$project$Carwow$Search$Filters$SingleSlider$currentUpToFormatter = F3(
	function (_v0, currentValue, max) {
		var unit = _v0.ci;
		var maxLabel = _v0.cO;
		var minLabel = _v0.cQ;
		var min = _v0.G;
		return _Utils_eq(currentValue, max) ? A2($elm$core$Maybe$withDefault, '', maxLabel) : (_Utils_eq(currentValue, min) ? A2(
			$elm$core$Maybe$withDefault,
			_Utils_ap(
				$elm$core$String$fromFloat(currentValue),
				$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit)),
			minLabel) : $author$project$AutomaticTranslations$Search$Filters$upTo(
			_Utils_ap(
				$elm$core$String$fromFloat(currentValue),
				$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit))));
	});
var $author$project$AutomaticTranslations$Search$Filters$maxAge = function (max) {
	return '' + (max + '+ Jahre');
};
var $author$project$Carwow$Search$Filters$SingleSlider$maxAgeFormatter = function (max) {
	return $author$project$AutomaticTranslations$Search$Filters$maxAge(
		$elm$core$String$fromFloat(max));
};
var $author$project$Carwow$Search$Filters$SingleSlider$maxDefaultFormatter = F2(
	function (_v0, max) {
		var unit = _v0.ci;
		var maxLabel = _v0.cO;
		if (!maxLabel.$) {
			var label = maxLabel.a;
			return label;
		} else {
			return _Utils_ap(
				$elm$core$String$fromFloat(max),
				$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit));
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$maxUpToFormatter = F2(
	function (_v0, max) {
		var unit = _v0.ci;
		var maxLabel = _v0.cO;
		if (!maxLabel.$) {
			var label = maxLabel.a;
			return label;
		} else {
			return $elm$core$String$fromFloat(max) + ('+' + $author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit));
		}
	});
var $author$project$AutomaticTranslations$Search$Filters$minAge = function (min) {
	return '< ' + (min + ' Jahr');
};
var $author$project$Carwow$Search$Filters$SingleSlider$minAgeFormatter = function (min) {
	return $author$project$AutomaticTranslations$Search$Filters$minAge(
		$elm$core$String$fromFloat(min));
};
var $author$project$Carwow$Search$Filters$SingleSlider$minDefaultFormatter = F2(
	function (_v0, min) {
		var unit = _v0.ci;
		var minLabel = _v0.cQ;
		if (!minLabel.$) {
			var label = minLabel.a;
			return label;
		} else {
			return _Utils_ap(
				$elm$core$String$fromFloat(min),
				$author$project$Carwow$Search$Filters$SingleSlider$withUnit(unit));
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$withFormat = F2(
	function (options, model) {
		var _v0 = options.bE;
		switch (_v0) {
			case 1:
				return _Utils_update(
					model,
					{
						aT: $author$project$Carwow$Search$Filters$SingleSlider$currentUpToFormatter(options),
						cN: $author$project$Carwow$Search$Filters$SingleSlider$maxUpToFormatter(options),
						cP: $author$project$Carwow$Search$Filters$SingleSlider$minDefaultFormatter(options)
					});
			case 2:
				return _Utils_update(
					model,
					{aT: $author$project$Carwow$Search$Filters$SingleSlider$currentAgeFormatter, cN: $author$project$Carwow$Search$Filters$SingleSlider$maxAgeFormatter, cP: $author$project$Carwow$Search$Filters$SingleSlider$minAgeFormatter});
			default:
				return _Utils_update(
					model,
					{
						aT: $author$project$Carwow$Search$Filters$SingleSlider$currentDefaultFormatter(options),
						cN: $author$project$Carwow$Search$Filters$SingleSlider$maxDefaultFormatter(options),
						cP: $author$project$Carwow$Search$Filters$SingleSlider$minDefaultFormatter(options)
					});
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$toSliderModel = function (sliderOptions) {
	var direction = sliderOptions.M ? 1 : 0;
	var defaultModel = A2($author$project$Carwow$Search$Filters$SingleSlider$withFormat, sliderOptions, $carwow$elm_slider_old$SingleSliderOld$defaultModel);
	return _Utils_update(
		defaultModel,
		{F: sliderOptions.F, G: sliderOptions.G, ed: direction, M: sliderOptions.M, aG: sliderOptions.aG, g: sliderOptions.g});
};
var $author$project$Carwow$Search$Filters$SingleSlider$selected = F2(
	function (model, format) {
		switch (format) {
			case 1:
				return _Utils_cmp(model.g, model.F) < 0;
			case 2:
				return _Utils_cmp(model.g, model.F) < 0;
			default:
				return model.M ? (!_Utils_eq(model.g, model.F)) : (!_Utils_eq(model.g, model.G));
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$toSliderOptions = F3(
	function (model, prevSlider, isChanged) {
		return {
			bq: isChanged,
			bE: prevSlider.bE,
			u: prevSlider.u,
			F: model.F,
			cO: prevSlider.cO,
			G: model.G,
			cQ: prevSlider.cQ,
			M: model.M,
			ek: A2($author$project$Carwow$Search$Filters$SingleSlider$selected, model, prevSlider.bE),
			aG: model.aG,
			ci: prevSlider.ci,
			g: model.g
		};
	});
var $carwow$elm_slider_old$SingleSliderOld$snapValue = F2(
	function (value, model) {
		var roundedStep = $elm$core$Basics$round(model.aG);
		var adjustedRoundedStep = (roundedStep > 0) ? roundedStep : 1;
		var newValue = value / adjustedRoundedStep;
		var roundedValue = function () {
			var _v0 = model.ed;
			if (!_v0) {
				return $elm$core$Basics$floor(newValue);
			} else {
				return $elm$core$Basics$ceiling(newValue);
			}
		}();
		var nextValue = roundedValue * adjustedRoundedStep;
		return nextValue;
	});
var $carwow$elm_slider_old$SingleSliderOld$update = F2(
	function (message, model) {
		switch (message.$) {
			case 1:
				var newValue = message.a;
				var shouldFetchModels = message.b;
				var convertedValue = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(newValue));
				var newModel = _Utils_update(
					model,
					{g: convertedValue});
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, shouldFetchModels);
			case 2:
				var newValue = message.a;
				var convertedValue = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toFloat(newValue));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g: convertedValue}),
					$elm$core$Platform$Cmd$none,
					true);
			default:
				var newValue = message.a;
				var convertedValue = A2(
					$carwow$elm_slider_old$SingleSliderOld$snapValue,
					A2(
						$elm$core$Maybe$withDefault,
						model.G,
						$elm$core$String$toFloat(newValue)),
					model);
				var newModel = _Utils_update(
					model,
					{g: convertedValue});
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, true);
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$select = F2(
	function (msg, _v0) {
		var slider = _v0;
		var model = $author$project$Carwow$Search$Filters$SingleSlider$toSliderModel(slider);
		var _v1 = A2($carwow$elm_slider_old$SingleSliderOld$update, msg, model);
		var newSliderModel = _v1.a;
		var isChanged = _v1.c;
		return A3($author$project$Carwow$Search$Filters$SingleSlider$toSliderOptions, newSliderModel, slider, isChanged);
	});
var $author$project$Carwow$Search$Filters$Select$Select = $elm$core$Basics$identity;
var $author$project$Carwow$Search$Filters$Select$deselectOptions = function (option) {
	return _Utils_update(
		option,
		{ek: false});
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Carwow$Search$Filters$Select$hasAllOptionSelected = function (options) {
	var allOptionSelected = A2(
		$elm$core$List$filter,
		function (option) {
			return (option.u === 'All') && option.ek;
		},
		options);
	return !$elm$core$List$isEmpty(allOptionSelected);
};
var $author$project$Carwow$Search$Filters$Select$toggle = F2(
	function (key, _v0) {
		var select = _v0;
		var updater = function (option) {
			return _Utils_eq(key, option.u) ? _Utils_update(
				option,
				{ek: !option.ek}) : option;
		};
		var options = select.o;
		var newOptions = ((key === 'All') || $author$project$Carwow$Search$Filters$Select$hasAllOptionSelected(options)) ? A2($elm$core$List$map, $author$project$Carwow$Search$Filters$Select$deselectOptions, options) : options;
		return _Utils_update(
			select,
			{
				o: A2($elm$core$List$map, updater, newOptions)
			});
	});
var $author$project$Carwow$Search$Filters$SelectRanges$SelectRanges = $elm$core$Basics$identity;
var $author$project$Carwow$Search$Filters$SelectRanges$changeSelect = F3(
	function (minValue, maxValue, _v0) {
		var params = _v0;
		var updater = function (range) {
			return range.ek ? _Utils_update(
				range,
				{r: maxValue.g, s: minValue.g}) : range;
		};
		return _Utils_update(
			params,
			{
				q: A2($elm$core$List$map, updater, params.q)
			});
	});
var $author$project$Carwow$Search$Filters$SelectRanges$select = F2(
	function (key, _v0) {
		var params = _v0;
		var updater = function (option) {
			return _Utils_update(
				option,
				{
					ek: _Utils_eq(key, option.u)
				});
		};
		return _Utils_update(
			params,
			{
				q: A2($elm$core$List$map, updater, params.q)
			});
	});
var $author$project$Carwow$Search$Filters$SelectRanges$update = F2(
	function (msg, ranges) {
		if (!msg.$) {
			var key = msg.a;
			return A2($author$project$Carwow$Search$Filters$SelectRanges$select, key, ranges);
		} else {
			var minValue = msg.a;
			var maxValue = msg.b;
			return A3($author$project$Carwow$Search$Filters$SelectRanges$changeSelect, minValue, maxValue, ranges);
		}
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$applyChange = F2(
	function (change, filter) {
		var _v0 = _Utils_Tuple2(change, filter);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var key = _v0.a.a;
						var select = _v0.b.a;
						return $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged(
							$author$project$Carwow$StockSearch$StockDealsFilters$Select(
								A2($author$project$Carwow$Search$Filters$Select$toggle, key, select)));
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var key = _v0.a.a;
						var radio = _v0.b.a;
						return $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged(
							$author$project$Carwow$StockSearch$StockDealsFilters$Radio(
								A2($author$project$Carwow$Search$Filters$Radio$select, key, radio)));
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var sliderMsg = _v0.a.a;
						var slider = _v0.b.a;
						return $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged(
							$author$project$Carwow$StockSearch$StockDealsFilters$DoubleSlider(
								A2($author$project$Carwow$Search$Filters$DoubleSlider$select, sliderMsg, slider)));
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var sliderMsg = _v0.a.a;
						var slider = _v0.b.a;
						return $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged(
							$author$project$Carwow$StockSearch$StockDealsFilters$SingleSlider(
								A2($author$project$Carwow$Search$Filters$SingleSlider$select, sliderMsg, slider)));
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var selectRangeMsg = _v0.a.a;
						var ranges = _v0.b.a;
						return $author$project$Carwow$StockSearch$StockDealsFilters$handleChanged(
							$author$project$Carwow$StockSearch$StockDealsFilters$SelectRanges(
								A2($author$project$Carwow$Search$Filters$SelectRanges$update, selectRangeMsg, ranges)));
					} else {
						break _v0$5;
					}
			}
		}
		return $author$project$Carwow$Search$Filters$clientChanged(filter);
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$SliderOptions = F9(
	function (key, min, max, step, lowValue, highValue, selected, format, changed) {
		return {bq: changed, bE: format, r: highValue, u: key, s: lowValue, F: max, G: min, ek: selected, aG: step};
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$Currency = 1;
var $author$project$Carwow$Search$Filters$DoubleSlider$Default = 0;
var $author$project$Carwow$Search$Filters$DoubleSlider$Mileage = 2;
var $author$project$Carwow$Search$Filters$DoubleSlider$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'currency':
				return $elm$json$Json$Decode$succeed(1);
			case 'mileage':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$DoubleSlider$sliderOptionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'format',
		$author$project$Carwow$Search$Filters$DoubleSlider$formatDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selected',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'high_value',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'low_value',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'step',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'max',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'min',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'key',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$DoubleSlider$SliderOptions))))))))));
var $author$project$Carwow$Search$Filters$DoubleSlider$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Carwow$Search$Filters$DoubleSlider$sliderOptionsDecoder);
var $author$project$Carwow$Search$Filters$Radio$Legacy = 0;
var $author$project$Carwow$Search$Filters$Radio$RadioParams = F5(
	function (options, all, only, operator, format) {
		return {bn: all, bE: format, ag: only, a4: operator, o: options};
	});
var $author$project$Carwow$Search$Filters$Radio$JsonApi = 1;
var $author$project$Carwow$Search$Filters$Radio$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'json_api') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$Radio$Option = F8(
	function (key, label, labelDescription, selected, selectedLabel, disabled, presetQueryParams, badge) {
		return {at: badge, bB: disabled, u: key, d3: label, az: labelDescription, aC: presetQueryParams, ek: selected, el: selectedLabel};
	});
var $author$project$Carwow$Search$Filters$Radio$QueryParam = F2(
	function (key, value) {
		return {u: key, g: value};
	});
var $author$project$Carwow$Search$Filters$Radio$queryParamDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'key',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Radio$QueryParam)));
var $author$project$Carwow$Search$Filters$Radio$optionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'badge',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'preset_query_params',
		$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$Radio$queryParamDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'disabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selected_label',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'selected',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'label_description',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'label',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'key',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Radio$Option)))))))));
var $author$project$Carwow$Search$Filters$Radio$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (options) {
				return $elm$json$Json$Decode$succeed(
					{bn: $elm$core$Maybe$Nothing, bE: 0, ag: _List_Nil, a4: $elm$core$Maybe$Nothing, o: options});
			},
			$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$Radio$optionDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$identity,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'format',
				$author$project$Carwow$Search$Filters$Radio$formatDecoder,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'operator',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'only',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'all',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'options',
								$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$Radio$optionDecoder),
								$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Radio$RadioParams)))))))
		]));
var $author$project$Carwow$Search$Filters$Select$AlwaysShow = 0;
var $author$project$Carwow$Search$Filters$Select$Legacy = 0;
var $author$project$Carwow$Search$Filters$Select$SelectParams = F7(
	function (options, all, syncMethod, only, preselectAvailableOptions, template, format) {
		return {bn: all, bE: format, ag: only, o: options, b_: preselectAvailableOptions, cg: syncMethod, ch: template};
	});
var $author$project$Carwow$Search$Filters$Select$Node = {$: 1};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$Carwow$Search$Filters$Select$calculateGroups = function (list) {
	return function (parentKeys) {
		return A2(
			$elm$core$List$map,
			function (opt) {
				return A2($elm$core$List$member, opt.u, parentKeys) ? _Utils_update(
					opt,
					{X: $author$project$Carwow$Search$Filters$Select$Node}) : opt;
			},
			list);
	}(
		$elm_community$list_extra$List$Extra$unique(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var rel = _v0.X;
					if (!rel.$) {
						var maybeParent = rel.a;
						return maybeParent;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				list)));
};
var $author$project$Carwow$Search$Filters$Select$Disable = 1;
var $author$project$Carwow$Search$Filters$Select$decodeSyncMethod = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		if (s === 'disable') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$Select$JsonApi = 1;
var $author$project$Carwow$Search$Filters$Select$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'json_api') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$Select$Leaf = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Search$Filters$Select$Option = F6(
	function (key, rel, label, selected, selectedLabel, disabled) {
		return {bB: disabled, u: key, d3: label, X: rel, ek: selected, el: selectedLabel};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Carwow$Search$Filters$Select$leafWithParentDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Carwow$Search$Filters$Select$Leaf,
	A2(
		$elm$json$Json$Decode$andThen,
		function (s) {
			return $elm$core$String$isEmpty(s) ? $elm$json$Json$Decode$fail('Select.Option.group_key cannot be empty') : $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(s));
		},
		$elm$json$Json$Decode$string));
var $author$project$Carwow$Search$Filters$Select$optionDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'disabled',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'selected_label',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selected',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'group_key',
					$author$project$Carwow$Search$Filters$Select$leafWithParentDecoder,
					$author$project$Carwow$Search$Filters$Select$Leaf($elm$core$Maybe$Nothing),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'key',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Select$Option)))))));
var $author$project$Carwow$Search$Filters$Select$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (options) {
				return $elm$json$Json$Decode$succeed(
					{bn: $elm$core$Maybe$Nothing, bE: 0, ag: _List_Nil, o: options, b_: $elm$core$Maybe$Nothing, cg: 0, ch: $elm$core$Maybe$Nothing});
			},
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Carwow$Search$Filters$Select$calculateGroups,
				$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$Select$optionDecoder))),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$identity,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'format',
				$author$project$Carwow$Search$Filters$Select$formatDecoder,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'template',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'preselect_available_options',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'only',
							$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'sync_method',
								$author$project$Carwow$Search$Filters$Select$decodeSyncMethod,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'all',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'options',
										A2(
											$elm$json$Json$Decode$map,
											$author$project$Carwow$Search$Filters$Select$calculateGroups,
											$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$Select$optionDecoder)),
										$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$Select$SelectParams)))))))))
		]));
var $author$project$Carwow$Search$Filters$SelectRanges$Legacy = 0;
var $author$project$Carwow$Search$Filters$SelectRanges$Params = F2(
	function (ranges, format) {
		return {bE: format, q: ranges};
	});
var $author$project$Carwow$Search$Filters$SelectRanges$JsonApi = 1;
var $author$project$Carwow$Search$Filters$SelectRanges$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'json_api') {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$SelectRanges$Range = F8(
	function (key, label, selected, minLabel, maxLabel, lowValue, highValue, options) {
		return {r: highValue, u: key, d3: label, s: lowValue, cO: maxLabel, cQ: minLabel, o: options, ek: selected};
	});
var $author$project$Carwow$Search$Filters$SelectRanges$Option = F2(
	function (value, label) {
		return {d3: label, g: value};
	});
var $author$project$Carwow$Search$Filters$SelectRanges$optionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$float,
		$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$SelectRanges$Option)));
var $author$project$Carwow$Search$Filters$SelectRanges$rangeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'options',
	$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$SelectRanges$optionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'high_value',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'low_value',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'max_label',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'min_label',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'selected',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'label',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'key',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$SelectRanges$Range)))))))));
var $author$project$Carwow$Search$Filters$SelectRanges$decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (ranges) {
				return $elm$json$Json$Decode$succeed(
					{bE: 0, q: ranges});
			},
			$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$SelectRanges$rangeDecoder)),
			A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$identity,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'format',
				$author$project$Carwow$Search$Filters$SelectRanges$formatDecoder,
				0,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ranges',
					$elm$json$Json$Decode$list($author$project$Carwow$Search$Filters$SelectRanges$rangeDecoder),
					$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$SelectRanges$Params))))
		]));
var $author$project$Carwow$Search$Filters$SingleSlider$SliderOptions = function (key) {
	return function (min) {
		return function (max) {
			return function (step) {
				return function (value) {
					return function (selected) {
						return function (format) {
							return function (unit) {
								return function (minLabel) {
									return function (maxLabel) {
										return function (reversed) {
											return function (changed) {
												return {bq: changed, bE: format, u: key, F: max, cO: maxLabel, G: min, cQ: minLabel, M: reversed, ek: selected, aG: step, ci: unit, g: value};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Carwow$Search$Filters$SingleSlider$Age = 2;
var $author$project$Carwow$Search$Filters$SingleSlider$Default = 0;
var $author$project$Carwow$Search$Filters$SingleSlider$UpTo = 1;
var $author$project$Carwow$Search$Filters$SingleSlider$formatDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'up_to':
				return $elm$json$Json$Decode$succeed(1);
			case 'age':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Carwow$Search$Filters$SingleSlider$sliderOptionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'reversed',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'max_label',
			$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'min_label',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'unit',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'format',
						$author$project$Carwow$Search$Filters$SingleSlider$formatDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'selected',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'value',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'step',
									$elm$json$Json$Decode$float,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'max',
										$elm$json$Json$Decode$float,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'min',
											$elm$json$Json$Decode$float,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'key',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Carwow$Search$Filters$SingleSlider$SliderOptions)))))))))))));
var $author$project$Carwow$Search$Filters$SingleSlider$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Carwow$Search$Filters$SingleSlider$sliderOptionsDecoder);
var $author$project$Carwow$StockSearch$StockDealsFilters$decoder = function (typeOf) {
	switch (typeOf) {
		case 'select':
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockSearch$StockDealsFilters$Select, $author$project$Carwow$Search$Filters$Select$decoder);
		case 'radio':
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockSearch$StockDealsFilters$Radio, $author$project$Carwow$Search$Filters$Radio$decoder);
		case 'double_slider':
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSlider, $author$project$Carwow$Search$Filters$DoubleSlider$decoder);
		case 'single_slider':
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockSearch$StockDealsFilters$SingleSlider, $author$project$Carwow$Search$Filters$SingleSlider$decoder);
		case 'select_ranges':
			return A2($elm$json$Json$Decode$map, $author$project$Carwow$StockSearch$StockDealsFilters$SelectRanges, $author$project$Carwow$Search$Filters$SelectRanges$decoder);
		default:
			return $elm$json$Json$Decode$fail('Invalid type: ' + typeOf);
	}
};
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Carwow$Search$Filters$SelectRanges$maximumValueOption = function (options) {
	return A2(
		$elm_community$list_extra$List$Extra$maximumBy,
		function ($) {
			return $.g;
		},
		options);
};
var $author$project$Carwow$Search$Filters$SelectRanges$highValueIsMax = function (range) {
	var _v0 = $author$project$Carwow$Search$Filters$SelectRanges$maximumValueOption(range.o);
	if (!_v0.$) {
		var o = _v0.a;
		return _Utils_eq(range.r, o.g);
	} else {
		return false;
	}
};
var $author$project$Carwow$Search$Filters$SelectRanges$lowValueIsMin = function (range) {
	var _v0 = $elm$core$List$head(range.o);
	if (!_v0.$) {
		var o = _v0.a;
		return _Utils_eq(range.s, o.g);
	} else {
		return false;
	}
};
var $author$project$Carwow$Search$Filters$SelectRanges$selectedRange = function (_v0) {
	var ranges = _v0.q;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.ek;
			},
			ranges));
};
var $author$project$Carwow$Search$Filters$SelectRanges$displayedSelectedValues = function (ranges) {
	var _v0 = $author$project$Carwow$Search$Filters$SelectRanges$selectedRange(ranges);
	if (!_v0.$) {
		var range = _v0.a;
		if ($author$project$Carwow$Search$Filters$SelectRanges$lowValueIsMin(range) && $author$project$Carwow$Search$Filters$SelectRanges$highValueIsMax(range)) {
			return _List_Nil;
		} else {
			var selectedLowValue = $elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.d3;
					},
					A2(
						$elm$core$List$filter,
						function (o) {
							return _Utils_eq(o.g, range.s);
						},
						range.o)));
			var selectedHighValue = $elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.d3;
					},
					A2(
						$elm$core$List$filter,
						function (o) {
							return _Utils_eq(o.g, range.r);
						},
						range.o)));
			var values = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[selectedLowValue, selectedHighValue]));
			return _List_fromArray(
				[
					A2($elm$core$String$join, ' - ', values)
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Search$Filters$DoubleSlider$selectedValues = function (_v0) {
	var slider = _v0;
	if (slider.ek) {
		var model = $author$project$Carwow$Search$Filters$DoubleSlider$toSliderModel(slider);
		return $elm$core$List$singleton(
			A4(model.aS, model.s, model.r, 0, 0));
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Search$Filters$Radio$selectedValues = function (_v0) {
	var options = _v0.o;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.el;
		},
		A2(
			$elm$core$List$filter,
			function (option) {
				return option.ek && (!$elm$core$String$isEmpty(option.u));
			},
			options));
};
var $author$project$Carwow$Search$Filters$Select$selectedOptions = function (options) {
	return A2(
		$elm$core$List$filter,
		function ($) {
			return $.ek;
		},
		A2(
			$elm$core$List$filter,
			function (o) {
				return o.u !== 'All';
			},
			options));
};
var $author$project$Carwow$Search$Filters$Select$selectedValues = function (_v0) {
	var options = _v0.o;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.el;
		},
		$author$project$Carwow$Search$Filters$Select$selectedOptions(options));
};
var $author$project$Carwow$Search$Filters$SingleSlider$formatter = function (slider) {
	var model = $author$project$Carwow$Search$Filters$SingleSlider$toSliderModel(slider);
	return A2(model.aT, model.g, model.F);
};
var $author$project$Carwow$Search$Filters$SingleSlider$selectedValues = function (_v0) {
	var slider = _v0;
	return slider.ek ? $elm$core$List$singleton(
		$author$project$Carwow$Search$Filters$SingleSlider$formatter(slider)) : _List_Nil;
};
var $author$project$Carwow$StockSearch$StockDealsFilters$displayedSelectedValues = function (filter) {
	switch (filter.$) {
		case 0:
			var select = filter.a;
			return $author$project$Carwow$Search$Filters$Select$selectedValues(select);
		case 2:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$DoubleSlider$selectedValues(slider);
		case 3:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$SingleSlider$selectedValues(slider);
		case 1:
			var radio = filter.a;
			return $author$project$Carwow$Search$Filters$Radio$selectedValues(radio);
		default:
			var ranges = filter.a;
			return $author$project$Carwow$Search$Filters$SelectRanges$displayedSelectedValues(ranges);
	}
};
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$encoder = F2(
	function (filterKey, _v0) {
		var slider = _v0;
		return $elm$core$List$singleton(
			A2(
				$elm$url$Url$Builder$string,
				filterKey,
				$elm$core$String$fromFloat(slider.s) + (',' + $elm$core$String$fromFloat(slider.r))));
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $author$project$Carwow$Search$Filters$Radio$optionEncoder = F3(
	function (filterKey, operator, option) {
		if ($elm$core$List$isEmpty(option.aC)) {
			var queryParamKey = function () {
				if (!operator.$) {
					var o = operator.a;
					return filterKey + ('[' + (o + ']'));
				} else {
					return filterKey;
				}
			}();
			return $elm$core$List$singleton(
				A2($elm$url$Url$Builder$string, queryParamKey, option.u));
		} else {
			return A2(
				$elm$core$List$map,
				function (qp) {
					return A2($elm$url$Url$Builder$string, qp.u, qp.g);
				},
				option.aC);
		}
	});
var $author$project$Carwow$Search$Filters$Radio$encoder = F2(
	function (filterKey, _v0) {
		var options = _v0.o;
		var operator = _v0.a4;
		var format = _v0.bE;
		var key = function () {
			if (format === 1) {
				return 'filter[' + (filterKey + ']');
			} else {
				return filterKey;
			}
		}();
		return A2(
			$elm$core$List$concatMap,
			A2($author$project$Carwow$Search$Filters$Radio$optionEncoder, key, operator),
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.ek;
				},
				options));
	});
var $author$project$Carwow$Search$Filters$Select$optionEncoder = function (option) {
	var _v0 = option.X;
	if (!_v0.$) {
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return option.u;
		} else {
			var groupKey = _v0.a.a;
			return groupKey + ('|' + option.u);
		}
	} else {
		return option.u + '|any';
	}
};
var $author$project$Carwow$Search$Filters$Select$encoder = F2(
	function (filterKey, _v0) {
		var options = _v0.o;
		var format = _v0.bE;
		var key = function () {
			if (format === 1) {
				return 'filter[' + (filterKey + ']');
			} else {
				return filterKey;
			}
		}();
		return $elm$core$List$singleton(
			A2(
				$elm$url$Url$Builder$string,
				key,
				A2(
					$elm$core$String$join,
					',',
					A2(
						$elm$core$List$map,
						$author$project$Carwow$Search$Filters$Select$optionEncoder,
						$author$project$Carwow$Search$Filters$Select$selectedOptions(options)))));
	});
var $author$project$Carwow$Search$Filters$SelectRanges$optionEncoder = F2(
	function (sendKey, range) {
		var values = sendKey ? _List_fromArray(
			[range.u]) : _List_Nil;
		return A2(
			$elm$core$String$join,
			',',
			_Utils_ap(
				values,
				_List_fromArray(
					[
						$elm$core$String$fromFloat(range.s),
						$elm$core$String$fromFloat(range.r)
					])));
	});
var $author$project$Carwow$Search$Filters$SelectRanges$encoder = F2(
	function (filterKey, _v0) {
		var ranges = _v0.q;
		var format = _v0.bE;
		if (format === 1) {
			return A2(
				$elm$core$List$concatMap,
				function (range) {
					var rangeParams = _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'filter[' + (filterKey + '_type]'), range.u)
						]);
					var rangeParamsWithLowValue = (!$author$project$Carwow$Search$Filters$SelectRanges$lowValueIsMin(range)) ? A2(
						$elm$core$List$append,
						rangeParams,
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'filter[' + (filterKey + '][gte]'),
								$elm$core$String$fromFloat(range.s))
							])) : rangeParams;
					var rangeParamsWithHighValue = (!$author$project$Carwow$Search$Filters$SelectRanges$highValueIsMax(range)) ? A2(
						$elm$core$List$append,
						rangeParamsWithLowValue,
						_List_fromArray(
							[
								A2(
								$elm$url$Url$Builder$string,
								'filter[' + (filterKey + '][lte]'),
								$elm$core$String$fromFloat(range.r))
							])) : rangeParamsWithLowValue;
					return rangeParamsWithHighValue;
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.ek;
					},
					ranges));
		} else {
			return $elm$core$List$singleton(
				A2(
					$elm$url$Url$Builder$string,
					filterKey,
					A2(
						$elm$core$String$join,
						',',
						A2(
							$elm$core$List$map,
							$author$project$Carwow$Search$Filters$SelectRanges$optionEncoder(
								$elm$core$List$length(ranges) > 1),
							A2(
								$elm$core$List$filter,
								function ($) {
									return $.ek;
								},
								ranges)))));
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$encoder = F2(
	function (filterKey, _v0) {
		var slider = _v0;
		return $elm$core$List$singleton(
			A2(
				$elm$url$Url$Builder$string,
				filterKey,
				$elm$core$String$fromFloat(slider.g)));
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$encoder = F2(
	function (filterKey, filter) {
		switch (filter.$) {
			case 0:
				var select = filter.a;
				return A2($author$project$Carwow$Search$Filters$Select$encoder, filterKey, select);
			case 1:
				var radio = filter.a;
				return A2($author$project$Carwow$Search$Filters$Radio$encoder, filterKey, radio);
			case 2:
				var slider = filter.a;
				return A2($author$project$Carwow$Search$Filters$DoubleSlider$encoder, filterKey, slider);
			case 3:
				var slider = filter.a;
				return A2($author$project$Carwow$Search$Filters$SingleSlider$encoder, filterKey, slider);
			default:
				var ranges = filter.a;
				return A2($author$project$Carwow$Search$Filters$SelectRanges$encoder, filterKey, ranges);
		}
	});
var $author$project$Carwow$Search$Filters$init = function (config) {
	return {as: config.as, av: config.av, x: config.x, aw: config.aw, a: $elm$core$Dict$empty, aB: config.aB, aD: config.aD, ek: config.ek, aF: config.aF, aH: config.aH, ab: config.ab};
};
var $author$project$Carwow$Search$Filters$DoubleSlider$displayedSelectedValues = function (_v0) {
	var slider = _v0;
	if (slider.ek) {
		var model = $author$project$Carwow$Search$Filters$DoubleSlider$toSliderModel(slider);
		return (_Utils_eq(model.s, model.G) && _Utils_eq(model.r, model.F)) ? _List_Nil : $elm$core$List$singleton(
			A4(model.aS, model.s, model.r, 0, 0));
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Search$Filters$DoubleSlider$valueInRange = F2(
	function (slider, value) {
		return (_Utils_cmp(value, slider.s) > -1) && (_Utils_cmp(value, slider.r) < 1);
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$matches = F2(
	function (doubleSlider, values) {
		var _v0 = doubleSlider;
		var sliderOption = _v0;
		return A2(
			$elm$core$List$map,
			function (v) {
				return {
					d3: A2(
						$elm$core$String$join,
						',',
						$author$project$Carwow$Search$Filters$DoubleSlider$displayedSelectedValues(doubleSlider)),
					d4: A2(
						$author$project$Carwow$Search$Filters$DoubleSlider$valueInRange,
						sliderOption,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(v))),
					el: A2(
						$elm$core$String$join,
						',',
						$author$project$Carwow$Search$Filters$DoubleSlider$displayedSelectedValues(doubleSlider)),
					eE: _List_fromArray(
						[v])
				};
			},
			values);
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Carwow$Search$Filters$Radio$matches = F2(
	function (_v0, keys) {
		var options = _v0.o;
		var operator = _v0.a4;
		if (!operator.$) {
			var o = operator.a;
			var numericKeys = A2($elm$core$List$filterMap, $elm$core$String$toFloat, keys);
			var compareFunc = F2(
				function (a, b) {
					return (o === 'gte') ? (_Utils_cmp(a, b) > -1) : (_Utils_cmp(a, b) < 1);
				});
			return A2(
				$elm$core$List$map,
				function (option) {
					return {
						d3: option.d3,
						d4: (!$elm$core$List$isEmpty(keys)) && A2(
							$elm$core$List$all,
							function (k) {
								return A2(
									compareFunc,
									k,
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(option.u)));
							},
							numericKeys),
						el: option.el,
						eE: keys
					};
				},
				A2(
					$elm$core$List$filter,
					function (option) {
						return option.ek;
					},
					options));
		} else {
			return A2(
				$elm$core$List$map,
				function (option) {
					return {
						d3: option.d3,
						d4: A2($elm$core$List$member, option.u, keys),
						el: option.el,
						eE: keys
					};
				},
				A2(
					$elm$core$List$filter,
					function (option) {
						return option.ek;
					},
					options));
		}
	});
var $elm$core$String$toLower = _String_toLower;
var $author$project$Carwow$Search$Filters$Select$matches = F2(
	function (_v0, keys) {
		var options = _v0.o;
		var matchingOptions = A2($elm$core$List$member, 'All', keys) ? options : A2(
			$elm$core$List$filter,
			function (option) {
				return option.ek;
			},
			options);
		return A2(
			$elm$core$List$map,
			function (option) {
				return {
					d3: option.d3,
					d4: A2(
						$elm$core$List$member,
						$elm$core$String$toLower(option.u),
						A2(
							$elm$core$List$map,
							function (key) {
								return $elm$core$String$toLower(key);
							},
							keys)),
					el: option.el,
					eE: keys
				};
			},
			matchingOptions);
	});
var $author$project$Carwow$Search$Filters$SelectRanges$valueInRange = F2(
	function (range, value) {
		return (_Utils_cmp(value, range.s) > -1) && (_Utils_cmp(value, range.r) < 1);
	});
var $author$project$Carwow$Search$Filters$SelectRanges$matches = F2(
	function (ranges, values) {
		var label = A2(
			$elm$core$String$join,
			',',
			$author$project$Carwow$Search$Filters$SelectRanges$displayedSelectedValues(ranges));
		var _v0 = $author$project$Carwow$Search$Filters$SelectRanges$selectedRange(ranges);
		if (!_v0.$) {
			var range = _v0.a;
			return A2(
				$elm$core$List$map,
				function (v) {
					return {
						d3: label,
						d4: A2(
							$author$project$Carwow$Search$Filters$SelectRanges$valueInRange,
							range,
							A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toFloat(v))),
						el: label,
						eE: values
					};
				},
				values);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Carwow$Search$Filters$SingleSlider$valueInRange = F2(
	function (slider, value) {
		return slider.M ? (_Utils_cmp(value, slider.g) > -1) : (_Utils_cmp(value, slider.g) < 1);
	});
var $author$project$Carwow$Search$Filters$SingleSlider$matches = F2(
	function (_v0, values) {
		var singleSlider = _v0;
		return A2(
			$elm$core$List$map,
			function (v) {
				return {
					d3: $author$project$Carwow$Search$Filters$SingleSlider$formatter(singleSlider),
					d4: A2(
						$author$project$Carwow$Search$Filters$SingleSlider$valueInRange,
						singleSlider,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(v))),
					el: $author$project$Carwow$Search$Filters$SingleSlider$formatter(singleSlider),
					eE: _List_fromArray(
						[v])
				};
			},
			values);
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$matches = F2(
	function (filter, values) {
		switch (filter.$) {
			case 0:
				var select = filter.a;
				return A2($author$project$Carwow$Search$Filters$Select$matches, select, values);
			case 2:
				var slider = filter.a;
				return A2($author$project$Carwow$Search$Filters$DoubleSlider$matches, slider, values);
			case 3:
				var slider = filter.a;
				return A2($author$project$Carwow$Search$Filters$SingleSlider$matches, slider, values);
			case 1:
				var radio = filter.a;
				return A2($author$project$Carwow$Search$Filters$Radio$matches, radio, values);
			default:
				var ranges = filter.a;
				return A2($author$project$Carwow$Search$Filters$SelectRanges$matches, ranges, values);
		}
	});
var $author$project$Carwow$Search$Filters$DoubleSlider$reset = function (_v0) {
	var doubleSlider = _v0;
	return _Utils_update(
		doubleSlider,
		{r: doubleSlider.F, s: doubleSlider.G, ek: false});
};
var $author$project$Carwow$Search$Filters$Radio$reset = function (_v0) {
	var radio = _v0;
	return function (opts) {
		return _Utils_update(
			radio,
			{o: opts});
	}(
		A2(
			$elm$core$List$map,
			function (option) {
				return _Utils_update(
					option,
					{ek: false});
			},
			radio.o));
};
var $author$project$Carwow$Search$Filters$Select$reset = function (_v0) {
	var select = _v0;
	return function (opts) {
		return _Utils_update(
			select,
			{o: opts});
	}(
		A2(
			$elm$core$List$map,
			function (option) {
				return _Utils_update(
					option,
					{ek: false});
			},
			select.o));
};
var $author$project$Carwow$Search$Filters$SelectRanges$reset = function (_v0) {
	var params = _v0;
	var getLowestValue = F2(
		function (defaultValue, options) {
			var _v2 = $elm$core$List$head(options);
			if (!_v2.$) {
				var option = _v2.a;
				return option.g;
			} else {
				return defaultValue;
			}
		});
	var getHighestValue = F2(
		function (defaultValue, options) {
			var _v1 = $author$project$Carwow$Search$Filters$SelectRanges$maximumValueOption(options);
			if (!_v1.$) {
				var option = _v1.a;
				return option.g;
			} else {
				return defaultValue;
			}
		});
	return _Utils_update(
		params,
		{
			q: A2(
				$elm$core$List$indexedMap,
				function (index) {
					return function (range) {
						return _Utils_update(
							range,
							{
								r: A2(getHighestValue, range.r, range.o),
								s: A2(getLowestValue, range.s, range.o),
								ek: !index
							});
					};
				},
				params.q)
		});
};
var $author$project$Carwow$Search$Filters$SingleSlider$reset = function (_v0) {
	var singleSlider = _v0;
	return _Utils_update(
		singleSlider,
		{ek: false, g: singleSlider.F});
};
var $author$project$Carwow$StockSearch$StockDealsFilters$resetValue = function (filter) {
	switch (filter.$) {
		case 3:
			var singleSlider = filter.a;
			return $author$project$Carwow$StockSearch$StockDealsFilters$SingleSlider(
				$author$project$Carwow$Search$Filters$SingleSlider$reset(singleSlider));
		case 2:
			var doubleSlider = filter.a;
			return $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSlider(
				$author$project$Carwow$Search$Filters$DoubleSlider$reset(doubleSlider));
		case 0:
			var select = filter.a;
			return $author$project$Carwow$StockSearch$StockDealsFilters$Select(
				$author$project$Carwow$Search$Filters$Select$reset(select));
		case 1:
			var radio = filter.a;
			return $author$project$Carwow$StockSearch$StockDealsFilters$Radio(
				$author$project$Carwow$Search$Filters$Radio$reset(radio));
		default:
			var ranges = filter.a;
			return $author$project$Carwow$StockSearch$StockDealsFilters$SelectRanges(
				$author$project$Carwow$Search$Filters$SelectRanges$reset(ranges));
	}
};
var $author$project$Carwow$Search$Filters$DoubleSlider$selectedKeyValues = $author$project$Carwow$Search$Filters$DoubleSlider$selectedValues;
var $author$project$Carwow$Search$Filters$Radio$selectedKeyValues = function (_v0) {
	var options = _v0.o;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.u;
		},
		A2(
			$elm$core$List$filter,
			function (option) {
				return option.ek && (!$elm$core$String$isEmpty(option.u));
			},
			options));
};
var $author$project$Carwow$Search$Filters$Select$selectedKeyValues = function (_v0) {
	var options = _v0.o;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.u;
		},
		$author$project$Carwow$Search$Filters$Select$selectedOptions(options));
};
var $author$project$Carwow$Search$Filters$SelectRanges$selectedKeyValues = function (_v0) {
	var ranges = _v0.q;
	return $elm$core$List$singleton(
		A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				$author$project$Carwow$Search$Filters$SelectRanges$optionEncoder(
					$elm$core$List$length(ranges) > 1),
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.ek;
					},
					ranges))));
};
var $author$project$Carwow$Search$Filters$SingleSlider$selectedKeyValues = $author$project$Carwow$Search$Filters$SingleSlider$selectedValues;
var $author$project$Carwow$StockSearch$StockDealsFilters$selectedKeyValues = function (filter) {
	switch (filter.$) {
		case 0:
			var select = filter.a;
			return $author$project$Carwow$Search$Filters$Select$selectedKeyValues(select);
		case 2:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$DoubleSlider$selectedKeyValues(slider);
		case 3:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$SingleSlider$selectedKeyValues(slider);
		case 1:
			var radio = filter.a;
			return $author$project$Carwow$Search$Filters$Radio$selectedKeyValues(radio);
		default:
			var ranges = filter.a;
			return $author$project$Carwow$Search$Filters$SelectRanges$selectedKeyValues(ranges);
	}
};
var $author$project$Carwow$Search$Filters$SelectRanges$selectedValues = function (_v0) {
	var ranges = _v0.q;
	return A2(
		$elm$core$List$concatMap,
		function (range) {
			return ($author$project$Carwow$Search$Filters$SelectRanges$lowValueIsMin(range) && $author$project$Carwow$Search$Filters$SelectRanges$highValueIsMax(range)) ? _List_fromArray(
				[range.d3]) : _List_fromArray(
				[
					range.d3,
					'Min: ' + $elm$core$String$fromFloat(range.s),
					'Max: ' + $elm$core$String$fromFloat(range.r)
				]);
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.ek;
			},
			ranges));
};
var $author$project$Carwow$StockSearch$StockDealsFilters$selectedValues = function (filter) {
	switch (filter.$) {
		case 0:
			var select = filter.a;
			return $author$project$Carwow$Search$Filters$Select$selectedValues(select);
		case 2:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$DoubleSlider$selectedValues(slider);
		case 3:
			var slider = filter.a;
			return $author$project$Carwow$Search$Filters$SingleSlider$selectedValues(slider);
		case 1:
			var radio = filter.a;
			return $author$project$Carwow$Search$Filters$Radio$selectedValues(radio);
		default:
			var ranges = filter.a;
			return $author$project$Carwow$Search$Filters$SelectRanges$selectedValues(ranges);
	}
};
var $author$project$Carwow$Search$Filters$DoubleSlider$sync = F2(
	function (_v0, _v1) {
		var doubleSlider = _v1;
		return doubleSlider;
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Carwow$Search$Filters$Radio$sync = F2(
	function (filterOptions, _v0) {
		var radio = _v0;
		var values = function () {
			var v = filterOptions;
			return v;
		}();
		var optionsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (o) {
					return _Utils_Tuple2(o.u, o);
				},
				radio.o));
		var filteredValues = $elm$core$List$isEmpty(radio.ag) ? values : A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v3) {
					return A2($elm$core$List$member, k, radio.ag);
				}),
			values);
		var valuesAsOptionsDict = A2(
			$elm$core$Dict$map,
			F2(
				function (k, v) {
					return {at: $elm$core$Maybe$Nothing, bB: false, u: k, d3: v.d3, az: $elm$core$Maybe$Nothing, aC: _List_Nil, ek: v.ek, el: v.d3};
				}),
			filteredValues);
		var newOptions = A6(
			$elm$core$Dict$merge,
			F2(
				function (key, _v1) {
					return $elm$core$Dict$remove(key);
				}),
			F3(
				function (key, a, _v2) {
					return A2($elm$core$Dict$insert, key, a);
				}),
			$elm$core$Dict$insert,
			optionsDict,
			valuesAsOptionsDict,
			$elm$core$Dict$empty);
		return function (options) {
			return _Utils_update(
				radio,
				{o: options});
		}(
			$elm$core$Dict$values(newOptions));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Carwow$Search$Filters$Select$sync = F2(
	function (filterOptions, _v0) {
		var select = _v0;
		var values = function () {
			var v = filterOptions;
			return v;
		}();
		var optionsDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (o) {
					return _Utils_Tuple2(o.u, o);
				},
				select.o));
		var filteredValues = $elm$core$List$isEmpty(select.ag) ? values : A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v6) {
					return A2($elm$core$List$member, k, select.ag);
				}),
			values);
		var valuesAsOptionsDict = A2(
			$elm$core$Dict$map,
			F2(
				function (k, v) {
					var disabled = function () {
						var _v5 = select.cg;
						if (_v5 === 1) {
							return (!v.eh) && (!v.ek);
						} else {
							return false;
						}
					}();
					return {
						bB: disabled,
						u: k,
						d3: v.d3,
						X: $author$project$Carwow$Search$Filters$Select$Leaf($elm$core$Maybe$Nothing),
						ek: v.ek,
						el: v.d3
					};
				}),
			filteredValues);
		var valuesWithPreselections = function () {
			var _v2 = select.b_;
			if (!_v2.$) {
				var n = _v2.a;
				return A2(
					$elm$core$Dict$map,
					F2(
						function (_v3, value) {
							return ((_Utils_cmp(
								$elm$core$Dict$size(
									A2(
										$elm$core$Dict$filter,
										F2(
											function (_v4, v) {
												return !v.bB;
											}),
										valuesAsOptionsDict)),
								n) < 1) && (!value.bB)) ? _Utils_update(
								value,
								{ek: true}) : value;
						}),
					valuesAsOptionsDict);
			} else {
				return valuesAsOptionsDict;
			}
		}();
		var newOptions = A6(
			$elm$core$Dict$merge,
			F2(
				function (key, _v1) {
					return $elm$core$Dict$remove(key);
				}),
			F3(
				function (key, a, b) {
					return A2(
						$elm$core$Dict$insert,
						key,
						_Utils_update(
							a,
							{bB: b.bB && (!a.ek)}));
				}),
			$elm$core$Dict$insert,
			optionsDict,
			valuesWithPreselections,
			$elm$core$Dict$empty);
		return function (options) {
			return _Utils_update(
				select,
				{o: options});
		}(
			$elm$core$Dict$values(newOptions));
	});
var $author$project$Carwow$Search$Filters$SelectRanges$sync = F2(
	function (_v0, _v1) {
		var ranges = _v1;
		return ranges;
	});
var $author$project$Carwow$Search$Filters$SingleSlider$sync = F2(
	function (_v0, _v1) {
		var singleSlider = _v1;
		return singleSlider;
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$sync = F2(
	function (values, filter) {
		switch (filter.$) {
			case 3:
				var singleSlider = filter.a;
				return $author$project$Carwow$StockSearch$StockDealsFilters$SingleSlider(
					A2($author$project$Carwow$Search$Filters$SingleSlider$sync, values, singleSlider));
			case 2:
				var doubleSlider = filter.a;
				return $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSlider(
					A2($author$project$Carwow$Search$Filters$DoubleSlider$sync, values, doubleSlider));
			case 0:
				var select = filter.a;
				return $author$project$Carwow$StockSearch$StockDealsFilters$Select(
					A2($author$project$Carwow$Search$Filters$Select$sync, values, select));
			case 1:
				var radio = filter.a;
				return $author$project$Carwow$StockSearch$StockDealsFilters$Radio(
					A2($author$project$Carwow$Search$Filters$Radio$sync, values, radio));
			default:
				var ranges = filter.a;
				return $author$project$Carwow$StockSearch$StockDealsFilters$SelectRanges(
					A2($author$project$Carwow$Search$Filters$SelectRanges$sync, values, ranges));
		}
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSliderChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$SelectOption = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$SelectRange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$SingleSliderChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Carwow$StockSearch$StockDealsFilters$ToggleOption = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $carwow$elm_slider_old$DoubleSliderOld$HighValue = 1;
var $carwow$elm_slider_old$DoubleSliderOld$LowValue = 0;
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $carwow$elm_slider_old$DoubleSliderOld$formatCurrentRange = function (model) {
	return (_Utils_eq(model.s, model.G) && _Utils_eq(model.r, model.F)) ? '' : A4(model.aS, model.s, model.r, model.G, model.F);
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $carwow$elm_slider_old$DoubleSliderOld$TrackClicked = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$debois$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($debois$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$debois$elm_dom$DOM$scrollLeft,
				$debois$elm_dom$DOM$scrollTop,
				$debois$elm_dom$DOM$offsetLeft,
				$debois$elm_dom$DOM$offsetTop));
	});
var $debois$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {cF: height, a$: x, dq: y, bk: width};
		}),
	A2($debois$elm_dom$DOM$position, 0, 0),
	$debois$elm_dom$DOM$offsetWidth,
	$debois$elm_dom$DOM$offsetHeight);
var $carwow$elm_slider_old$DoubleSliderOld$onInsideRangeClick = function (model) {
	var valueTypeDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var centerThreshold = rectangle.bk / 2;
				var valueType = (_Utils_cmp(mouseX, centerThreshold) < 0) ? 0 : 1;
				return valueType;
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	var valueDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var newValue = A2($carwow$elm_slider_old$DoubleSliderOld$snapValue, (((model.r - model.s) / rectangle.bk) * mouseX) + model.s, model.aG);
				return $elm$core$String$fromInt(
					$elm$core$Basics$round(newValue));
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	return A3($elm$json$Json$Decode$map2, $carwow$elm_slider_old$DoubleSliderOld$TrackClicked, valueTypeDecoder, valueDecoder);
};
var $carwow$elm_slider_old$DoubleSliderOld$onOutsideRangeClick = function (model) {
	var valueTypeDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var newValue = A2($carwow$elm_slider_old$DoubleSliderOld$snapValue, (model.F / rectangle.bk) * mouseX, model.aG);
				var valueType = (_Utils_cmp(newValue, model.s) < 0) ? 0 : 1;
				return valueType;
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	var valueDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var newValue = (((model.F - model.G) / rectangle.bk) * mouseX) + model.G;
				return $elm$core$String$fromInt(
					$elm$core$Basics$round(newValue));
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	return A3($elm$json$Json$Decode$map2, $carwow$elm_slider_old$DoubleSliderOld$TrackClicked, valueTypeDecoder, valueDecoder);
};
var $carwow$elm_slider_old$DoubleSliderOld$RangeChanged = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $carwow$elm_slider_old$DoubleSliderOld$onRangeChange = F2(
	function (valueType, shouldFetchModels) {
		return A4(
			$elm$json$Json$Decode$map3,
			$carwow$elm_slider_old$DoubleSliderOld$RangeChanged,
			$elm$json$Json$Decode$succeed(valueType),
			$elm$html$Html$Events$targetValue,
			$elm$json$Json$Decode$succeed(shouldFetchModels));
	});
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $carwow$elm_slider_old$DoubleSliderOld$view = function (model) {
	var progressRatio = 100 / (model.F - model.G);
	var progressLow = $elm$core$String$fromFloat((model.s - model.G) * progressRatio) + '%';
	var progressHigh = $elm$core$String$fromFloat((model.F - model.r) * progressRatio) + '%';
	var lowValue = $elm$core$Basics$round(model.s);
	var highValue = $elm$core$Basics$round(model.r);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-range-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min(
								$elm$core$String$fromFloat(model.G)),
								$elm$html$Html$Attributes$max(
								$elm$core$String$fromFloat(model.F)),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromFloat(model.s)),
								$elm$html$Html$Attributes$step(
								$elm$core$String$fromInt(model.aG)),
								$elm$html$Html$Attributes$class('input-range input-range--first'),
								A2(
								$elm$html$Html$Events$on,
								'change',
								A2($carwow$elm_slider_old$DoubleSliderOld$onRangeChange, 0, true)),
								A2(
								$elm$html$Html$Events$on,
								'input',
								A2($carwow$elm_slider_old$DoubleSliderOld$onRangeChange, 0, false))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min(
								$elm$core$String$fromFloat(model.G)),
								$elm$html$Html$Attributes$max(
								$elm$core$String$fromFloat(model.F)),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromFloat(model.r)),
								$elm$html$Html$Attributes$step(
								$elm$core$String$fromInt(model.aG)),
								$elm$html$Html$Attributes$class('input-range input-range--second'),
								A2(
								$elm$html$Html$Events$on,
								'change',
								A2($carwow$elm_slider_old$DoubleSliderOld$onRangeChange, 1, true)),
								A2(
								$elm$html$Html$Events$on,
								'input',
								A2($carwow$elm_slider_old$DoubleSliderOld$onRangeChange, 1, false))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range__track'),
								A2(
								$elm$html$Html$Events$on,
								'click',
								$carwow$elm_slider_old$DoubleSliderOld$onOutsideRangeClick(model))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range__progress'),
								A2($elm$html$Html$Attributes$style, 'left', progressLow),
								A2($elm$html$Html$Attributes$style, 'right', progressHigh),
								A2(
								$elm$html$Html$Events$on,
								'click',
								$carwow$elm_slider_old$DoubleSliderOld$onInsideRangeClick(model))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-range-labels-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.cP(model.G))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label input-range-label--current-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$carwow$elm_slider_old$DoubleSliderOld$formatCurrentRange(model))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.cN(model.F))
							]))
					]))
			]));
};
var $author$project$Carwow$Search$Filters$DoubleSlider$view = F3(
	function (_v0, msg, _v1) {
		var slider = _v1;
		var model = $author$project$Carwow$Search$Filters$DoubleSlider$toSliderModel(slider);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					msg,
					$carwow$elm_slider_old$DoubleSliderOld$view(model))
				]));
	});
var $author$project$Carwow$Search$Filters$Radio$allOption = F2(
	function (all, selected) {
		if (!all.$) {
			var s = all.a;
			return _List_fromArray(
				[
					{at: $elm$core$Maybe$Nothing, bB: false, u: 'all', d3: s, az: $elm$core$Maybe$Nothing, aC: _List_Nil, ek: selected, el: s}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Carwow$Search$Filters$Radio$optionsToDisplay = function (_v0) {
	var radio = _v0;
	var optionsList = $elm$core$List$isEmpty(radio.ag) ? radio.o : A2(
		$elm$core$List$concatMap,
		function (k) {
			return A2(
				$elm$core$List$filter,
				function (o) {
					return _Utils_eq(o.u, k);
				},
				radio.o);
		},
		radio.ag);
	return _Utils_ap(
		A2(
			$author$project$Carwow$Search$Filters$Radio$allOption,
			radio.bn,
			!A2(
				$elm$core$List$any,
				function ($) {
					return $.ek;
				},
				radio.o)),
		optionsList);
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Carwow$Search$Filters$Radio$viewOption = F3(
	function (filterKey, msg, option) {
		var inputId = filterKey + ('__' + option.u);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('search-filter-select__list-item', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'radio--with-badge',
									!_Utils_eq(option.at, $elm$core$Maybe$Nothing))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(inputId),
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$value(option.u),
									$elm$html$Html$Attributes$checked(option.ek),
									$elm$html$Html$Events$onClick(
									msg(option.u))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(inputId)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(option.d3)
								])),
							function () {
							var _v0 = option.at;
							if (!_v0.$) {
								var badgeText = _v0.a;
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('badge badge--small badge-notification')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(badgeText)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					function () {
					var _v1 = option.az;
					if (!_v1.$) {
						var d = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('search-filter__radio-label-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(d)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Carwow$Search$Filters$Radio$view = F3(
	function (filterKey, msg, radio) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-unstyled search-filter-select__list')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Carwow$Search$Filters$Radio$viewOption, filterKey, msg),
				$author$project$Carwow$Search$Filters$Radio$optionsToDisplay(radio)));
	});
var $author$project$Carwow$Search$Filters$Select$allOption = F2(
	function (all, selected) {
		if (!all.$) {
			var s = all.a;
			return _List_fromArray(
				[
					{
					bB: false,
					u: 'All',
					d3: s,
					X: $author$project$Carwow$Search$Filters$Select$Leaf($elm$core$Maybe$Nothing),
					ek: selected,
					el: s
				}
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Carwow$Search$Filters$Select$optionsToDisplay = function (_v0) {
	var select = _v0;
	var optionsList = $elm$core$List$isEmpty(select.ag) ? select.o : A2(
		$elm$core$List$concatMap,
		function (k) {
			return A2(
				$elm$core$List$filter,
				function (o) {
					return _Utils_eq(o.u, k);
				},
				select.o);
		},
		select.ag);
	return _Utils_ap(
		A2(
			$author$project$Carwow$Search$Filters$Select$allOption,
			select.bn,
			!A2(
				$elm$core$List$any,
				function ($) {
					return $.ek;
				},
				select.o)),
		optionsList);
};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Carwow$Search$Filters$Select$viewOption = F3(
	function (filterKey, msg, option) {
		var inputId = filterKey + ('__' + option.u);
		var optionLi = function (opt) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-filter-select__list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('checkbox')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(inputId),
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$value(opt.u),
										$elm$html$Html$Attributes$checked(opt.ek),
										$elm$html$Html$Attributes$disabled(opt.bB),
										$elm$html$Html$Events$onClick(
										msg(opt.u))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$for(inputId)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(opt.d3)
									]))
							]))
					]));
		};
		var _v0 = option.X;
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('search-filter-select__list-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('search-filter-select__list-group-heading')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(option.d3)
								]))
						])),
					optionLi(
					_Utils_update(
						option,
						{d3: 'Any'}))
				]);
		} else {
			return _List_fromArray(
				[
					optionLi(option)
				]);
		}
	});
var $author$project$Carwow$Search$Filters$Select$view = F3(
	function (filterKey, msg, select) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-unstyled search-filter-select__list')
				]),
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					A2($author$project$Carwow$Search$Filters$Select$viewOption, filterKey, msg),
					$author$project$Carwow$Search$Filters$Select$optionsToDisplay(select))));
	});
var $author$project$Carwow$Search$Filters$SelectRanges$ChangeSelect = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Carwow$Theme$RangeDropdown$RangeDropdown = $elm$core$Basics$identity;
var $author$project$AutomaticTranslations$RangeDropdown$maximum = 'Maximaler';
var $author$project$AutomaticTranslations$RangeDropdown$minimum = 'Minimaler';
var $author$project$Carwow$Theme$RangeDropdown$init = function (settings) {
	return {dF: settings.dF, cO: $author$project$AutomaticTranslations$RangeDropdown$maximum, d5: settings.d5, cQ: $author$project$AutomaticTranslations$RangeDropdown$minimum, d7: settings.d7, ee: settings.ee};
};
var $author$project$Carwow$Theme$RangeDropdown$greaterThan = F3(
	function (cmp, a, b) {
		var _v0 = A2(cmp, a, b);
		if (_v0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Carwow$Theme$RangeDropdown$lessThan = F3(
	function (cmp, a, b) {
		var _v0 = A2(cmp, a, b);
		if (!_v0) {
			return true;
		} else {
			return false;
		}
	});
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{l: nodeList, i: nodeListSize, k: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Carwow$Theme$RangeDropdown$onMaxRangeSelection = F4(
	function (_v0, message, defaultRangeOption, stringIndex) {
		var rangeDropdown = _v0;
		var index = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(stringIndex));
		var newSelectedRangeOption = A2(
			$elm$core$Maybe$withDefault,
			defaultRangeOption,
			A2(
				$elm$core$Array$get,
				index,
				$elm$core$Array$fromList(rangeDropdown.ee)));
		return A2(message, rangeDropdown.d7, newSelectedRangeOption);
	});
var $author$project$Carwow$Theme$RangeDropdown$onMinRangeSelection = F4(
	function (_v0, message, defaultRangeOption, stringIndex) {
		var rangeDropdown = _v0;
		var index = A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(stringIndex));
		var newSelectedRangeOption = A2(
			$elm$core$Maybe$withDefault,
			defaultRangeOption,
			A2(
				$elm$core$Array$get,
				index,
				$elm$core$Array$fromList(rangeDropdown.ee)));
		return A2(message, newSelectedRangeOption, rangeDropdown.d5);
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Carwow$Theme$RangeDropdown$viewRangeOption = F3(
	function (index, selectedOption, rangeOption) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(index)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(rangeOption.g, selectedOption.g))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(rangeOption.d3)
				]));
	});
var $author$project$Carwow$Theme$RangeDropdown$view = F2(
	function (message, rd) {
		var rangeDropdown = rd;
		var minOptions = A2(
			$elm$core$List$map,
			function (_v3) {
				var index = _v3.a;
				var rangeOption = _v3.b;
				return A3($author$project$Carwow$Theme$RangeDropdown$viewRangeOption, index, rangeDropdown.d7, rangeOption);
			},
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var rangeOption = _v2.b;
					return A3($author$project$Carwow$Theme$RangeDropdown$lessThan, rangeDropdown.dF, rangeOption.g, rangeDropdown.d5.g);
				},
				A2(
					$elm$core$List$indexedMap,
					function (i) {
						return function (r) {
							return _Utils_Tuple2(i, r);
						};
					},
					rangeDropdown.ee)));
		var maxOptions = A2(
			$elm$core$List$map,
			function (_v1) {
				var index = _v1.a;
				var rangeOption = _v1.b;
				return A3($author$project$Carwow$Theme$RangeDropdown$viewRangeOption, index, rangeDropdown.d5, rangeOption);
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var rangeOption = _v0.b;
					return A3($author$project$Carwow$Theme$RangeDropdown$greaterThan, rangeDropdown.dF, rangeOption.g, rangeDropdown.d7.g);
				},
				A2(
					$elm$core$List$indexedMap,
					function (i) {
						return function (r) {
							return _Utils_Tuple2(i, r);
						};
					},
					rangeDropdown.ee)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('range-dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-input-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rangeDropdown.cQ)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('select input-full-width')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Events$onInput(
												A3($author$project$Carwow$Theme$RangeDropdown$onMinRangeSelection, rd, message, rangeDropdown.d7))
											]),
										minOptions)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('range-dropdown')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-input-label')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rangeDropdown.cO)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('select input-full-width')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Events$onInput(
												A3($author$project$Carwow$Theme$RangeDropdown$onMaxRangeSelection, rd, message, rangeDropdown.d5))
											]),
										maxOptions)
									]))
							]))
					]))
			]);
	});
var $author$project$Carwow$Theme$RangeDropdown$withLabels = F3(
	function (minLabel, maxLabel, _v0) {
		var rangeDropdown = _v0;
		return _Utils_update(
			rangeDropdown,
			{cO: maxLabel, cQ: minLabel});
	});
var $author$project$Carwow$Search$Filters$SelectRanges$viewRange = function (range) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-filters__range')
			]),
		A2(
			$author$project$Carwow$Theme$RangeDropdown$view,
			$author$project$Carwow$Search$Filters$SelectRanges$ChangeSelect,
			A3(
				$author$project$Carwow$Theme$RangeDropdown$withLabels,
				range.cQ,
				range.cO,
				$author$project$Carwow$Theme$RangeDropdown$init(
					{
						dF: $elm$core$Basics$compare,
						d5: {d3: '', g: range.r},
						d7: {d3: '', g: range.s},
						ee: range.o
					}))));
};
var $author$project$Carwow$Search$Filters$SelectRanges$SelectRange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Theme$SegmentedNavigation$SegmentedNavigation = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$SegmentedNavigation$init = function (selectedTab) {
	return selectedTab;
};
var $author$project$Carwow$Search$Filters$SelectRanges$toSegmentedNavigationModel = function (options) {
	var firstTab = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.u;
				},
				options)));
	var tabSelected = A2(
		$elm$core$Maybe$withDefault,
		firstTab,
		$elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.u;
				},
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.ek;
					},
					options))));
	return $author$project$Carwow$Theme$SegmentedNavigation$init(tabSelected);
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Carwow$Theme$SegmentedNavigation$viewItem = F3(
	function (selectedTab, message, item) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('segmentation-nav__item', true),
							_Utils_Tuple2(
							'segmentation-nav__item--is-selected',
							_Utils_eq(item.er, selectedTab))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('segmentation-nav__link'),
								$elm$html$Html$Events$onClick(
								message(item.er))
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var key = _v0.a;
								var value = _v0.b;
								return A2($elm$html$Html$Attributes$attribute, key, value);
							},
							item.dI)),
					_List_fromArray(
						[
							$elm$html$Html$text(item.d3)
						]))
				]));
	});
var $author$project$Carwow$Theme$SegmentedNavigation$view = F3(
	function (message, items, _v0) {
		var selectedTab = _v0;
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('segmentation-nav')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Carwow$Theme$SegmentedNavigation$viewItem, selectedTab, message),
				items));
	});
var $author$project$Carwow$Search$Filters$SelectRanges$viewTabs = function (_v0) {
	var params = _v0;
	var navItems = A2(
		$elm$core$List$map,
		function (option) {
			return {dI: _List_Nil, d3: option.d3, er: option.u};
		},
		params.q);
	var nav = $author$project$Carwow$Search$Filters$SelectRanges$toSegmentedNavigationModel(params.q);
	return ($elm$core$List$length(params.q) > 1) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-filter__tabs')
			]),
		_List_fromArray(
			[
				A3($author$project$Carwow$Theme$SegmentedNavigation$view, $author$project$Carwow$Search$Filters$SelectRanges$SelectRange, navItems, nav)
			])) : $elm$html$Html$text('');
};
var $author$project$Carwow$Search$Filters$SelectRanges$view = F2(
	function (msg, ranges) {
		var rangeToDisplay = function () {
			var _v0 = $author$project$Carwow$Search$Filters$SelectRanges$selectedRange(ranges);
			if (_v0.$ === 1) {
				return $elm$html$Html$text('');
			} else {
				var r = _v0.a;
				return $author$project$Carwow$Search$Filters$SelectRanges$viewRange(r);
			}
		}();
		return A2(
			$elm$html$Html$map,
			function (a) {
				return msg(a);
			},
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Carwow$Search$Filters$SelectRanges$viewTabs(ranges),
						rangeToDisplay
					])));
	});
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $carwow$elm_slider_old$SingleSliderOld$calculateProgressPercentages = function (model) {
	var value = A3($elm$core$Basics$clamp, model.G, model.F, model.g);
	var progressRatio = 100 / (model.F - model.G);
	var _v0 = model.ed;
	if (_v0 === 1) {
		return model.M ? {a$: 100 - ((value - model.G) * progressRatio), bc: 0.0} : {a$: (value - model.G) * progressRatio, bc: 0.0};
	} else {
		return {a$: 0.0, bc: (model.F - value) * progressRatio};
	}
};
var $carwow$elm_slider_old$SingleSliderOld$OnChange = function (a) {
	return {$: 2, a: a};
};
var $carwow$elm_slider_old$SingleSliderOld$onChange = A2($elm$json$Json$Decode$map, $carwow$elm_slider_old$SingleSliderOld$OnChange, $elm$html$Html$Events$targetValue);
var $carwow$elm_slider_old$SingleSliderOld$OnInput = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $carwow$elm_slider_old$SingleSliderOld$onInput = function (shouldFetchModels) {
	return A3(
		$elm$json$Json$Decode$map2,
		$carwow$elm_slider_old$SingleSliderOld$OnInput,
		$elm$html$Html$Events$targetValue,
		$elm$json$Json$Decode$succeed(shouldFetchModels));
};
var $carwow$elm_slider_old$SingleSliderOld$TrackClicked = function (a) {
	return {$: 0, a: a};
};
var $carwow$elm_slider_old$SingleSliderOld$onInsideRangeClick = function (model) {
	var valueDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var adjustedValue = A3($elm$core$Basics$clamp, model.G, model.F, model.g);
				var newValue = $elm$core$Basics$round(
					function () {
						var _v0 = model.ed;
						if (!_v0) {
							return (adjustedValue / rectangle.bk) * mouseX;
						} else {
							return model.M ? (adjustedValue - ((mouseX / rectangle.bk) * (adjustedValue - model.G))) : (adjustedValue + ((mouseX / rectangle.bk) * (model.F - adjustedValue)));
						}
					}());
				var adjustedNewValue = A3($elm$core$Basics$clamp, model.G, model.F, newValue);
				return $elm$core$String$fromFloat(adjustedNewValue);
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	return A2($elm$json$Json$Decode$map, $carwow$elm_slider_old$SingleSliderOld$TrackClicked, valueDecoder);
};
var $carwow$elm_slider_old$SingleSliderOld$closestStep = F2(
	function (value, step) {
		var roundedValue = $elm$core$Basics$round(value);
		var roundedStep = ($elm$core$Basics$round(step) > 0) ? $elm$core$Basics$round(step) : 1;
		var remainder = roundedValue % roundedStep;
		return (_Utils_cmp(remainder, (roundedStep / 2) | 0) > 0) ? ((roundedValue - remainder) + roundedStep) : (roundedValue - remainder);
	});
var $carwow$elm_slider_old$SingleSliderOld$onOutsideRangeClick = function (model) {
	var valueDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (rectangle, mouseX) {
				var clickedValue = model.M ? (model.F - (((model.F - model.G) / rectangle.bk) * mouseX)) : ((((model.F - model.G) / rectangle.bk) * mouseX) + model.G);
				var newValue = A2($carwow$elm_slider_old$SingleSliderOld$closestStep, clickedValue, model.aG);
				return $elm$core$String$fromInt(newValue);
			}),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['target']),
			$debois$elm_dom$DOM$boundingClientRect),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['offsetX']),
			$elm$json$Json$Decode$float));
	return A2($elm$json$Json$Decode$map, $carwow$elm_slider_old$SingleSliderOld$TrackClicked, valueDecoder);
};
var $carwow$elm_slider_old$SingleSliderOld$view = function (model) {
	var trackAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('input-range__track')
		]);
	var trackAllAttributes = function () {
		var _v2 = model.bB;
		if (!_v2) {
			return A2(
				$elm$core$List$append,
				trackAttributes,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$on,
						'click',
						$carwow$elm_slider_old$SingleSliderOld$onOutsideRangeClick(model))
					]));
		} else {
			return trackAttributes;
		}
	}();
	var progressPercentages = $carwow$elm_slider_old$SingleSliderOld$calculateProgressPercentages(model);
	var progressAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$class('input-range__progress'),
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$elm$core$String$fromFloat(progressPercentages.a$) + '%'),
			A2(
			$elm$html$Html$Attributes$style,
			'right',
			$elm$core$String$fromFloat(progressPercentages.bc) + '%')
		]);
	var progressAllAttributes = function () {
		var _v1 = model.bB;
		if (!_v1) {
			return A2(
				$elm$core$List$append,
				progressAttributes,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Events$on,
						'click',
						$carwow$elm_slider_old$SingleSliderOld$onInsideRangeClick(model))
					]));
		} else {
			return progressAttributes;
		}
	}();
	var _v0 = model.M ? _Utils_Tuple2(
		model.cN(model.F),
		model.cP(model.G)) : _Utils_Tuple2(
		model.cP(model.G),
		model.cN(model.F));
	var leftText = _v0.a;
	var rightText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-range-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min(
								$elm$core$String$fromFloat(model.G)),
								$elm$html$Html$Attributes$max(
								$elm$core$String$fromFloat(model.F)),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromFloat(model.g)),
								$elm$html$Html$Attributes$step(
								$elm$core$String$fromFloat(model.aG)),
								$elm$html$Html$Attributes$class('input-range'),
								$elm$html$Html$Attributes$disabled(model.bB),
								A2($elm$html$Html$Events$on, 'change', $carwow$elm_slider_old$SingleSliderOld$onChange),
								A2(
								$elm$html$Html$Events$on,
								'input',
								$carwow$elm_slider_old$SingleSliderOld$onInput(true)),
								A2(
								$elm$html$Html$Attributes$style,
								'direction',
								model.M ? 'rtl' : 'ltr')
							]),
						_List_Nil),
						A2($elm$html$Html$div, trackAllAttributes, _List_Nil),
						A2($elm$html$Html$div, progressAllAttributes, _List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input-range-labels-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(leftText)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label input-range-label--current-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(model.aT, model.g, model.F))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('input-range-label')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rightText)
							]))
					]))
			]));
};
var $author$project$Carwow$Search$Filters$SingleSlider$view = F3(
	function (_v0, msg, _v1) {
		var slider = _v1;
		var model = $author$project$Carwow$Search$Filters$SingleSlider$toSliderModel(slider);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('search-filter-select__slider')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					msg,
					$carwow$elm_slider_old$SingleSliderOld$view(model))
				]));
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$view = F2(
	function (key, filter) {
		switch (filter.$) {
			case 0:
				var select = filter.a;
				return A3($author$project$Carwow$Search$Filters$Select$view, key, $author$project$Carwow$StockSearch$StockDealsFilters$ToggleOption, select);
			case 1:
				var radio = filter.a;
				return A3($author$project$Carwow$Search$Filters$Radio$view, key, $author$project$Carwow$StockSearch$StockDealsFilters$SelectOption, radio);
			case 2:
				var slider = filter.a;
				return A3($author$project$Carwow$Search$Filters$DoubleSlider$view, key, $author$project$Carwow$StockSearch$StockDealsFilters$DoubleSliderChange, slider);
			case 3:
				var slider = filter.a;
				return A3($author$project$Carwow$Search$Filters$SingleSlider$view, key, $author$project$Carwow$StockSearch$StockDealsFilters$SingleSliderChange, slider);
			default:
				var ranges = filter.a;
				return A2($author$project$Carwow$Search$Filters$SelectRanges$view, $author$project$Carwow$StockSearch$StockDealsFilters$SelectRange, ranges);
		}
	});
var $author$project$Carwow$StockSearch$StockDealsFilters$init = $author$project$Carwow$Search$Filters$init(
	{as: $author$project$Carwow$StockSearch$StockDealsFilters$applyChange, av: $author$project$Carwow$StockSearch$StockDealsFilters$decoder, x: $author$project$Carwow$StockSearch$StockDealsFilters$displayedSelectedValues, aw: $author$project$Carwow$StockSearch$StockDealsFilters$encoder, aB: $author$project$Carwow$StockSearch$StockDealsFilters$matches, aD: $author$project$Carwow$StockSearch$StockDealsFilters$resetValue, ek: $author$project$Carwow$StockSearch$StockDealsFilters$selectedValues, aF: $author$project$Carwow$StockSearch$StockDealsFilters$selectedKeyValues, aH: $author$project$Carwow$StockSearch$StockDealsFilters$sync, ab: $author$project$Carwow$StockSearch$StockDealsFilters$view});
var $ChristophP$elm_i18next$I18Next$Translations = $elm$core$Basics$identity;
var $ChristophP$elm_i18next$I18Next$initialTranslations = $elm$core$Dict$empty;
var $author$project$Carwow$Search$Filters$openFilter = function (filter) {
	return _Utils_update(
		filter,
		{z: true});
};
var $author$project$Carwow$Search$Filters$open = F2(
	function (keys, _v0) {
		var filters = _v0;
		return _Utils_update(
			filters,
			{
				a: A3(
					$elm$core$List$foldl,
					function (key) {
						return A2(
							$elm$core$Dict$update,
							key,
							$elm$core$Maybe$map($author$project$Carwow$Search$Filters$openFilter));
					},
					filters.a,
					keys)
			});
	});
var $author$project$Carwow$Search$openFilters = F2(
	function (keys, _v0) {
		var response = _v0;
		return _Utils_update(
			response,
			{
				a: A2($author$project$Carwow$Search$Filters$open, keys, response.a)
			});
	});
var $elm$url$Url$Builder$Absolute = {$: 0};
var $elm$url$Url$Builder$CrossOrigin = function (a) {
	return {$: 2, a: a};
};
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $author$project$Carwow$StockSearch$buildDealPath = F4(
	function (baseUrl, relativePath, queryParams, dealId) {
		var root = function () {
			if (!baseUrl.$) {
				var url = baseUrl.a;
				return $elm$url$Url$Builder$CrossOrigin(url);
			} else {
				return $elm$url$Url$Builder$Absolute;
			}
		}();
		var params = A2($elm$core$Maybe$withDefault, _List_Nil, queryParams);
		var dealPath = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					relativePath,
					$elm$core$Maybe$Just(dealId)
				]));
		return A4($elm$url$Url$Builder$custom, root, dealPath, params, $elm$core$Maybe$Nothing);
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Carwow$StockSearch$renderCarCard = F3(
	function (flags, maybeLocation, car) {
		var userLocation = function () {
			if (!maybeLocation.$) {
				var coordinates = maybeLocation.a.ct;
				return coordinates;
			} else {
				return flags.bj;
			}
		}();
		var hideDistance = function () {
			if (!maybeLocation.$) {
				return 'false';
			} else {
				return flags.bH;
			}
		}();
		var htmlKeyID = A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				[car.d_, hideDistance]));
		var dataAttributes = _List_fromArray(
			[
				_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string('interaction-element')),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string('View deal'))
				]),
				_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string('interaction-section')),
					_Utils_Tuple2(
					'value',
					$elm$json$Json$Encode$string('Car card'))
				])
			]);
		var badge = function () {
			var _v0 = flags.Z;
			if (!_v0.$) {
				var stockSale = _v0.a;
				return stockSale.at;
			} else {
				return $elm$core$Maybe$Just('');
			}
		}();
		var component = A3(
			$elm$html$Html$node,
			'carwow-stock-deal-card',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(car.d_),
					$elm$html$Html$Attributes$class('stock-car-search-results__card'),
					A2($elm$html$Html$Attributes$attribute, 'deal_id', car.d_),
					A2(
					$elm$html$Html$Attributes$attribute,
					'deal_path',
					A4($author$project$Carwow$StockSearch$buildDealPath, flags.bx, flags.bw, $elm$core$Maybe$Nothing, car.d_)),
					A2($elm$html$Html$Attributes$attribute, 'deals_service_api_endpoint', flags.by),
					A2($elm$html$Html$Attributes$attribute, 'user_location', userLocation),
					A2($elm$html$Html$Attributes$attribute, 'hide_distance', hideDistance),
					A2($elm$html$Html$Attributes$attribute, 'show_power_kw', flags.b6),
					A2($elm$html$Html$Attributes$attribute, 'show_price_confidence', flags.b7),
					A2($elm$html$Html$Attributes$attribute, 'show_efficiency_details', flags.b5),
					A2($elm$html$Html$Attributes$attribute, 'show_ask_for_leasing_price', flags.b4),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data_attributes',
					A2(
						$elm$json$Json$Encode$encode,
						0,
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$object, dataAttributes))),
					A2(
					$elm$html$Html$Attributes$attribute,
					'badge',
					A2($elm$core$Maybe$withDefault, '', badge)),
					A2($elm$html$Html$Attributes$attribute, 'app_name', flags.bo),
					A2($elm$html$Html$Attributes$attribute, 'source_partner', flags.ak)
				]),
			_List_Nil);
		return _Utils_Tuple2(htmlKeyID, component);
	});
var $author$project$Carwow$Analytics$TrackableEvent$TrackableEvent = $elm$core$Basics$identity;
var $author$project$Carwow$Analytics$TrackableEvent$init = function (name) {
	return {
		bV: name,
		a7: $elm$json$Json$Encode$object(_List_Nil)
	};
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Carwow$Analytics$TrackableEvent$withParams = F2(
	function (params, _v0) {
		var payload = _v0;
		return _Utils_update(
			payload,
			{a7: params});
	});
var $author$project$Carwow$StockSearch$buildResultsEvent = F5(
	function (type_, count, total, page, firingTrigger) {
		var encodedFiringTrigger = function () {
			if (!firingTrigger) {
				return _Utils_Tuple2(
					'firingTrigger',
					$elm$json$Json$Encode$string('initial_load'));
			} else {
				return _Utils_Tuple2(
					'firingTrigger',
					$elm$json$Json$Encode$string('subsequent_load'));
			}
		}();
		return A2(
			$author$project$Carwow$Analytics$TrackableEvent$withParams,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(type_)),
						_Utils_Tuple2(
						'resultsCount',
						$elm$json$Json$Encode$int(count)),
						_Utils_Tuple2(
						'totalResultsCount',
						$elm$json$Json$Encode$int(total)),
						_Utils_Tuple2(
						'currentResultPage',
						$elm$json$Json$Encode$int(page)),
						encodedFiringTrigger
					])),
			$author$project$Carwow$Analytics$TrackableEvent$init('Stock Cars Number Of Cars'));
	});
var $author$project$Carwow$Search$withPagination = F2(
	function (fun, _v0) {
		var pagination = _v0.p;
		return fun(pagination);
	});
var $author$project$Carwow$StockSearch$resultsCount = function (_v0) {
	var searchData = _v0.d;
	return A2(
		$author$project$Carwow$Search$withPagination,
		function (pagination) {
			return pagination.ez;
		},
		searchData);
};
var $author$project$Carwow$Analytics$TrackableEvent$dataLayerEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'event',
				$elm$json$Json$Encode$string('trackable event')),
				_Utils_Tuple2(
				'eventName',
				$elm$json$Json$Encode$string(payload.bV)),
				_Utils_Tuple2('eventParams', payload.a7),
				_Utils_Tuple2(
				'_clear',
				$elm$json$Json$Encode$bool(true))
			]));
};
var $author$project$Carwow$Analytics$TrackableEvent$pushToDataLayer = _Platform_outgoingPort('pushToDataLayer', $elm$core$Basics$identity);
var $author$project$Carwow$Analytics$TrackableEvent$track = function (_v0) {
	var payload = _v0;
	return $author$project$Carwow$Analytics$TrackableEvent$pushToDataLayer(
		$author$project$Carwow$Analytics$TrackableEvent$dataLayerEncoder(payload));
};
var $author$project$Carwow$Search$withData = F2(
	function (fun, _v0) {
		var data = _v0.A;
		return fun(data);
	});
var $author$project$Carwow$StockSearch$trackSearchResults = F2(
	function (model, firingTrigger) {
		var page = A2(
			$author$project$Carwow$Search$withPagination,
			function ($) {
				return $.au;
			},
			model.d);
		var count = A2($author$project$Carwow$Search$withData, $elm$core$List$length, model.d);
		return $author$project$Carwow$Analytics$TrackableEvent$track(
			A5(
				$author$project$Carwow$StockSearch$buildResultsEvent,
				'search_results',
				count,
				$author$project$Carwow$StockSearch$resultsCount(model),
				page,
				firingTrigger));
	});
var $author$project$Carwow$StockSearch$RecommendationsMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Carwow$Search$Filters$encoderFilter = F2(
	function (valueEncoder, filter) {
		return A2(valueEncoder, filter.u, filter.g);
	});
var $author$project$Carwow$Search$Filters$encoder = function (_v0) {
	var filters = _v0;
	return A2(
		$elm$core$List$concatMap,
		$author$project$Carwow$Search$Filters$encoderFilter(filters.aw),
		A2(
			$elm$core$List$filter,
			function (f) {
				return !$elm$core$List$isEmpty(
					filters.ek(f.g));
			},
			$elm$core$Dict$values(filters.a)));
};
var $author$project$Carwow$Search$SortOrder$selected = function (_v0) {
	var sortOrder = _v0;
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.ek;
			},
			sortOrder.o));
};
var $author$project$Carwow$Search$SortOrder$encoder = function (_v0) {
	var sortOrder = _v0;
	var _v1 = $author$project$Carwow$Search$SortOrder$selected(sortOrder);
	if (!_v1.$) {
		var option = _v1.a;
		var _v2 = sortOrder.bE;
		if (!_v2) {
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'sort_order[key]', option.u),
					A2($elm$url$Url$Builder$string, 'sort_order[direction]', option.bA)
				]);
		} else {
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'sort', option.u)
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Search$filterOptionsEncode = function (_v0) {
	var filterOptions = _v0.ax;
	return _Utils_ap(
		_List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'filter_options[default_make_slugs]',
				A2($elm$core$String$join, ',', filterOptions.dM))
			]),
		_Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'filter_options[default_model_slugs]',
					A2($elm$core$String$join, ',', filterOptions.dN))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$url$Url$Builder$string,
						'filter_options[allowed_stock_types]',
						A2($elm$core$String$join, ',', filterOptions.dA))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'filter_options[hidden_filters]',
							A2($elm$core$String$join, ',', filterOptions.dZ))
						]),
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'filter_options[excluded_filters]',
							A2($elm$core$String$join, ',', filterOptions.dT))
						])))));
};
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Carwow$Search$paginationEncode = function (_v0) {
	var pagination = _v0.p;
	var context = _v0.aR;
	return A2(
		$elm$core$List$member,
		context,
		_List_fromArray(
			['Car Chooser', 'Car Discovery'])) ? _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'page[number]', pagination.au)
		]) : _List_fromArray(
		[
			A2($elm$url$Url$Builder$int, 'pagination[current_page]', pagination.au),
			A2($elm$url$Url$Builder$int, 'pagination[per_page]', pagination.ec)
		]);
};
var $author$project$Carwow$Search$encode = function (_v0) {
	var response = _v0;
	return _Utils_ap(
		$author$project$Carwow$Search$Filters$encoder(response.a),
		_Utils_ap(
			$author$project$Carwow$Search$paginationEncode(response),
			_Utils_ap(
				$author$project$Carwow$Search$SortOrder$encoder(response.h),
				$author$project$Carwow$Search$filterOptionsEncode(response))));
};
var $author$project$Carwow$StockSearch$Recommendations$ReceiveRecommendations = $elm$core$Basics$identity;
var $author$project$Carwow$Http$absolute = $author$project$Carwow$Http$defaultClient;
var $author$project$Carwow$Http$deleteHeader = F2(
	function (key, headersList) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var k = _v0.a;
				return !_Utils_eq(k, key);
			},
			headersList);
	});
var $author$project$Carwow$Http$addHeader = F2(
	function (_v0, headersList) {
		var key = _v0.a;
		var value = _v0.b;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			A2($author$project$Carwow$Http$deleteHeader, key, headersList));
	});
var $author$project$Carwow$Http$header = F3(
	function (key, value, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{
				cE: A2(
					$author$project$Carwow$Http$addHeader,
					_Utils_Tuple2(key, value),
					client.cE)
			});
	});
var $author$project$Carwow$Http$methodForRequest = function (method) {
	switch (method) {
		case 0:
			return 'GET';
		case 1:
			return 'POST';
		case 2:
			return 'PATCH';
		case 3:
			return 'PUT';
		default:
			return 'DELETE';
	}
};
var $author$project$Carwow$Http$requestUrl = function (client) {
	return A2(client.ay, client.aX, client.U);
};
var $author$project$Carwow$Http$toContext = function (_v0) {
	var client = _v0;
	return {
		co: client.co,
		cE: client.cE,
		d6: $author$project$Carwow$Http$methodForRequest(client.d6),
		aO: $author$project$Carwow$Http$requestUrl(client)
	};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Carwow$Http$BadBody = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Carwow$Http$decodeJson = F3(
	function (context, decoder, response) {
		return A2(
			$elm$core$Result$map,
			function (value) {
				return {co: value, aR: context, cE: response.cE, dl: response.dl};
			},
			A2(
				$elm$core$Result$mapError,
				function (err) {
					return A2($author$project$Carwow$Http$BadBody, err, response);
				},
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeString, decoder, response.co))));
	});
var $author$project$Carwow$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Carwow$Http$BadUrl = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Carwow$Http$NetworkError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$Http$Timeout = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Http$toResponse = F3(
	function (context, metadata, body_) {
		return {
			co: body_,
			aR: context,
			cE: $elm$core$Dict$toList(metadata.cE),
			dl: metadata.dm
		};
	});
var $author$project$Carwow$Http$toDataString = F2(
	function (context, response) {
		switch (response.$) {
			case 0:
				var url_ = response.a;
				return $elm$core$Result$Err(
					A2($author$project$Carwow$Http$BadUrl, url_, context));
			case 1:
				return $elm$core$Result$Err(
					$author$project$Carwow$Http$Timeout(context));
			case 2:
				return $elm$core$Result$Err(
					$author$project$Carwow$Http$NetworkError(context));
			case 3:
				var metadata = response.a;
				var body_ = response.b;
				return $elm$core$Result$Err(
					A2(
						$author$project$Carwow$Http$BadStatus,
						metadata.dm,
						A3($author$project$Carwow$Http$toResponse, context, metadata, body_)));
			default:
				var metadata = response.a;
				var body_ = response.b;
				return $elm$core$Result$Ok(
					A3($author$project$Carwow$Http$toResponse, context, metadata, body_));
		}
	});
var $author$project$Carwow$Http$toDataJson = F3(
	function (decoder, context, response) {
		return A2(
			$elm$core$Result$andThen,
			A2($author$project$Carwow$Http$decodeJson, context, decoder),
			A2($author$project$Carwow$Http$toDataString, context, response));
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {db: reqs, $7: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.eB;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.db));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.$7)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					dz: r.dz,
					co: r.co,
					dU: A2(_Http_mapExpect, func, r.dU),
					cE: r.cE,
					d6: r.d6,
					aa: r.aa,
					eB: r.eB,
					aO: r.aO
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{dz: false, co: r.co, dU: r.dU, cE: r.cE, d6: r.d6, aa: r.aa, eB: r.eB, aO: r.aO}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{dz: true, co: r.co, dU: r.dU, cE: r.cE, d6: r.d6, aa: r.aa, eB: r.eB, aO: r.aO}));
};
var $author$project$Carwow$Http$toHttpRequest = F3(
	function (msg, responseToData, _v0) {
		var client = _v0;
		var request = {
			co: client.co,
			dU: A2($elm$http$Http$expectStringResponse, msg, responseToData),
			cE: A2(
				$elm$core$List$map,
				function (_v1) {
					var key = _v1.a;
					var val = _v1.b;
					return A2($elm$http$Http$header, key, val);
				},
				client.cE),
			d6: $author$project$Carwow$Http$methodForRequest(client.d6),
			aa: client.aa,
			eB: $elm$core$Maybe$Nothing,
			aO: $author$project$Carwow$Http$requestUrl(client)
		};
		return client.aP ? $elm$http$Http$riskyRequest(request) : $elm$http$Http$request(request);
	});
var $author$project$Carwow$Http$fetchJson = F3(
	function (decoder, msg, client) {
		return A3(
			$author$project$Carwow$Http$toHttpRequest,
			msg,
			A2(
				$author$project$Carwow$Http$toDataJson,
				decoder,
				$author$project$Carwow$Http$toContext(client)),
			A3($author$project$Carwow$Http$header, 'Accept', 'application/json', client));
	});
var $author$project$Carwow$Http$path = F2(
	function (endpoint, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{aX: endpoint});
	});
var $author$project$Carwow$Http$query = F2(
	function (params, _v0) {
		var client = _v0;
		var newParams = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var k = _v1.a;
					var v = _v1.b;
					return A2($elm$url$Url$Builder$string, k, v);
				},
				params),
			client.U);
		return _Utils_update(
			client,
			{U: newParams});
	});
var $author$project$Carwow$Http$queryParams = F2(
	function (params, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{
				U: _Utils_ap(params, client.U)
			});
	});
var $author$project$Carwow$StockSearch$Recommendations$fetch = F2(
	function (filters, excludedIds) {
		return A3(
			$author$project$Carwow$Http$fetchJson,
			$elm$json$Json$Decode$list($author$project$Carwow$StockSearch$StockDeal$decoder),
			$elm$core$Basics$identity,
			A2(
				$author$project$Carwow$Http$queryParams,
				filters,
				A2(
					$author$project$Carwow$Http$query,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'excluded_ids',
							A2($elm$core$String$join, ',', excludedIds))
						]),
					A2(
						$author$project$Carwow$Http$path,
						_List_fromArray(
							['stock_cars', 'recommendations']),
						$author$project$Carwow$Http$get($author$project$Carwow$Http$absolute)))));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Carwow$StockSearch$fetchRecommendations = F2(
	function (model, firingTrigger) {
		var currentCarIDs = A2(
			$author$project$Carwow$Search$withData,
			$elm$core$List$map(
				function ($) {
					return $.d_;
				}),
			model.d);
		return A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Carwow$StockSearch$RecommendationsMsg(firingTrigger),
			A2(
				$author$project$Carwow$StockSearch$Recommendations$fetch,
				$author$project$Carwow$Search$encode(model.d),
				currentCarIDs));
	});
var $author$project$Carwow$StockSearch$updateRecommendations = F2(
	function (model, firingTrigger) {
		var noPromotion = function () {
			var _v0 = model.Z;
			if (!_v0.$) {
				return false;
			} else {
				return true;
			}
		}();
		return (($author$project$Carwow$StockSearch$resultsCount(model) < 10) && noPromotion) ? A2($author$project$Carwow$StockSearch$fetchRecommendations, model, firingTrigger) : $elm$core$Platform$Cmd$none;
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Carwow$Search$SortOrder$withKey = F2(
	function (key, _v0) {
		var sortOrder = _v0;
		return _Utils_update(
			sortOrder,
			{u: key});
	});
var $author$project$Carwow$Search$SortOrder$withLabel = F2(
	function (label, _v0) {
		var sortOrder = _v0;
		return _Utils_update(
			sortOrder,
			{d3: label});
	});
var $author$project$Carwow$StockSearch$init = function (flags) {
	var location = A2(
		$elm$core$Maybe$map,
		function (postcode) {
			return A2($author$project$Carwow$StockSearch$Location, postcode, flags.bj);
		},
		flags.cj);
	var defaultSort = A2(
		$author$project$Carwow$Search$SortOrder$withLabel,
		'Closest',
		A2($author$project$Carwow$Search$SortOrder$withKey, 'distance', $author$project$Carwow$Search$SortOrder$init));
	var searchConfig = A2(
		$author$project$Carwow$Search$init,
		_List_Nil,
		{
			aR: 'Stock Deals',
			Q: $elm$json$Json$Decode$list($author$project$Carwow$StockSearch$StockDeal$decoder),
			ax: flags.ax,
			a: $author$project$Carwow$StockSearch$StockDealsFilters$init,
			T: true,
			h: defaultSort,
			aL: $ChristophP$elm_i18next$I18Next$initialTranslations
		});
	var searchData = A2(
		$author$project$Carwow$Search$openFilters,
		_List_fromArray(
			['stock_type']),
		A2(
			$elm$core$Result$withDefault,
			searchConfig,
			A2($author$project$Carwow$Search$decode, searchConfig, flags.d)));
	var model = {
		K: $author$project$Carwow$Theme$Modal$init('filter-modal'),
		a0: 0,
		S: false,
		E: location,
		af: flags.af,
		cM: flags.ba + (((flags.ba === '/') ? '' : '/') + 'car_configuration/choose-model#make-model-menu'),
		a9: $author$project$Carwow$StockSearch$PrismicPreview$init(flags.b1),
		W: _List_Nil,
		bb: $author$project$Carwow$StockSearch$renderCarCard(flags),
		aE: '',
		d: searchData,
		ah: flags.ah === 'true',
		ai: flags.ai,
		ak: flags.ak,
		Z: flags.Z,
		ap: flags.ap,
		aq: flags.aq
	};
	var commands = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A2($author$project$Carwow$StockSearch$updateRecommendations, model, 0),
				A2($author$project$Carwow$StockSearch$trackSearchResults, model, 0)
			]));
	return _Utils_Tuple2(model, commands);
};
var $author$project$Carwow$StockSearch$CloseAllChips = function (a) {
	return {$: 7, a: a};
};
var $author$project$Carwow$StockSearch$CloseFiltersModal = {$: 2};
var $author$project$Carwow$StockSearch$LocationChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Carwow$StockSearch$NoOp = {$: 0};
var $author$project$Carwow$StockSearch$Rendering = 1;
var $author$project$Carwow$StockSearch$Tick = {$: 3};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Carwow$StockSearch$clickOutsideChipDropdown = _Platform_incomingPort('clickOutsideChipDropdown', $elm$json$Json$Decode$bool);
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Carwow$Theme$Modal$onEsc = F3(
	function (dismiss, noop, key) {
		return ((key === 'Escape') || (key === 'Esc')) ? dismiss : noop;
	});
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {cZ: pids, $7: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {cA: event, u: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.cZ,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.u;
		var event = _v0.cA;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.$7);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
var $author$project$Carwow$Theme$Modal$onKeyUp = function (msg) {
	return $elm$browser$Browser$Events$onKeyUp(
		A2(
			$elm$json$Json$Decode$map,
			msg,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
};
var $author$project$Carwow$Theme$Modal$closeOnEsc = F3(
	function (_v0, dismiss, noop) {
		var state = _v0.b;
		if (!state) {
			return $author$project$Carwow$Theme$Modal$onKeyUp(
				A2($author$project$Carwow$Theme$Modal$onEsc, dismiss, noop));
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Carwow$StockSearch$locationChanged = _Platform_incomingPort('locationChanged', $elm$json$Json$Decode$value);
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {bY: oldTime, dc: request, $7: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.dc;
		var oldTime = _v0.bY;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.$7;
		var oldTime = _v0.bY;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $author$project$Carwow$StockSearch$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A3($author$project$Carwow$Theme$Modal$closeOnEsc, model.K, $author$project$Carwow$StockSearch$CloseFiltersModal, $author$project$Carwow$StockSearch$NoOp),
				$author$project$Carwow$StockSearch$clickOutsideChipDropdown($author$project$Carwow$StockSearch$CloseAllChips),
				$author$project$Carwow$StockSearch$locationChanged($author$project$Carwow$StockSearch$LocationChanged),
				(model.a0 === 1) ? $elm$browser$Browser$Events$onAnimationFrame(
				$elm$core$Basics$always($author$project$Carwow$StockSearch$Tick)) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Carwow$StockSearch$ReceiveResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Carwow$StockSearch$Rendered = 2;
var $author$project$Carwow$StockSearch$SubsequentLoad = 1;
var $author$project$Carwow$Theme$Modal$closed = _Platform_outgoingPort('closed', $elm$json$Json$Encode$string);
var $author$project$Carwow$Theme$Modal$close = function (_v0) {
	var id = _v0.a;
	var state = _v0.b;
	if (!state) {
		return _Utils_Tuple2(
			A2($author$project$Carwow$Theme$Modal$Modal, id, 1),
			$author$project$Carwow$Theme$Modal$closed(id));
	} else {
		return _Utils_Tuple2(
			A2($author$project$Carwow$Theme$Modal$Modal, id, 1),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Carwow$Theme$ChipDropdown$close = function (_v0) {
	var state = _v0.a;
	var modal = _v0.b;
	var _v1 = $author$project$Carwow$Theme$Modal$close(modal);
	var newModal = _v1.a;
	var msg = _v1.b;
	return _Utils_Tuple2(
		A2($author$project$Carwow$Theme$ChipDropdown$ChipDropdown, 1, newModal),
		msg);
};
var $author$project$Carwow$Theme$ChipDropdown$Opened = 0;
var $author$project$Carwow$Theme$Modal$Opened = 0;
var $author$project$Carwow$Theme$Modal$opened = _Platform_outgoingPort('opened', $elm$json$Json$Encode$string);
var $author$project$Carwow$Theme$Modal$open = function (_v0) {
	var id = _v0.a;
	var state = _v0.b;
	if (!state) {
		return _Utils_Tuple2(
			A2($author$project$Carwow$Theme$Modal$Modal, id, 0),
			$elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(
			A2($author$project$Carwow$Theme$Modal$Modal, id, 0),
			$author$project$Carwow$Theme$Modal$opened(id));
	}
};
var $author$project$Carwow$Theme$ChipDropdown$open = F2(
	function (chipType, _v0) {
		var state = _v0.a;
		var modal = _v0.b;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(state, chipType);
			if (!_v2.b) {
				var _v3 = _v2.b;
				return $author$project$Carwow$Theme$Modal$open(modal);
			} else {
				return _Utils_Tuple2(modal, $elm$core$Platform$Cmd$none);
			}
		}();
		var newModal = _v1.a;
		var msg = _v1.b;
		return _Utils_Tuple2(
			A2($author$project$Carwow$Theme$ChipDropdown$ChipDropdown, 0, newModal),
			msg);
	});
var $author$project$Carwow$Theme$ChipDropdown$toggle = F2(
	function (chipType, chip) {
		var state = chip.a;
		if (!state) {
			return $author$project$Carwow$Theme$ChipDropdown$close(chip);
		} else {
			return A2($author$project$Carwow$Theme$ChipDropdown$open, chipType, chip);
		}
	});
var $author$project$Carwow$Search$Filters$applyToggleChange = F2(
	function (toggle, filter) {
		if (!toggle.$) {
			var chipType = toggle.a;
			return _Utils_update(
				filter,
				{
					D: A2($author$project$Carwow$Theme$ChipDropdown$toggle, chipType, filter.D).a
				});
		} else {
			return _Utils_update(
				filter,
				{z: !filter.z});
		}
	});
var $author$project$Carwow$Search$Filters$mapChanged = F2(
	function (f, changed) {
		if (!changed.$) {
			var value = changed.a;
			return $author$project$Carwow$Search$Filters$ServerChanged(
				f(value));
		} else {
			var value = changed.a;
			return $author$project$Carwow$Search$Filters$ClientChanged(
				f(value));
		}
	});
var $author$project$Carwow$Search$Filters$applyChangeFilter = F3(
	function (apply, change, filter) {
		if (!change.$) {
			var toggle = change.a;
			return $author$project$Carwow$Search$Filters$clientChanged(
				A2($author$project$Carwow$Search$Filters$applyToggleChange, toggle, filter));
		} else {
			var changeValue = change.a;
			return A2(
				$author$project$Carwow$Search$Filters$mapChanged,
				function (newValue) {
					return _Utils_update(
						filter,
						{g: newValue});
				},
				A2(apply, changeValue, filter.g));
		}
	});
var $author$project$Carwow$Search$Filters$closeChip = function (filter) {
	return _Utils_update(
		filter,
		{
			D: $author$project$Carwow$Theme$ChipDropdown$close(filter.D).a
		});
};
var $author$project$Carwow$Search$Filters$closeChipWithKey = F3(
	function (changedKey, key, filter) {
		return _Utils_eq(key, changedKey) ? filter : $author$project$Carwow$Search$Filters$closeChip(filter);
	});
var $author$project$Carwow$Search$Filters$updateFilters = F3(
	function (key, change, _v0) {
		var filters = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Carwow$Search$Filters$clientChanged(filters),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					change,
					$author$project$Carwow$Search$Filters$mapChanged(
						function (filter) {
							return _Utils_update(
								filters,
								{
									a: A3($elm$core$Dict$insert, key, filter, filters.a)
								});
						})),
				A2($elm$core$Dict$get, key, filters.a)));
	});
var $author$project$Carwow$Search$Filters$applyChange = F3(
	function (change, key, _v0) {
		var filters = _v0;
		var collapsedFilters = _Utils_update(
			filters,
			{
				a: A2(
					$elm$core$Dict$map,
					$author$project$Carwow$Search$Filters$closeChipWithKey(key),
					filters.a)
			});
		return A3(
			$author$project$Carwow$Search$Filters$updateFilters,
			key,
			A2($author$project$Carwow$Search$Filters$applyChangeFilter, collapsedFilters.as, change),
			collapsedFilters);
	});
var $author$project$Carwow$Search$bump = function (_v0) {
	var response = _v0;
	return _Utils_update(
		response,
		{an: response.an + 1});
};
var $author$project$Carwow$Search$Filters$closeChipFilters = function (_v0) {
	var filters = _v0;
	return _Utils_update(
		filters,
		{
			a: A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, filter) {
						return $author$project$Carwow$Search$Filters$closeChip(filter);
					}),
				filters.a)
		});
};
var $author$project$Carwow$Search$closeChipFilters = function (_v0) {
	var response = _v0;
	return _Utils_update(
		response,
		{
			a: $author$project$Carwow$Search$Filters$closeChipFilters(response.a)
		});
};
var $author$project$Carwow$Search$SortOrder$close = function (_v0) {
	var sortOrder = _v0;
	return _Utils_update(
		sortOrder,
		{
			D: $author$project$Carwow$Theme$ChipDropdown$close(sortOrder.D).a
		});
};
var $author$project$Carwow$Search$closeSort = function (_v0) {
	var response = _v0;
	return _Utils_update(
		response,
		{
			h: $author$project$Carwow$Search$SortOrder$close(response.h)
		});
};
var $author$project$Carwow$Search$Filters$onChanged = F4(
	function (serverMapping, clientMapping, toCmd, changed) {
		if (!changed.$) {
			var value = changed.a;
			var newValue = serverMapping(value);
			return _Utils_Tuple2(
				newValue,
				toCmd(newValue));
		} else {
			var value = changed.a;
			var newValue = clientMapping(value);
			return _Utils_Tuple2(newValue, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Carwow$Search$Filters$findChildren = F2(
	function (key, _v0) {
		var filters = _v0;
		var children = A2(
			$elm$core$List$map,
			function ($) {
				return $.u;
			},
			A2(
				$elm$core$List$filter,
				function (filter) {
					return _Utils_eq(
						filter.cX,
						$elm$core$Maybe$Just(key));
				},
				$elm$core$Dict$values(filters.a)));
		var descendants = A2(
			$elm$core$List$concatMap,
			function (childKey) {
				return A2($author$project$Carwow$Search$Filters$findChildren, childKey, filters);
			},
			children);
		return A2($elm$core$List$append, children, descendants);
	});
var $author$project$Carwow$Search$Filters$resetFilter = F2(
	function (_v0, filter) {
		var filters = _v0;
		return _Utils_update(
			filter,
			{
				g: filters.aD(filter.g)
			});
	});
var $author$project$Carwow$Search$Filters$reset = F2(
	function (key, _v0) {
		var filters = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			filters,
			A2(
				$elm$core$Maybe$map,
				function (filter) {
					return _Utils_update(
						filters,
						{
							a: A3($elm$core$Dict$insert, key, filter, filters.a)
						});
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Carwow$Search$Filters$resetFilter(filters),
					A2($elm$core$Dict$get, key, filters.a))));
	});
var $author$project$Carwow$Search$Filters$resetChildren = F2(
	function (key, _v0) {
		var filters = _v0;
		return A3(
			$elm$core$List$foldl,
			$author$project$Carwow$Search$Filters$reset,
			filters,
			A2($author$project$Carwow$Search$Filters$findChildren, key, filters));
	});
var $author$project$Carwow$Search$resetChildrenFilters = F2(
	function (key, _v0) {
		var response = _v0;
		return _Utils_update(
			response,
			{
				a: A2($author$project$Carwow$Search$Filters$resetChildren, key, response.a)
			});
	});
var $author$project$Carwow$Search$resetPagination = function (_v0) {
	var response = _v0;
	var pagination = response.p;
	return _Utils_update(
		response,
		{
			p: _Utils_update(
				pagination,
				{au: 1})
		});
};
var $author$project$Carwow$Search$SortOrder$shouldFetch = F2(
	function (change, _v0) {
		var sortOrder = _v0;
		if (change.$ === 1) {
			var key = change.a;
			var prevSortKey = A2(
				$elm$core$Maybe$withDefault,
				key,
				$elm$core$List$head(
					A2($elm$core$String$split, '-', sortOrder.u)));
			return !_Utils_eq(key, prevSortKey);
		} else {
			return false;
		}
	});
var $author$project$Carwow$Search$SortOrder$select = F2(
	function (key, sortOrder) {
		var options = A2(
			$elm$core$List$map,
			function (option) {
				return _Utils_update(
					option,
					{
						ek: _Utils_eq(option.u, key)
					});
			},
			sortOrder.o);
		return _Utils_update(
			sortOrder,
			{u: key, o: options});
	});
var $author$project$Carwow$Search$SortOrder$update = F2(
	function (_v0, msg) {
		var sortOrder = _v0;
		switch (msg.$) {
			case 0:
				var chipType = msg.a;
				var _v2 = A2($author$project$Carwow$Theme$ChipDropdown$toggle, chipType, sortOrder.D);
				var chip = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						sortOrder,
						{D: chip}),
					cmd);
			case 1:
				var key = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Carwow$Search$SortOrder$select, key, sortOrder),
					$elm$core$Platform$Cmd$none);
			default:
				var _v3 = $author$project$Carwow$Theme$ChipDropdown$close(sortOrder.D);
				var chip = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						sortOrder,
						{D: chip}),
					cmd);
		}
	});
var $author$project$Carwow$Search$Filters$getFilters = F2(
	function (filters, keys) {
		return A2(
			$elm$core$List$filterMap,
			function (k) {
				return A2($elm$core$Dict$get, k, filters.a);
			},
			keys);
	});
var $author$project$Carwow$Search$Filters$getFilterKeyValues = F2(
	function (keys, _v0) {
		var filters = _v0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, dict) {
					var k = _v1.a;
					var v = _v1.b;
					return A3($elm$core$Dict$insert, k, v, dict);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$map,
				function (f) {
					return _Utils_Tuple2(
						f.u,
						filters.aF(f.g));
				},
				A2($author$project$Carwow$Search$Filters$getFilters, filters, keys)));
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Carwow$Search$Filters$parseFilterCondition = function (condition) {
	var splitCondition = A2($elm$core$String$split, '=', condition);
	var values = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$split(','),
			$elm_community$list_extra$List$Extra$last(splitCondition)));
	var key = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(splitCondition));
	return _Utils_Tuple2(key, values);
};
var $author$project$Carwow$Search$Filters$filterSatisfiesCondition = F2(
	function (filter, filters) {
		var _v0 = filter.cs;
		if (!_v0.$) {
			var condition = _v0.a;
			var _v1 = $author$project$Carwow$Search$Filters$parseFilterCondition(condition);
			var conditionKey = _v1.a;
			var conditionValues = _v1.b;
			var selectedValues = A2(
				$elm$core$List$concatMap,
				$elm$core$Basics$identity,
				$elm$core$Dict$values(
					A2(
						$author$project$Carwow$Search$Filters$getFilterKeyValues,
						_List_fromArray(
							[conditionKey]),
						filters)));
			return ($elm$core$List$isEmpty(selectedValues) && A2($elm$core$List$member, '*', conditionValues)) ? true : A2(
				$elm$core$List$any,
				function (v) {
					return A2($elm$core$List$member, v, selectedValues);
				},
				conditionValues);
		} else {
			return true;
		}
	});
var $author$project$Carwow$Search$Filters$updateConditionalFilter = F2(
	function (filter, filters) {
		return A2($author$project$Carwow$Search$Filters$filterSatisfiesCondition, filter, filters) ? filter : A2($author$project$Carwow$Search$Filters$resetFilter, filters, filter);
	});
var $author$project$Carwow$Search$Filters$updateConditionalFilters = function (_v0) {
	var filters = _v0;
	return _Utils_update(
		filters,
		{
			a: A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, f) {
						return A2($author$project$Carwow$Search$Filters$updateConditionalFilter, f, filters);
					}),
				filters.a)
		});
};
var $author$project$Carwow$Search$updateConditionalFilters = function (_v0) {
	var response = _v0;
	return _Utils_update(
		response,
		{
			a: $author$project$Carwow$Search$Filters$updateConditionalFilters(response.a)
		});
};
var $author$project$Carwow$Search$applyChange = F3(
	function (doRequest, change, _v0) {
		var response = _v0;
		switch (change.$) {
			case 0:
				var key = change.a;
				var filterChange = change.b;
				return A4(
					$author$project$Carwow$Search$Filters$onChanged,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Carwow$Search$resetChildrenFilters(key),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Carwow$Search$updateConditionalFilters,
							A2($elm$core$Basics$composeR, $author$project$Carwow$Search$resetPagination, $author$project$Carwow$Search$bump))),
					$author$project$Carwow$Search$closeSort,
					doRequest,
					A2(
						$author$project$Carwow$Search$Filters$mapChanged,
						function (newFilters) {
							return _Utils_update(
								response,
								{a: newFilters});
						},
						A3($author$project$Carwow$Search$Filters$applyChange, filterChange, key, response.a)));
			case 1:
				var pagination = change.a;
				var newResponse = $author$project$Carwow$Search$bump(
					_Utils_update(
						response,
						{p: pagination}));
				return _Utils_Tuple2(
					newResponse,
					doRequest(newResponse));
			default:
				var sortChange = change.a;
				var newResponse = $author$project$Carwow$Search$bump(
					$author$project$Carwow$Search$closeChipFilters(
						$author$project$Carwow$Search$resetPagination(
							_Utils_update(
								response,
								{
									h: A2($author$project$Carwow$Search$SortOrder$update, response.h, sortChange).a
								}))));
				var fetchData = A2($author$project$Carwow$Search$SortOrder$shouldFetch, sortChange, response.h) ? doRequest(newResponse) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(newResponse, fetchData);
		}
	});
var $author$project$Carwow$Search$Filters$closeFilter = function (filter) {
	return _Utils_update(
		filter,
		{z: false});
};
var $author$project$Carwow$Search$Filters$closeAll = function (_v0) {
	var filters = _v0;
	return _Utils_update(
		filters,
		{
			a: A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, filter) {
						return $author$project$Carwow$Search$Filters$closeFilter(filter);
					}),
				filters.a)
		});
};
var $author$project$Carwow$Search$closeAllFilters = function (_v0) {
	var response = _v0;
	return _Utils_update(
		response,
		{
			a: $author$project$Carwow$Search$Filters$closeAll(response.a)
		});
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Carwow$Search$Filters$valueChanged = function (change) {
	if (change.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Carwow$Search$valueChanged = function (change) {
	if (!change.$) {
		var c = change.b;
		return $author$project$Carwow$Search$Filters$valueChanged(c);
	} else {
		return false;
	}
};
var $author$project$Carwow$StockSearch$isLoading = function (change) {
	return $author$project$Carwow$Search$valueChanged(change);
};
var $author$project$Carwow$StockSearch$locationDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Carwow$StockSearch$Location,
	A2($elm$json$Json$Decode$field, 'postcode', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'coordinates', $elm$json$Json$Decode$string));
var $author$project$Carwow$Bugsnag$Internal$List = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$Bugsnag$Internal$String = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Bugsnag$Internal$Error = $elm$core$Basics$identity;
var $author$project$Carwow$Bugsnag$addTab = F3(
	function (name, attributes, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				bS: A3($elm$core$Dict$insert, name, attributes, error.bS)
			});
	});
var $author$project$Carwow$Bugsnag$Http$addContextTab = function (context) {
	return A2(
		$author$project$Carwow$Bugsnag$addTab,
		'context',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'method',
				$author$project$Carwow$Bugsnag$Internal$String(context.d6)),
				_Utils_Tuple2(
				'url',
				$author$project$Carwow$Bugsnag$Internal$String(context.aO)),
				_Utils_Tuple2(
				'headers',
				$author$project$Carwow$Bugsnag$Internal$List(context.cE))
			]));
};
var $author$project$Carwow$Bugsnag$addMessage = F2(
	function (message, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				bR: A2(
					$elm$core$List$append,
					error.bR,
					_List_fromArray(
						[message]))
			});
	});
var $author$project$Carwow$Bugsnag$Internal$Int = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Bugsnag$Http$addResponseTab = function (response) {
	return A2(
		$author$project$Carwow$Bugsnag$addTab,
		'response',
		_List_fromArray(
			[
				_Utils_Tuple2(
				'status',
				$author$project$Carwow$Bugsnag$Internal$Int(response.dl)),
				_Utils_Tuple2(
				'headers',
				$author$project$Carwow$Bugsnag$Internal$List(response.cE)),
				_Utils_Tuple2(
				'body',
				$author$project$Carwow$Bugsnag$Internal$String(response.co))
			]));
};
var $author$project$Carwow$Bugsnag$groupBy = F2(
	function (group, _v0) {
		var error = _v0;
		return _Utils_update(
			error,
			{
				bG: A2($elm$core$List$cons, group, error.bG)
			});
	});
var $author$project$Carwow$Bugsnag$newError = function (error) {
	return {dS: error, dY: $elm$core$Maybe$Nothing, bG: _List_Nil, bR: _List_Nil, bS: $elm$core$Dict$empty};
};
var $author$project$Carwow$Bugsnag$Http$newError = F2(
	function (group, error) {
		return A2(
			$author$project$Carwow$Bugsnag$groupBy,
			group,
			function () {
				switch (error.$) {
					case 0:
						var url = error.a;
						var context = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								url,
								$author$project$Carwow$Bugsnag$newError('Http.BadUrl')));
					case 1:
						var context = error.a;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								context.aO,
								$author$project$Carwow$Bugsnag$newError('Http.Timeout')));
					case 2:
						var context = error.a;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addContextTab,
							context,
							A2(
								$author$project$Carwow$Bugsnag$addMessage,
								context.aO,
								$author$project$Carwow$Bugsnag$newError('Http.NetworkError')));
					case 3:
						var response = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addResponseTab,
							response,
							A2(
								$author$project$Carwow$Bugsnag$Http$addContextTab,
								response.aR,
								A2(
									$author$project$Carwow$Bugsnag$addMessage,
									response.co,
									A2(
										$author$project$Carwow$Bugsnag$addMessage,
										response.aR.aO,
										$author$project$Carwow$Bugsnag$newError(
											'Http.BadStatus: ' + $elm$core$String$fromInt(response.dl))))));
					default:
						var errorMessage = error.a;
						var response = error.b;
						return A2(
							$author$project$Carwow$Bugsnag$Http$addResponseTab,
							response,
							A2(
								$author$project$Carwow$Bugsnag$Http$addContextTab,
								response.aR,
								A2(
									$author$project$Carwow$Bugsnag$addMessage,
									errorMessage,
									A2(
										$author$project$Carwow$Bugsnag$addMessage,
										response.aR.aO,
										$author$project$Carwow$Bugsnag$newError('Http.BadBody')))));
				}
			}());
	});
var $author$project$Carwow$Bugsnag$bugsnagNotify = _Platform_outgoingPort('bugsnagNotify', $elm$core$Basics$identity);
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Carwow$Bugsnag$Internal$encodeValue = function (value) {
	switch (value.$) {
		case 0:
			var string = value.a;
			return $elm$json$Json$Encode$string(string);
		case 1:
			var _int = value.a;
			return $elm$json$Json$Encode$int(_int);
		default:
			var list = value.a;
			return A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(list));
	}
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Carwow$Bugsnag$Internal$encodeValueList = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Encode$object,
	$elm$core$List$map(
		$elm$core$Tuple$mapSecond($author$project$Carwow$Bugsnag$Internal$encodeValue)));
var $author$project$Carwow$Bugsnag$Internal$encodeError = function (_v0) {
	var error = _v0;
	var errorWithGroups = function () {
		var _v1 = error.bG;
		if (!_v1.b) {
			return error.dS;
		} else {
			return A2(
				$elm$core$String$join,
				' @ ',
				_List_fromArray(
					[
						error.dS,
						A2($elm$core$String$join, ', ', error.bG)
					]));
		}
	}();
	var groupingHash = A2($elm$core$Maybe$withDefault, errorWithGroups, error.dY);
	var message = A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$cons, errorWithGroups, error.bR));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(message)),
				_Utils_Tuple2(
				'groupingHash',
				$elm$json$Json$Encode$string(groupingHash)),
				_Utils_Tuple2(
				'metaData',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Carwow$Bugsnag$Internal$encodeValueList, error.bS))
			]));
};
var $author$project$Carwow$Bugsnag$notify = A2($elm$core$Basics$composeR, $author$project$Carwow$Bugsnag$Internal$encodeError, $author$project$Carwow$Bugsnag$bugsnagNotify);
var $author$project$Carwow$Bugsnag$Http$notify = F2(
	function (group, error) {
		return $author$project$Carwow$Bugsnag$notify(
			A2($author$project$Carwow$Bugsnag$Http$newError, group, error));
	});
var $author$project$Navigation$modifyUrl = _Platform_outgoingPort('modifyUrl', $elm$json$Json$Encode$string);
var $author$project$Carwow$Search$requestWithDecoder = F4(
	function (buildUrl, msg, _v0, requestDecoder) {
		var response = _v0;
		var url = buildUrl(
			$author$project$Carwow$Search$encode(response));
		var modifyUrl = response.T ? $author$project$Navigation$modifyUrl(url) : $elm$core$Platform$Cmd$none;
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					modifyUrl,
					A3(
					$author$project$Carwow$Http$fetchJson,
					requestDecoder(response),
					msg,
					A2(
						$author$project$Carwow$Http$path,
						_List_fromArray(
							[url]),
						response.P))
				]));
	});
var $author$project$Carwow$Search$request = F3(
	function (buildUrl, msg, response) {
		return A4($author$project$Carwow$Search$requestWithDecoder, buildUrl, msg, response, $author$project$Carwow$Search$decoder);
	});
var $author$project$Carwow$StockSearch$scrollTo = _Platform_outgoingPort('scrollTo', $elm$json$Json$Encode$string);
var $author$project$Carwow$StockSearch$scrollToStockCar = function (model) {
	return (model.aE === '') ? $elm$core$Platform$Cmd$none : $author$project$Carwow$StockSearch$scrollTo(model.aE);
};
var $author$project$Carwow$Search$Filters$syncFilter = F2(
	function (maybePrev, next) {
		if (!maybePrev.$) {
			var prev = maybePrev.a;
			return _Utils_update(
				next,
				{D: prev.D, z: prev.z});
		} else {
			return next;
		}
	});
var $author$project$Carwow$Search$Filters$sync = F2(
	function (_v0, _v1) {
		var prev = _v0;
		var next = _v1;
		return _Utils_update(
			next,
			{
				a: A2(
					$elm$core$Dict$map,
					function (key) {
						return $author$project$Carwow$Search$Filters$syncFilter(
							A2($elm$core$Dict$get, key, prev.a));
					},
					next.a)
			});
	});
var $author$project$Carwow$Search$SortOrder$sync = F2(
	function (_v0, _v1) {
		var prev = _v0;
		var next = _v1;
		return _Utils_update(
			next,
			{D: prev.D});
	});
var $author$project$Carwow$Search$sync = F2(
	function (_v0, _v1) {
		var prev = _v0;
		var next = _v1;
		return (_Utils_cmp(prev.an, next.an) > 0) ? prev : _Utils_update(
			next,
			{
				a: A2($author$project$Carwow$Search$Filters$sync, prev.a, next.a),
				h: A2($author$project$Carwow$Search$SortOrder$sync, prev.h, next.h)
			});
	});
var $author$project$Carwow$StockSearch$PrismicPreview$toQueryParams = function (prismicPreview) {
	if (prismicPreview.$ === 1) {
		return _List_Nil;
	} else {
		var documentId = prismicPreview.a.aV;
		var token = prismicPreview.a.bh;
		var pageSelection = prismicPreview.a.a6;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'documentId', documentId)),
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'token', token)),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('page_selection'),
					pageSelection)
				]));
	}
};
var $author$project$Carwow$Theme$ChipDropdown$isOpen = function (_v0) {
	var state = _v0.a;
	if (!state) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Carwow$Search$Filters$toggleChangeValue = F2(
	function (toggle, filter) {
		var openString = function (isOpen) {
			return isOpen ? 'open' : 'close';
		};
		if (toggle.$ === 1) {
			return _Utils_Tuple2(
				'expander',
				openString(filter.z));
		} else {
			return _Utils_Tuple2(
				'chip',
				openString(
					$author$project$Carwow$Theme$ChipDropdown$isOpen(filter.D)));
		}
	});
var $author$project$Carwow$Search$Filters$toggleChange = F3(
	function (change, key, _v0) {
		var filters = _v0;
		if (!change.$) {
			var toggle = change.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Carwow$Search$Filters$toggleChangeValue(toggle),
				$elm$core$List$head(
					A2(
						$author$project$Carwow$Search$Filters$getFilters,
						filters,
						_List_fromArray(
							[key]))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Carwow$Search$trackFilterToggle = F4(
	function (type_, open, key, context) {
		return $author$project$Carwow$Analytics$TrackableEvent$track(
			A2(
				$author$project$Carwow$Analytics$TrackableEvent$withParams,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(type_)),
							_Utils_Tuple2(
							'key',
							$elm$json$Json$Encode$string(key)),
							_Utils_Tuple2(
							'open',
							$elm$json$Json$Encode$string(open))
						])),
				$author$project$Carwow$Analytics$TrackableEvent$init(context + ' Toggle Filter')));
	});
var $author$project$Carwow$Search$Filters$getFilterValues = F2(
	function (keys, _v0) {
		var filters = _v0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, dict) {
					var k = _v1.a;
					var v = _v1.b;
					return A3($elm$core$Dict$insert, k, v, dict);
				}),
			$elm$core$Dict$empty,
			A2(
				$elm$core$List$map,
				function (f) {
					return _Utils_Tuple2(
						f.u,
						filters.ek(f.g));
				},
				A2($author$project$Carwow$Search$Filters$getFilters, filters, keys)));
	});
var $author$project$Carwow$Search$trackingEvent = F3(
	function (category, context, values) {
		return $author$project$Carwow$Analytics$TrackableEvent$track(
			A2(
				$author$project$Carwow$Analytics$TrackableEvent$withParams,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'category',
							$elm$json$Json$Encode$string(category)),
							_Utils_Tuple2(
							'selection',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, values))
						])),
				$author$project$Carwow$Analytics$TrackableEvent$init(context + ' Filtering')));
	});
var $author$project$Carwow$Search$trackFilterValueChanged = F3(
	function (filters, key, context) {
		var changed = A2(
			$elm$core$Dict$get,
			key,
			A2(
				$author$project$Carwow$Search$Filters$getFilterValues,
				$elm$core$List$singleton(key),
				filters));
		if (!changed.$) {
			var values = changed.a;
			return A3($author$project$Carwow$Search$trackingEvent, key, context, values);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Carwow$Search$trackFilterChange = F4(
	function (filters, key, change, context) {
		var maybeToggleChange = A3($author$project$Carwow$Search$Filters$toggleChange, change, key, filters);
		if (!maybeToggleChange.$) {
			var _v1 = maybeToggleChange.a;
			var type_ = _v1.a;
			var open = _v1.b;
			return A4($author$project$Carwow$Search$trackFilterToggle, type_, open, key, context);
		} else {
			return A3($author$project$Carwow$Search$trackFilterValueChanged, filters, key, context);
		}
	});
var $author$project$Carwow$Search$trackPaginationChange = F2(
	function (_v0, context) {
		var currentPage = _v0.au;
		return A3(
			$author$project$Carwow$Search$trackingEvent,
			'pagination',
			context,
			_List_fromArray(
				[
					$elm$core$String$fromInt(currentPage)
				]));
	});
var $author$project$Carwow$Search$SortOrder$trackChange = F3(
	function (_v0, track, change) {
		if (change.$ === 1) {
			var key = change.a;
			return track(
				_List_fromArray(
					[key]));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Carwow$Search$trackSortChange = F3(
	function (sortOrder, sortChange, context) {
		return A3(
			$author$project$Carwow$Search$SortOrder$trackChange,
			sortOrder,
			A2($author$project$Carwow$Search$trackingEvent, 'sort', context),
			sortChange);
	});
var $author$project$Carwow$Search$trackChange = F2(
	function (_v0, change) {
		var filters = _v0.a;
		var context = _v0.aR;
		var sortOrder = _v0.h;
		switch (change.$) {
			case 0:
				var key = change.a;
				var filterChange = change.b;
				return A4($author$project$Carwow$Search$trackFilterChange, filters, key, filterChange, context);
			case 1:
				var paginationProperties = change.a;
				return A2($author$project$Carwow$Search$trackPaginationChange, paginationProperties, context);
			default:
				var sortChange = change.a;
				return A3($author$project$Carwow$Search$trackSortChange, sortOrder, sortChange, context);
		}
	});
var $author$project$Carwow$StockSearch$trackRecommendations = F2(
	function (model, firingTrigger) {
		var page = 1;
		var count = $elm$core$List$length(model.W);
		return $author$project$Carwow$Analytics$TrackableEvent$track(
			A5($author$project$Carwow$StockSearch$buildResultsEvent, 'recommendations', count, count, page, firingTrigger));
	});
var $author$project$Carwow$StockSearch$Recommendations$handleResponse = function (response) {
	if (!response.$) {
		var body = response.a.co;
		return _Utils_Tuple2(body, $elm$core$Platform$Cmd$none);
	} else {
		var error = response.a;
		return _Utils_Tuple2(
			_List_Nil,
			A2($author$project$Carwow$Bugsnag$Http$notify, 'ReceiveRecommendations', error));
	}
};
var $author$project$Carwow$StockSearch$Recommendations$update = function (msg) {
	var response = msg;
	return $author$project$Carwow$StockSearch$Recommendations$handleResponse(response);
};
var $author$project$Carwow$StockSearch$update = F2(
	function (message, model) {
		switch (message.$) {
			case 9:
				var locationJson = message.a;
				var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Carwow$StockSearch$locationDecoder, locationJson);
				if (!_v1.$) {
					var location = _v1.a;
					var url = function (queryParams) {
						return A2($elm$url$Url$Builder$relative, _List_Nil, queryParams);
					};
					var request = A2($author$project$Carwow$Search$request, url, $author$project$Carwow$StockSearch$ReceiveResponse);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								E: $elm$core$Maybe$Just(location)
							}),
						request(model.d));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{E: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				var change = message.a;
				var url = function (queryParams) {
					return A2(
						$elm$url$Url$Builder$relative,
						_List_Nil,
						_Utils_ap(
							queryParams,
							$author$project$Carwow$StockSearch$PrismicPreview$toQueryParams(model.a9)));
				};
				var request = A2($author$project$Carwow$Search$request, url, $author$project$Carwow$StockSearch$ReceiveResponse);
				var loading = $author$project$Carwow$StockSearch$isLoading(change);
				var _v2 = A3($author$project$Carwow$Search$applyChange, request, change, model.d);
				var filters = _v2.a;
				var cmd = _v2.b;
				var newModel = _Utils_update(
					model,
					{S: loading, d: filters});
				var trackingCmd = A2($author$project$Carwow$Search$trackChange, filters, change);
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[trackingCmd, cmd])));
			case 5:
				var result = message.a;
				var searchData = A2(
					$author$project$Carwow$Search$sync,
					model.d,
					A2(
						$elm$core$Result$withDefault,
						model.d,
						A2(
							$elm$core$Result$map,
							function ($) {
								return $.co;
							},
							result)));
				var notifyOnError = function () {
					if (!result.$) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var error = result.a;
						return A2($author$project$Carwow$Bugsnag$Http$notify, 'ReceiveResponse', error);
					}
				}();
				var newModel = _Utils_update(
					model,
					{S: false, W: _List_Nil, d: searchData});
				var cmds = _List_fromArray(
					[
						$author$project$Carwow$StockSearch$scrollTo('stock-results'),
						A2($author$project$Carwow$StockSearch$updateRecommendations, newModel, 1),
						A2($author$project$Carwow$StockSearch$trackSearchResults, newModel, 1),
						notifyOnError
					]);
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds));
			case 6:
				var pathSegments = A2(
					$elm$core$List$filter,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
					A2($elm$core$String$split, '/', model.aq));
				var url = function (_v4) {
					var queryParams = _Utils_ap(
						_List_Nil,
						$author$project$Carwow$StockSearch$PrismicPreview$toQueryParams(model.a9));
					return A3($elm$url$Url$Builder$crossOrigin, model.ap, pathSegments, queryParams);
				};
				var request = A2($author$project$Carwow$Search$request, url, $author$project$Carwow$StockSearch$ReceiveResponse);
				return _Utils_Tuple2(
					model,
					request(model.d));
			case 1:
				var openFilterKeys = message.a;
				var trackableEvent = $author$project$Carwow$Analytics$TrackableEvent$track(
					$author$project$Carwow$Analytics$TrackableEvent$init('Stock Deals Show All Filters'));
				var data = A2(
					$author$project$Carwow$Search$openFilters,
					openFilterKeys,
					$author$project$Carwow$Search$closeAllFilters(model.d));
				var _v5 = $author$project$Carwow$Theme$Modal$open(model.K);
				var modal = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{K: modal, d: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[trackableEvent, cmd])));
			case 2:
				var _v6 = $author$project$Carwow$Theme$Modal$close(model.K);
				var modal = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{K: modal}),
					cmd);
			case 7:
				var newSearchData = $author$project$Carwow$Search$closeSort(
					$author$project$Carwow$Search$closeChipFilters(model.d));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d: newSearchData}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var firingTrigger = message.a;
				var msg = message.b;
				var _v7 = $author$project$Carwow$StockSearch$Recommendations$update(msg);
				var recommendations = _v7.a;
				var newModel = _Utils_update(
					model,
					{W: recommendations});
				return _Utils_Tuple2(
					newModel,
					A2($author$project$Carwow$StockSearch$trackRecommendations, newModel, firingTrigger));
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: 2, aE: ''}),
					$author$project$Carwow$StockSearch$scrollToStockCar(model));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Carwow$StockSearch$ChangeResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Carwow$Theme$Modal$Config = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$Modal$Left = 0;
var $author$project$Carwow$Theme$Modal$alignDrawerLeft = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{aW: 0});
};
var $author$project$Carwow$StockSearch$allFilterKeys = _List_fromArray(
	['stock_type', 'supplier_distance', 'make_slug', 'model_slug', 'body_types_slug', 'trim_slug', 'budget', 'transmission_long', 'fuel_long_simplified', 'age', 'mileage', 'cc', 'generic_colour', 'doors_simplified', 'seats_number', 'safety_rating']);
var $author$project$Carwow$Theme$Modal$Drawer = 1;
var $author$project$Carwow$Theme$Modal$asDrawer = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{I: 1});
};
var $author$project$Carwow$Theme$Modal$Body = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Carwow$Theme$Modal$DefaultCloseButton = {$: 0};
var $author$project$Carwow$Theme$Modal$DefaultStyle = 0;
var $author$project$Carwow$Theme$Modal$Header = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Carwow$Theme$Modal$Light = 0;
var $author$project$Carwow$Theme$Modal$NoFooter = {$: 2};
var $author$project$Carwow$Theme$Modal$NoSecondaryAction = {$: 1};
var $author$project$Carwow$Theme$Modal$NoTitle = {$: 2};
var $author$project$Carwow$Theme$Modal$Padding = 0;
var $author$project$Carwow$Theme$Modal$ResetScroll = 0;
var $author$project$Carwow$Theme$Modal$Right = 1;
var $author$project$Carwow$Theme$Modal$defaultConfig = function (msg) {
	return {
		co: A3($author$project$Carwow$Theme$Modal$Body, 0, 0, _List_Nil),
		aU: msg,
		aW: 1,
		aY: $author$project$Carwow$Theme$Modal$NoFooter,
		t: A3($author$project$Carwow$Theme$Modal$Header, $author$project$Carwow$Theme$Modal$NoSecondaryAction, $author$project$Carwow$Theme$Modal$NoTitle, $author$project$Carwow$Theme$Modal$DefaultCloseButton),
		z: $elm$core$Maybe$Nothing,
		I: 0,
		al: 0
	};
};
var $author$project$Carwow$Theme$Modal$NoPadding = 1;
var $author$project$Carwow$Theme$Modal$noBodyPadding = function (_v0) {
	var config = _v0;
	var _v1 = config.co;
	var scroll = _v1.b;
	var body = _v1.c;
	return _Utils_update(
		config,
		{
			co: A3($author$project$Carwow$Theme$Modal$Body, 1, scroll, body)
		});
};
var $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$fetching = 'Suchen...';
var $cuducos$elm_format_number$FormatNumber$Locales$spanishLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		dK: ',',
		dL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(3),
		es: '.'
	});
var $author$project$ThemeTranslations$Numbers$formatNumber = F2(
	function (x, precision) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$format,
			_Utils_update(
				$cuducos$elm_format_number$FormatNumber$Locales$spanishLocale,
				{
					dL: $cuducos$elm_format_number$FormatNumber$Locales$Exact(precision)
				}),
			x);
	});
var $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$one = 'Ein Fahrzeug anzeigen';
var $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$other = function (total_results) {
	return '' + (total_results + ' Treffer anzeigen');
};
var $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$zero = 'Keine verfügbaren Fahrzeuge';
var $author$project$Carwow$StockSearch$renderModalFooter = F2(
	function (model, buttonClass) {
		var totalCars = $author$project$Carwow$StockSearch$resultsCount(model);
		var totalCarsLabel = model.S ? $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$fetching : ((!totalCars) ? $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$zero : ((totalCars === 1) ? $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$one : $author$project$AutomaticTranslations$StockSearch$Filters$ViewResults$other(
			A2($author$project$ThemeTranslations$Numbers$formatNumber, totalCars, 0))));
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(buttonClass),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('btn--disabled', model.S || (!totalCars))
						])),
					$elm$html$Html$Events$onClick($author$project$Carwow$StockSearch$CloseFiltersModal)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(totalCarsLabel)
				]));
	});
var $author$project$Carwow$Theme$Modal$Fullscreen = 2;
var $author$project$Carwow$Theme$Modal$resetScrollAttribute = function (scroll) {
	if (!scroll) {
		return _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'data-modal-reset-scroll', 'true')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Theme$Modal$themeModifier = function (theme) {
	if (!theme) {
		return '--light-theme';
	} else {
		return '--dark-theme';
	}
};
var $author$project$Carwow$Theme$Modal$bodyView = F3(
	function (style, _v0, theme) {
		var padding = _v0.a;
		var scroll = _v0.b;
		var body = _v0.c;
		var baseClass = 'modal__body';
		var classWithModifier = _Utils_ap(
			baseClass,
			$author$project$Carwow$Theme$Modal$themeModifier(theme));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal__body'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal__body--no-padding', padding === 1),
										_Utils_Tuple2(
										'modal__body--drawer',
										A2(
											$elm$core$List$member,
											style,
											_List_fromArray(
												[1]))),
										_Utils_Tuple2('modal__body--fullscreen', style === 2),
										_Utils_Tuple2(baseClass, true),
										_Utils_Tuple2(classWithModifier, true)
									])),
								A2($elm$html$Html$Attributes$attribute, 'data-modal-content-body', 'true')
							]),
							$author$project$Carwow$Theme$Modal$resetScrollAttribute(scroll)
						])),
				body)
			]);
	});
var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $author$project$Carwow$Theme$Modal$closeInput = F2(
	function (dismiss, _v0) {
		var modalId = _v0.a;
		var state = _v0.b;
		return A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal-radio-button--close'),
					$elm$html$Html$Attributes$name(modalId),
					$elm$html$Html$Attributes$type_('radio'),
					$elm$html$Html$Attributes$hidden(true),
					$elm$html$Html$Attributes$checked(state === 1),
					$elm$html$Html$Attributes$id(modalId + '-close'),
					$elm$html$Html$Events$onClick(dismiss)
				]),
			_List_Nil);
	});
var $author$project$Carwow$Theme$Modal$footerView = F3(
	function (style, footer, theme) {
		switch (footer.$) {
			case 0:
				var content = footer.a;
				var baseClass = 'modal__footer';
				var classWithModifier = _Utils_ap(
					baseClass,
					$author$project$Carwow$Theme$Modal$themeModifier(theme));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'modal__footer--drawer',
										A2(
											$elm$core$List$member,
											style,
											_List_fromArray(
												[1]))),
										_Utils_Tuple2(baseClass, true),
										_Utils_Tuple2(classWithModifier, true)
									]))
							]),
						content)
					]);
			case 1:
				var content = footer.a;
				return content;
			default:
				return _List_Nil;
		}
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Carwow$Theme$Svgs$iconWithExtraClass = F3(
	function (iconName, iconProperties, extraClass) {
		var sizeClass = ' inline-icon--' + iconProperties.dj;
		var colourClass = ' inline-icon--' + iconProperties.cr;
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$version('1.1'),
					$elm$svg$Svg$Attributes$class('inline-icon' + (sizeClass + (colourClass + (' ' + extraClass)))),
					$elm$svg$Svg$Attributes$viewBox('0 0 24 24')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$use,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$xlinkHref('#sprite_icon/' + iconName)
						]),
					_List_Nil)
				]));
	});
var $author$project$Carwow$Theme$Svgs$icon = F2(
	function (iconName, iconProperties) {
		return A3($author$project$Carwow$Theme$Svgs$iconWithExtraClass, iconName, iconProperties, '');
	});
var $author$project$Carwow$Theme$Modal$closeButtonView = F4(
	function (dismiss, closeButton, theme, modalId) {
		var iconColour = function () {
			if (!theme) {
				return 'black';
			} else {
				return 'white';
			}
		}();
		switch (closeButton.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$for(modalId + '-close'),
								$elm$html$Html$Attributes$class('modal__header-button modal__close-icon')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Carwow$Theme$Svgs$icon,
								'close_b',
								{cr: iconColour, dj: 'small'})
							]))
					]);
			case 1:
				var button = closeButton.a;
				return button;
			default:
				return _List_Nil;
		}
	});
var $author$project$Carwow$Theme$Modal$secondaryActionView = function (action) {
	if (!action.$) {
		var content = action.a;
		return content;
	} else {
		return _List_Nil;
	}
};
var $author$project$Carwow$Theme$Modal$titleView = F2(
	function (action, title) {
		switch (title.$) {
			case 0:
				var content = title.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal__title'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'modal__title--centered',
										!_Utils_eq(action, $author$project$Carwow$Theme$Modal$NoSecondaryAction))
									]))
							]),
						content)
					]);
			case 1:
				var content = title.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal__title modal__title--centered')
							]),
						content)
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Carwow$Theme$Modal$headerView = F5(
	function (style, dismiss, header, theme, modalId) {
		if (!header.$) {
			var action = header.a;
			var title = header.b;
			var closeButton = header.c;
			var baseClass = 'modal__header';
			var classWithModifier = _Utils_ap(
				baseClass,
				$author$project$Carwow$Theme$Modal$themeModifier(theme));
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'modal__header--with-border',
									!_Utils_eq(title, $author$project$Carwow$Theme$Modal$NoTitle)),
									_Utils_Tuple2(
									'modal__header--drawer',
									A2(
										$elm$core$List$member,
										style,
										_List_fromArray(
											[1]))),
									_Utils_Tuple2(baseClass, true),
									_Utils_Tuple2(classWithModifier, true)
								]))
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								$author$project$Carwow$Theme$Modal$secondaryActionView(action),
								A2($author$project$Carwow$Theme$Modal$titleView, action, title),
								A4($author$project$Carwow$Theme$Modal$closeButtonView, dismiss, closeButton, theme, modalId)
							])))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Carwow$Theme$Modal$openInput = F2(
	function (maybeMsg, _v0) {
		var modalId = _v0.a;
		var state = _v0.b;
		var maybeOnClick = function () {
			if (!maybeMsg.$) {
				var msg = maybeMsg.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$id(modalId + '-open'),
						$elm$html$Html$Events$onClick(msg)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$input,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-radio-button--open'),
						$elm$html$Html$Attributes$name(modalId),
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$hidden(true),
						$elm$html$Html$Attributes$checked(!state),
						$elm$html$Html$Attributes$id(modalId + '-open'),
						A2($elm$html$Html$Attributes$attribute, 'data-open-modal-input', 'true')
					]),
				maybeOnClick),
			_List_Nil);
	});
var $author$project$Carwow$Theme$Modal$overlayCancel = F2(
	function (dismiss, modalId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(modalId + '-close'),
						$elm$html$Html$Attributes$class('modal-overlay__cancel'),
						$elm$html$Html$Events$onClick(dismiss)
					]),
				_List_Nil)
			]);
	});
var $author$project$Carwow$Theme$Modal$overlay = F3(
	function (dismiss, modalId, modal) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(modalId),
					$elm$html$Html$Attributes$class('modal-overlay')
				]),
			_Utils_ap(
				A2($author$project$Carwow$Theme$Modal$overlayCancel, dismiss, modalId),
				_List_fromArray(
					[modal])));
	});
var $author$project$Carwow$Theme$Modal$view = F2(
	function (_v0, modal) {
		var config = _v0;
		var modalId = modal.a;
		var isDrawer = config.I === 1;
		var baseClass = 'modal';
		var classWithModifier = _Utils_ap(
			baseClass,
			$author$project$Carwow$Theme$Modal$themeModifier(config.al));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Carwow$Theme$Modal$openInput, config.z, modal),
					A2($author$project$Carwow$Theme$Modal$closeInput, config.aU, modal),
					A3(
					$author$project$Carwow$Theme$Modal$overlay,
					config.aU,
					modalId,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(baseClass),
								$elm$html$Html$Attributes$class(classWithModifier),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('modal--drawer', config.I === 1),
										_Utils_Tuple2('modal--fullscreen', config.I === 2),
										_Utils_Tuple2('modal--drawer-left', isDrawer && (!config.aW)),
										_Utils_Tuple2('modal--drawer-right', isDrawer && (config.aW === 1))
									]))
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									A5($author$project$Carwow$Theme$Modal$headerView, config.I, config.aU, config.t, config.al, modalId),
									A3($author$project$Carwow$Theme$Modal$bodyView, config.I, config.co, config.al),
									A3($author$project$Carwow$Theme$Modal$footerView, config.I, config.aY, config.al)
								]))))
				]));
	});
var $author$project$Carwow$StockSearch$ClearFilters = {$: 6};
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$AutomaticTranslations$StockSearch$Filters$clearAll = 'Alle Filter löschen';
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Carwow$HtmlSafe$onClickNoHref = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			$elm$json$Json$Decode$succeed(msg),
			$elm$json$Json$Decode$succeed(true)));
};
var $author$project$Carwow$StockSearch$viewClearAll = function (className) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(className),
				$elm$html$Html$Attributes$href('#'),
				$author$project$Carwow$HtmlSafe$onClickNoHref($author$project$Carwow$StockSearch$ClearFilters)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$Filters$clearAll)
			]));
};
var $author$project$Carwow$Search$ChangeFilter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Carwow$Search$Filters$filtersNotPresent = F2(
	function (keys, _v0) {
		var filters = _v0;
		return $elm$core$List$isEmpty(
			A2($author$project$Carwow$Search$Filters$getFilters, filters, keys));
	});
var $author$project$Carwow$Search$Filters$ChangeValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Search$Filters$Expander = {$: 1};
var $author$project$Carwow$Search$Filters$ToggleFilter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Search$Filters$filterHidden = function (filter) {
	return A2($elm$core$Maybe$withDefault, false, filter.aZ);
};
var $author$project$AutomaticTranslations$Search$Filters$selectedFilters = function (number) {
	return '' + (number + ' ausgewählt');
};
var $author$project$Carwow$Search$Filters$pluralizeSelectedValues = function (values) {
	var _v0 = $elm$core$List$length(values);
	switch (_v0) {
		case 0:
			return '';
		case 1:
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(values));
		default:
			return $author$project$AutomaticTranslations$Search$Filters$selectedFilters(
				$elm$core$String$fromInt(
					$elm$core$List$length(values)));
	}
};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $author$project$Carwow$Theme$CssExpander$view = F2(
	function (properties, content) {
		var trackingCategory = properties.z ? 'close expander' : 'open expander';
		var hasCssClass = !_Utils_eq(properties.dH, $elm$core$Maybe$Nothing);
		var cssClass = A2($elm$core$Maybe$withDefault, '', properties.dH);
		var cssClassWithSuffix = function (suffix) {
			return _Utils_ap(cssClass, suffix);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('expandable-content-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(properties.d_),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(properties.z),
							$elm$html$Html$Events$onCheck(properties.dE),
							$elm$html$Html$Attributes$class('expandable-content__checkbox'),
							A2($elm$html$Html$Attributes$attribute, 'data-expander-input', 'true'),
							A2($elm$html$Html$Attributes$attribute, 'data-interaction-element', properties.d_),
							A2($elm$html$Html$Attributes$attribute, 'data-interaction-type', trackingCategory)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('expandable-content', true),
									_Utils_Tuple2(cssClass, hasCssClass)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(properties.d_),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('expandable-content__head', true),
											_Utils_Tuple2(
											cssClassWithSuffix('__head'),
											hasCssClass)
										]))
								]),
							properties.et),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('expandable-content__content', true),
											_Utils_Tuple2(
											cssClassWithSuffix('__content'),
											hasCssClass)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('expandable-content__content-wrapper', true),
													_Utils_Tuple2(
													cssClassWithSuffix('__content-wrapper'),
													hasCssClass)
												]))
										]),
									content)
								]))
						]))
				]));
	});
var $author$project$Carwow$Search$Filters$viewFilter = F3(
	function (config, change, filter) {
		var expanderIconColour = function (value) {
			return $elm$core$String$isEmpty(value) ? 'black' : 'dark-grey';
		};
		var expanderIcon = filter.z ? 'caret_up' : 'caret_down';
		var expanderIconWithValue = function (value) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-filter-expander__current-value')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(value),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('search-filter-expander__caret')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Carwow$Theme$Svgs$icon,
								expanderIcon,
								{
									cr: expanderIconColour(value),
									dj: 'x-small'
								})
							]))
					]));
		};
		return A2(
			$elm$html$Html$map,
			change(filter.u),
			A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('search-filter-expander__list-item', true),
								_Utils_Tuple2(
								'hidden-content',
								$author$project$Carwow$Search$Filters$filterHidden(filter))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Carwow$Theme$CssExpander$view,
						{
							dE: $elm$core$Basics$always(
								$author$project$Carwow$Search$Filters$ToggleFilter($author$project$Carwow$Search$Filters$Expander)),
							dH: $elm$core$Maybe$Just('search-filter-expander'),
							d_: filter.u,
							z: filter.z,
							et: _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(filter.d3)
										])),
									expanderIconWithValue(
									$author$project$Carwow$Search$Filters$pluralizeSelectedValues(
										config.x(filter.g)))
								])
						},
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Carwow$Search$Filters$ChangeValue,
										A2(config.ab, filter.u, filter.g))
									]))
							]))
					])));
	});
var $author$project$Carwow$Search$Filters$visibleFilters = F2(
	function (keys, _v0) {
		var filters = _v0;
		return A2(
			$elm$core$List$filter,
			function (f) {
				return A2($author$project$Carwow$Search$Filters$filterSatisfiesCondition, f, filters);
			},
			A2($author$project$Carwow$Search$Filters$getFilters, filters, keys));
	});
var $author$project$Carwow$Search$Filters$view = F3(
	function (change, keys, _v0) {
		var filters = _v0;
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-unstyled search-filter__list-filters')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Carwow$Search$Filters$viewFilter, filters, change),
				A2($author$project$Carwow$Search$Filters$visibleFilters, keys, filters)));
	});
var $author$project$Carwow$Search$viewFilters = F3(
	function (msg, keys, _v0) {
		var filters = _v0.a;
		return A2($author$project$Carwow$Search$Filters$filtersNotPresent, keys, filters) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$map,
			msg,
			A3($author$project$Carwow$Search$Filters$view, $author$project$Carwow$Search$ChangeFilter, keys, filters));
	});
var $author$project$Carwow$Theme$Modal$withBody = F2(
	function (body, _v0) {
		var config = _v0;
		var _v1 = config.co;
		var padding = _v1.a;
		var scroll = _v1.b;
		return _Utils_update(
			config,
			{
				co: A3($author$project$Carwow$Theme$Modal$Body, padding, scroll, body)
			});
	});
var $author$project$Carwow$Theme$Modal$Footer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Theme$Modal$withFooter = F2(
	function (footer, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				aY: $author$project$Carwow$Theme$Modal$Footer(footer)
			});
	});
var $author$project$Carwow$Theme$Modal$SecondaryAction = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Theme$Modal$withSecondaryAction = F2(
	function (action, _v0) {
		var config = _v0;
		var _v1 = config.t;
		if (!_v1.$) {
			var title = _v1.b;
			var closeButton = _v1.c;
			return _Utils_update(
				config,
				{
					t: A3(
						$author$project$Carwow$Theme$Modal$Header,
						$author$project$Carwow$Theme$Modal$SecondaryAction(action),
						title,
						closeButton)
				});
		} else {
			return config;
		}
	});
var $author$project$Carwow$StockSearch$filtersModalView = function (model) {
	var modalBodyContent = function (keys) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stock-filters-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Carwow$Search$viewFilters, $author$project$Carwow$StockSearch$ChangeResponse, keys, model.d)
				]));
	};
	var config = A2(
		$author$project$Carwow$Theme$Modal$withSecondaryAction,
		_List_fromArray(
			[
				$author$project$Carwow$StockSearch$viewClearAll('btn-link filter-modal__clear-all')
			]),
		A2(
			$author$project$Carwow$Theme$Modal$withFooter,
			_List_fromArray(
				[
					A2($author$project$Carwow$StockSearch$renderModalFooter, model, 'btn btn--bold btn-full-width')
				]),
			A2(
				$author$project$Carwow$Theme$Modal$withBody,
				_List_fromArray(
					[
						modalBodyContent($author$project$Carwow$StockSearch$allFilterKeys)
					]),
				$author$project$Carwow$Theme$Modal$noBodyPadding(
					$author$project$Carwow$Theme$Modal$alignDrawerLeft(
						$author$project$Carwow$Theme$Modal$asDrawer(
							$author$project$Carwow$Theme$Modal$defaultConfig($author$project$Carwow$StockSearch$CloseFiltersModal)))))));
	return A2($author$project$Carwow$Theme$Modal$view, config, model.K);
};
var $author$project$AutomaticTranslations$StockSearch$emptyTitle = 'Lagerfahrzeug-Angebote';
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Carwow$Search$getFilterValues = F2(
	function (keys, _v0) {
		var response = _v0;
		return A2($author$project$Carwow$Search$Filters$getFilterValues, keys, response.a);
	});
var $author$project$Carwow$StockSearch$getMakeModel = function (response) {
	var filterValues = A2(
		$author$project$Carwow$Search$getFilterValues,
		_List_fromArray(
			['make_slug', 'model_slug']),
		response);
	var getValue = function (val) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2($elm$core$Dict$get, val, filterValues)));
	};
	return _Utils_Tuple2(
		getValue('make_slug'),
		getValue('model_slug'));
};
var $author$project$AutomaticTranslations$StockSearch$title = F2(
	function (make_name, model_name) {
		return '' + (make_name + (' ' + (model_name + ' Lagerfahrzeug-Angebote')));
	});
var $author$project$Carwow$StockSearch$pageTitle = function (model) {
	var _v0 = $author$project$Carwow$StockSearch$getMakeModel(model.d);
	var makeName = _v0.a;
	var modelName = _v0.b;
	var title = (makeName === '') ? $author$project$AutomaticTranslations$StockSearch$emptyTitle : A2($author$project$AutomaticTranslations$StockSearch$title, makeName, modelName);
	return title;
};
var $author$project$Carwow$Theme$Header$Config = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$Header$defaultConfig = {bp: true, bv: $elm$core$Maybe$Nothing, cw: $elm$core$Maybe$Nothing};
var $author$project$Carwow$StockSearch$heroId = 'stock-cars-hero';
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Carwow$Theme$Header$view = F2(
	function (title, _v0) {
		var config = _v0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('header', true),
							_Utils_Tuple2('header--with-border', config.bp)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grid-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header__title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							function () {
							var _v1 = config.cw;
							if (!_v1.$) {
								var description = _v1.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header__desc-wrap')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('header__desc')
												]),
											_List_fromArray(
												[description]))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							function () {
							var _v2 = config.bv;
							if (!_v2.$) {
								var customContent = _v2.a;
								return customContent;
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]))
				]));
	});
var $author$project$Carwow$Theme$Header$withDescription = F2(
	function (description, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				cw: $elm$core$Maybe$Just(description)
			});
	});
var $author$project$Carwow$Theme$Header$withoutBorder = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{bp: false});
};
var $author$project$Carwow$StockSearch$renderHeader = F2(
	function (title, subtitleHtml) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id($author$project$Carwow$StockSearch$heroId)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Carwow$Theme$Header$view,
					title,
					A2(
						$author$project$Carwow$Theme$Header$withDescription,
						A3(
							$elm$html$Html$node,
							'render-html',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'html', subtitleHtml)
								]),
							_List_Nil),
						$author$project$Carwow$Theme$Header$withoutBorder($author$project$Carwow$Theme$Header$defaultConfig)))
				]));
	});
var $author$project$AutomaticTranslations$StockSearch$subtitleVariantHtml = 'Alle Fahrzeuge sind <strong>in der Regel innerhalb von 2 Wochen</strong> bereit zur Abholung bei deutschen Vertragshändlern';
var $author$project$Carwow$StockSearch$headerView = function (model) {
	return model.ah ? A2(
		$author$project$Carwow$StockSearch$renderHeader,
		$author$project$Carwow$StockSearch$pageTitle(model),
		$author$project$AutomaticTranslations$StockSearch$subtitleVariantHtml) : $elm$html$Html$text('');
};
var $author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$button = 'Fahrzeug wählen';
var $author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$description = 'Konfiguriere deinen Neuwagen so, wie du es möchtest und lass dir Angebote von Deutschlands besten Vertragshändlern zusenden';
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$title = 'Du kannst das gewünschte Fahrzeug nicht finden?';
var $author$project$Carwow$StockSearch$jumbotronView = function (model) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-cars-jumbotron')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('jumbotron-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('jumbotron')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$title)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$description)
									])),
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('btn'),
										A2($elm$html$Html$Attributes$attribute, 'for', model.af),
										A2($elm$html$Html$Attributes$attribute, 'data-interaction-type', 'cta'),
										A2($elm$html$Html$Attributes$attribute, 'data-element-name', 'Select a car')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$JumbotronChooseModelCta$button)
									]))
							]))
					]))
			]));
};
var $author$project$Carwow$Theme$EmptyState$Config = F4(
	function (title, description, icon, content) {
		return {bu: content, cw: description, bI: icon, et: title};
	});
var $author$project$Carwow$Theme$EmptyState$init = F3(
	function (title, description, emptyStateIcon) {
		return A4($author$project$Carwow$Theme$EmptyState$Config, title, description, emptyStateIcon, $elm$core$Maybe$Nothing);
	});
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Carwow$Theme$EmptyState$view = function (config) {
	var content = function () {
		var _v0 = config.bu;
		if (!_v0.$) {
			var html = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('empty-state__content')
					]),
				_List_fromArray(
					[html]));
		} else {
			return $elm$html$Html$text('');
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('empty-state empty-state--full-width')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('empty-state__media')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('empty-state__confetti')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('empty-state__icon-container')
							]),
						_List_fromArray(
							[config.bI]))
					])),
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('empty-state__title')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.et)
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('empty-state__text')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.cw)
					])),
				content
			]));
};
var $author$project$Carwow$Theme$EmptyState$emptyState = F3(
	function (title, description, emptyStateIcon) {
		return $author$project$Carwow$Theme$EmptyState$view(
			A3($author$project$Carwow$Theme$EmptyState$init, title, description, emptyStateIcon));
	});
var $author$project$AutomaticTranslations$StockSearch$ElmResult$filterText = 'Ändern Sie Ihre Filter oben oder setzen Sie alle Filter zurück.';
var $author$project$AutomaticTranslations$StockSearch$ElmResult$filterTitle = 'Leider entsprechen keine Fahrzeuge Ihrer Suchanfrage.';
var $author$project$Carwow$StockSearch$emptyStateView = A3(
	$author$project$Carwow$Theme$EmptyState$emptyState,
	$author$project$AutomaticTranslations$StockSearch$ElmResult$filterTitle,
	$author$project$AutomaticTranslations$StockSearch$ElmResult$filterText,
	A2(
		$author$project$Carwow$Theme$Svgs$icon,
		'car',
		{cr: 'blue', dj: 'large'}));
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Carwow$Search$ChangePagination = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Theme$Pagination$linkView = F4(
	function (page, content, clickMsg, pagination) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('pagination__page ', true),
							_Utils_Tuple2(
							'pagination__page--active',
							_Utils_eq(pagination.au, page))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('#'),
							$author$project$Carwow$HtmlSafe$onClickNoHref(
							clickMsg(page))
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Carwow$Theme$Pagination$nextLink = F2(
	function (pagination, clickMsg) {
		return (_Utils_cmp(pagination.au, pagination.eA) < 0) ? A4(
			$author$project$Carwow$Theme$Pagination$linkView,
			pagination.au + 1,
			A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'caret_right',
				{cr: 'dark-grey', dj: 'x-small'}),
			clickMsg,
			pagination) : $elm$html$Html$text('');
	});
var $author$project$Carwow$Theme$Pagination$emptyLinkView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('pagination__page')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('…')
		]));
var $elm_community$list_extra$List$Extra$groupWhile = F2(
	function (isSameGroup, items) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					if (!acc.b) {
						return _List_fromArray(
							[
								_Utils_Tuple2(x, _List_Nil)
							]);
					} else {
						var _v1 = acc.a;
						var y = _v1.a;
						var restOfGroup = _v1.b;
						var groups = acc.b;
						return A2(isSameGroup, x, y) ? A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								x,
								A2($elm$core$List$cons, y, restOfGroup)),
							groups) : A2(
							$elm$core$List$cons,
							_Utils_Tuple2(x, _List_Nil),
							acc);
					}
				}),
			_List_Nil,
			items);
	});
var $elm_community$list_extra$List$Extra$group = $elm_community$list_extra$List$Extra$groupWhile($elm$core$Basics$eq);
var $author$project$Carwow$Theme$Pagination$pageLinks = F2(
	function (pagination, clickMsg) {
		var allPages = A2($elm$core$List$range, 1, pagination.eA);
		var middlePages = A2(
			$elm$core$List$map,
			function (page) {
				return ($elm$core$Basics$abs(page - pagination.au) < 2) ? $elm$core$Maybe$Just(page) : $elm$core$Maybe$Nothing;
			},
			allPages);
		var middleAndLimitPages = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$core$Maybe$Just(1)
					]),
					middlePages,
					_List_fromArray(
					[
						$elm$core$Maybe$Just(pagination.eA)
					])
				]));
		var pages = A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			$elm_community$list_extra$List$Extra$group(middleAndLimitPages));
		return A2(
			$elm$core$List$map,
			function (page) {
				if (page.$ === 1) {
					return $author$project$Carwow$Theme$Pagination$emptyLinkView;
				} else {
					var pageNum = page.a;
					return A4(
						$author$project$Carwow$Theme$Pagination$linkView,
						pageNum,
						$elm$html$Html$text(
							$elm$core$String$fromInt(pageNum)),
						clickMsg,
						pagination);
				}
			},
			pages);
	});
var $author$project$Carwow$Theme$Pagination$prevLink = F2(
	function (pagination, clickMsg) {
		return (pagination.au > 1) ? A4(
			$author$project$Carwow$Theme$Pagination$linkView,
			pagination.au - 1,
			A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'caret_left',
				{cr: 'dark-grey', dj: 'x-small'}),
			clickMsg,
			pagination) : $elm$html$Html$text('');
	});
var $author$project$Carwow$Theme$Pagination$view = F2(
	function (pagination, clickMsg) {
		var links = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2($author$project$Carwow$Theme$Pagination$prevLink, pagination, clickMsg)
					]),
					A2($author$project$Carwow$Theme$Pagination$pageLinks, pagination, clickMsg),
					_List_fromArray(
					[
						A2($author$project$Carwow$Theme$Pagination$nextLink, pagination, clickMsg)
					])
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pagination')
				]),
			links);
	});
var $author$project$Carwow$Search$viewPagination = F2(
	function (msg, _v0) {
		var pagination = _v0.p;
		var makeMsg = function (newPage) {
			return msg(
				$author$project$Carwow$Search$ChangePagination(
					_Utils_update(
						pagination,
						{au: newPage})));
		};
		return (pagination.eA > 1) ? A2($author$project$Carwow$Theme$Pagination$view, pagination, makeMsg) : $elm$html$Html$text('');
	});
var $author$project$Carwow$StockSearch$paginationView = function (_v0) {
	var searchData = _v0.d;
	return A2($author$project$Carwow$Search$viewPagination, $author$project$Carwow$StockSearch$ChangeResponse, searchData);
};
var $author$project$Carwow$Theme$Alert$Config = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$Alert$Default = 0;
var $author$project$Carwow$Theme$Alert$defaultConfig = {
	O: 0,
	bI: $elm$core$Maybe$Nothing,
	bQ: $elm$html$Html$text(''),
	et: $elm$core$Maybe$Nothing
};
var $author$project$AutomaticTranslations$StockSearch$Recommendations$elmMessage = function (count) {
	switch (count) {
		case 0:
			return 'Leider sind keine Modelle mit dieser Auswahl verfügbar. Bitte passen Sie die Filter an oder sehen Sie sich die unten aufgeführten Alternativen an.';
		case 1:
			return 'Derzeit passt nur 1 Auto zu Ihrer Auswahl. Vielleicht gefallen Ihnen aber auch unsere unten aufgeführten Alternativen.';
		default:
			return 'Derzeit passen nur ' + ($elm$core$String$fromInt(count) + ' Auto zu Ihrer Auswahl. Vielleicht gefallen Ihnen aber auch unsere unten aufgeführten Alternativen.');
	}
};
var $author$project$AutomaticTranslations$StockSearch$Recommendations$title = 'Ähnliche Fahrzeuge auf Lager';
var $author$project$Carwow$Theme$Alert$Error = 1;
var $author$project$Carwow$Theme$Alert$Success = 3;
var $author$project$Carwow$Theme$Alert$Tip = 2;
var $author$project$Carwow$Theme$Alert$Warning = 4;
var $author$project$Carwow$Theme$Alert$categoryClass = function (category) {
	return _List_fromArray(
		[
			_Utils_Tuple2('note--error', category === 1),
			_Utils_Tuple2('note--tip', category === 2),
			_Utils_Tuple2('note--warning', category === 4),
			_Utils_Tuple2('note--success', category === 3),
			_Utils_Tuple2('note--neutral', !category)
		]);
};
var $author$project$Carwow$Theme$Alert$iconColor = function (category) {
	switch (category) {
		case 1:
			return 'red';
		case 4:
			return 'yellow';
		case 3:
			return 'green';
		default:
			return 'blue';
	}
};
var $author$project$Carwow$Theme$Alert$viewIcon = function (_v0) {
	var config = _v0;
	var _v1 = config.bI;
	if (!_v1.$) {
		var slug = _v1.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('note__icon')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Carwow$Theme$Svgs$icon,
					slug,
					{
						cr: $author$project$Carwow$Theme$Alert$iconColor(config.O),
						dj: 'medium'
					})
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Carwow$Theme$Alert$view = function (_v0) {
	var config = _v0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2('note', true)
						]),
					$author$project$Carwow$Theme$Alert$categoryClass(config.O)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('note__content')
					]),
				_List_fromArray(
					[
						$author$project$Carwow$Theme$Alert$viewIcon(config),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('note__body')
							]),
						_List_fromArray(
							[
								function () {
								var _v1 = config.et;
								if (!_v1.$) {
									var title = _v1.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('note__heading')
											]),
										_List_fromArray(
											[title]));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								config.bQ
							]))
					]))
			]));
};
var $author$project$Carwow$Theme$Alert$withMessage = F2(
	function (message, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bQ: message});
	});
var $author$project$Carwow$StockSearch$Recommendations$view = F3(
	function (recommendations, resultsCount, renderCard) {
		var alert = $author$project$Carwow$Theme$Alert$view(
			A2(
				$author$project$Carwow$Theme$Alert$withMessage,
				$elm$html$Html$text(
					$author$project$AutomaticTranslations$StockSearch$Recommendations$elmMessage(resultsCount)),
				$author$project$Carwow$Theme$Alert$defaultConfig));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('stock-car-search-recommendations')
				]),
			_List_fromArray(
				[
					alert,
					A2(
					$elm$html$Html$h5,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stock-car-search-recommendations-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$Recommendations$title)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stock-car-search-results-container')
						]),
					_List_fromArray(
						[
							A3(
							$elm$html$Html$Keyed$node,
							'div',
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stock-car-search-results')
								]),
							A2($elm$core$List$map, renderCard, recommendations))
						]))
				]));
	});
var $author$project$Carwow$StockSearch$recommendationsView = function (model) {
	return ($elm$core$List$length(model.W) > 0) ? A3(
		$author$project$Carwow$StockSearch$Recommendations$view,
		model.W,
		$author$project$Carwow$StockSearch$resultsCount(model),
		model.bb(model.E)) : $elm$html$Html$text('');
};
var $author$project$Carwow$StockSearch$OpenFiltersModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Search$Filters$selectedFilterCountByType = F2(
	function (keys, _v0) {
		var filters = _v0;
		var allSelectedFilterCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (f) {
					return $elm$core$List$length(
						filters.x(f.g)) > 0;
				},
				A2(
					$elm$core$List$filter,
					function (f) {
						return !_Utils_eq(
							f.aZ,
							$elm$core$Maybe$Just(true));
					},
					A2($author$project$Carwow$Search$Filters$getFilters, filters, keys))));
		return allSelectedFilterCount;
	});
var $author$project$Carwow$Search$selectedFilterCountByType = F2(
	function (keys, _v0) {
		var response = _v0;
		return A2($author$project$Carwow$Search$Filters$selectedFilterCountByType, keys, response.a);
	});
var $author$project$Carwow$StockSearch$viewSelectedCount = function (count) {
	if (!count) {
		return _List_fromArray(
			[
				A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'filters',
				{cr: 'black', dj: 'x-small'})
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'filters',
				{cr: 'black', dj: 'x-small'}),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stock-filters__selected-count')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(count))
					]))
			]);
	}
};
var $author$project$Carwow$StockSearch$filterBtnLabel = function (model) {
	var totalSelectedCount = A2($author$project$Carwow$Search$selectedFilterCountByType, $author$project$Carwow$StockSearch$allFilterKeys, model.d);
	return $author$project$Carwow$StockSearch$viewSelectedCount(totalSelectedCount);
};
var $author$project$Carwow$StockSearch$allFiltersBtn = F2(
	function (btnClass, model) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(btnClass),
					$elm$html$Html$Events$onClick(
					$author$project$Carwow$StockSearch$OpenFiltersModal(_List_Nil)),
					A2($elm$html$Html$Attributes$attribute, 'data-interaction-type', 'open modal')
				]),
			$author$project$Carwow$StockSearch$filterBtnLabel(model));
	});
var $author$project$Carwow$StockSearch$chipFilterKeys = _List_fromArray(
	['stock_type', 'supplier_distance', 'make_slug', 'model_slug', 'body_types_slug', 'budget', 'transmission_long', 'fuel_long_simplified']);
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {cq: col, dG: contextStack, c5: problem, df: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.df, s.cq, x, s.aR));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.c, s.b);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{cq: 1, aR: s.aR, f: s.f, c: s.c + 1, df: s.df + 1, b: s.b}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{cq: s.cq + 1, aR: s.aR, f: s.f, c: newOffset, df: s.df, b: s.b}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.b);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.c, offset) < 0,
					0,
					{cq: col, aR: s0.aR, f: s0.f, c: offset, df: row, b: s0.b});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.c, s.df, s.cq, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.c, s1.c, s0.b),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.c, s.df, s.cq, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.aR)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.c, newOffset) < 0,
			0,
			{cq: newCol, aR: s.aR, f: s.f, c: newOffset, df: newRow, b: s.b});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.c, s.df, s.cq, s.b);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{cq: newCol, aR: s.aR, f: s.f, c: newOffset, df: newRow, b: s.b});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {cq: s.cq + (newOffset - s.c), aR: s.aR, f: s.f, c: newOffset, df: s.df, b: s.b};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.c, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.b);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.df, s.cq - (floatOffset + s.c), invalid, s.aR));
		} else {
			if (_Utils_eq(s.c, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.c, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.c, floatOffset, s.b));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.c, s.b)) {
			var zeroOffset = s.c + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.d2,
				c.cG,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.d2,
				c.cU,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.b),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.b) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.d2,
				c.cn,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.b),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.d2,
				c.cB,
				c.cJ,
				c.cC,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.d2,
				c.cB,
				c.cJ,
				c.cC,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.c, s.b),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				cn: $elm$core$Result$Err(invalid),
				cB: expecting,
				cC: $elm$core$Result$Err(invalid),
				cG: $elm$core$Result$Err(invalid),
				cJ: $elm$core$Result$Ok($elm$core$Basics$identity),
				d2: invalid,
				cU: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {cq: col, c5: problem, df: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.df, p.cq, p.c5);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{cq: 1, aR: _List_Nil, f: 1, c: 0, df: 1, b: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Carwow$HtmlSafe$htmlSafe = function (string) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]),
		A2(
			$elm$core$Result$map,
			$hecrj$html_parser$Html$Parser$Util$toVirtualDom,
			$hecrj$html_parser$Html$Parser$run(string)));
};
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.k)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.k, tail);
		return (notAppended < 0) ? {
			l: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.l),
			i: builder.i + 1,
			k: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			l: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.l),
			i: builder.i + 1,
			k: $elm$core$Elm$JsArray$empty
		} : {l: builder.l, i: builder.i, k: appended});
	});
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree = F4(
	function (shift, index, tail, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		if (_Utils_cmp(
			pos,
			$elm$core$Elm$JsArray$length(tree)) > -1) {
			if (shift === 5) {
				return A2(
					$elm$core$Elm$JsArray$push,
					$elm$core$Array$Leaf(tail),
					tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
				return A2($elm$core$Elm$JsArray$push, newSub, tree);
			}
		} else {
			var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!value.$) {
				var subTree = value.a;
				var newSub = $elm$core$Array$SubTree(
					A4($elm$core$Array$insertTailInTree, shift - $elm$core$Array$shiftStep, index, tail, subTree));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			} else {
				var newSub = $elm$core$Array$SubTree(
					A4(
						$elm$core$Array$insertTailInTree,
						shift - $elm$core$Array$shiftStep,
						index,
						tail,
						$elm$core$Elm$JsArray$singleton(value)));
				return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
			}
		}
	});
var $elm$core$Array$unsafeReplaceTail = F2(
	function (newTail, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		var originalTailLen = $elm$core$Elm$JsArray$length(tail);
		var newTailLen = $elm$core$Elm$JsArray$length(newTail);
		var newArrayLen = len + (newTailLen - originalTailLen);
		if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
			var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
			if (overflow) {
				var newShift = startShift + $elm$core$Array$shiftStep;
				var newTree = A4(
					$elm$core$Array$insertTailInTree,
					newShift,
					len,
					newTail,
					$elm$core$Elm$JsArray$singleton(
						$elm$core$Array$SubTree(tree)));
				return A4($elm$core$Array$Array_elm_builtin, newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
			} else {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					newArrayLen,
					startShift,
					A4($elm$core$Array$insertTailInTree, startShift, len, newTail, tree),
					$elm$core$Elm$JsArray$empty);
			}
		} else {
			return A4($elm$core$Array$Array_elm_builtin, newArrayLen, startShift, tree, newTail);
		}
	});
var $elm$core$Array$appendHelpTree = F2(
	function (toAppend, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
		var newArray = A2($elm$core$Array$unsafeReplaceTail, appended, array);
		if (notAppended < 0) {
			var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
			return A2($elm$core$Array$unsafeReplaceTail, nextTail, newArray);
		} else {
			return newArray;
		}
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		l: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		i: (len / $elm$core$Array$branchFactor) | 0,
		k: tail
	};
};
var $elm$core$Array$append = F2(
	function (a, _v0) {
		var aTail = a.d;
		var bLen = _v0.a;
		var bTree = _v0.c;
		var bTail = _v0.d;
		if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
			var foldHelper = F2(
				function (node, array) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpTree, leaf, array);
					}
				});
			return A2(
				$elm$core$Array$appendHelpTree,
				bTail,
				A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
		} else {
			var foldHelper = F2(
				function (node, builder) {
					if (!node.$) {
						var tree = node.a;
						return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
					} else {
						var leaf = node.a;
						return A2($elm$core$Array$appendHelpBuilder, leaf, builder);
					}
				});
			return A2(
				$elm$core$Array$builderToArray,
				true,
				A2(
					$elm$core$Array$appendHelpBuilder,
					bTail,
					A3(
						$elm$core$Elm$JsArray$foldl,
						foldHelper,
						$elm$core$Array$builderFromArray(a),
						bTree)));
		}
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Array$push = F2(
	function (a, array) {
		var tail = array.d;
		return A2(
			$elm$core$Array$unsafeReplaceTail,
			A2($elm$core$Elm$JsArray$push, a, tail),
			array);
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (!node.$) {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						l: _List_Nil,
						i: 0,
						k: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (!_v0.$) {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $elm_community$array_extra$Array$Extra$insertAt = F2(
	function (index, val) {
		return function (array) {
			var arrayLength = $elm$core$Array$length(array);
			if ((index >= 0) && (_Utils_cmp(index, arrayLength) < 1)) {
				var before = A3($elm$core$Array$slice, 0, index, array);
				var after = A3($elm$core$Array$slice, index, arrayLength, array);
				return A2(
					$elm$core$Array$append,
					A2($elm$core$Array$push, val, before),
					after);
			} else {
				return array;
			}
		};
	});
var $author$project$AutomaticTranslations$StockSearch$Filters$location = 'Ihre Region';
var $author$project$AutomaticTranslations$StockSearch$Filters$locationTooltipHtml = 'Standort festlegen, um Ergebnisse <br>in Ihrer Nähe zu erhalten.';
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Carwow$Search$Filters$selectedFilterCount = F2(
	function (keys, _v0) {
		var filters = _v0;
		var selectedVisuallyHiddenFilterCount = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (f) {
					return $elm$core$List$length(
						filters.x(f.g));
				},
				A2(
					$elm$core$List$filter,
					function (f) {
						return _Utils_eq(
							f.aZ,
							$elm$core$Maybe$Just(true));
					},
					A2($author$project$Carwow$Search$Filters$getFilters, filters, keys))));
		var allSelectedFilterCount = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (f) {
					return $elm$core$List$length(
						filters.x(f.g));
				},
				A2($author$project$Carwow$Search$Filters$getFilters, filters, keys)));
		return allSelectedFilterCount - selectedVisuallyHiddenFilterCount;
	});
var $author$project$Carwow$Search$selectedFilterCount = F2(
	function (keys, _v0) {
		var response = _v0;
		return A2($author$project$Carwow$Search$Filters$selectedFilterCount, keys, response.a);
	});
var $author$project$Carwow$Search$Filters$viewChipLabel = F2(
	function (config, filter) {
		var selectedFilterValues = config.x(filter.g);
		var count = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (str) {
					return !$elm$core$String$isEmpty(str);
				},
				selectedFilterValues));
		switch (count) {
			case 0:
				return filter.d3;
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					filter.d3,
					$elm$core$List$head(selectedFilterValues));
			default:
				return filter.d3 + (' (' + ($elm$core$String$fromInt(count) + ')'));
		}
	});
var $author$project$Carwow$Search$Filters$viewChipButton = F4(
	function (config, msg, withActiveState, filter) {
		var onClickMsg = msg(
			$elm$core$List$singleton(filter.u));
		var filterSelected = !$elm$core$List$isEmpty(
			config.x(filter.g));
		var labelClasses = _List_fromArray(
			[
				_Utils_Tuple2('chip', true),
				_Utils_Tuple2('chip--active', filterSelected)
			]);
		var chipLabel = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chip__label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Carwow$Search$Filters$viewChipLabel, config, filter))
					])),
				A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'caret_down',
				{cr: 'black', dj: 'xx-small'})
			]);
		var chipClasses = _List_fromArray(
			[
				_Utils_Tuple2('chip-dropdown', true),
				_Utils_Tuple2(
				'hidden-content',
				$author$project$Carwow$Search$Filters$filterHidden(filter))
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(chipClasses)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(labelClasses),
							$elm$html$Html$Events$onClick(onClickMsg)
						]),
					chipLabel)
				]));
	});
var $author$project$Carwow$Search$Filters$viewActiveChipButtons = F3(
	function (keys, msg, _v0) {
		var filters = _v0;
		return A2(
			$elm$core$List$map,
			A3($author$project$Carwow$Search$Filters$viewChipButton, filters, msg, true),
			A2($author$project$Carwow$Search$Filters$getFilters, filters, keys));
	});
var $author$project$Carwow$Search$viewActiveChipButtons = F3(
	function (keys, msg, _v0) {
		var filters = _v0.a;
		return A2($author$project$Carwow$Search$Filters$filtersNotPresent, keys, filters) ? _List_fromArray(
			[
				$elm$html$Html$text('')
			]) : A3($author$project$Carwow$Search$Filters$viewActiveChipButtons, keys, msg, filters);
	});
var $author$project$Carwow$Search$Filters$Chip = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Theme$ChipDropdown$ChipTypeModal = 0;
var $author$project$Carwow$Theme$ChipDropdown$Config = $elm$core$Basics$identity;
var $author$project$Carwow$Theme$ChipDropdown$defaultConfig = function (click) {
	return {
		br: false,
		bs: false,
		bt: click,
		bD: _List_Nil,
		d3: _List_Nil,
		a3: $author$project$Carwow$Theme$Modal$defaultConfig(
			click(0))
	};
};
var $author$project$Carwow$Theme$ChipDropdown$ChipTypeDropdown = 1;
var $author$project$Carwow$Theme$ChipDropdown$view = F2(
	function (_v0, chip) {
		var config = _v0;
		var state = chip.a;
		var modal = chip.b;
		var chipLabel = _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chip__label')
					]),
				config.d3),
				A2(
				$author$project$Carwow$Theme$Svgs$icon,
				'caret_down',
				{cr: 'black', dj: 'xx-small'})
			]);
		var chipClasses = _List_fromArray(
			[
				_Utils_Tuple2('chip-dropdown', true),
				_Utils_Tuple2('hidden-content', config.bs)
			]);
		var chipActive = (!state) || config.br;
		var labelClasses = _List_fromArray(
			[
				_Utils_Tuple2('chip', true),
				_Utils_Tuple2('chip--active', chipActive)
			]);
		var bodyClasses = _List_fromArray(
			[
				_Utils_Tuple2('chip-dropdown__body', true),
				_Utils_Tuple2('is-hidden', state === 1)
			]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(chipClasses)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chip-dropdown__tablet-up')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(labelClasses),
									$elm$html$Html$Events$onClick(
									config.bt(1))
								]),
							chipLabel),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(bodyClasses)
								]),
							config.bD)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chip-dropdown__mobile')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(labelClasses),
									$elm$html$Html$Events$onClick(
									config.bt(0))
								]),
							chipLabel),
							A2($author$project$Carwow$Theme$Modal$view, config.a3, modal)
						]))
				]));
	});
var $author$project$Carwow$Search$Filters$viewFilterDescription = F2(
	function (filter, className) {
		var _v0 = filter.cw;
		if (!_v0.$) {
			var description = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(className)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(description)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Carwow$Theme$ChipDropdown$withChipAlwaysActive = F2(
	function (active, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{br: active});
	});
var $author$project$Carwow$Theme$ChipDropdown$withChipHidden = F2(
	function (hidden, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bs: hidden});
	});
var $author$project$Carwow$Theme$ChipDropdown$withDropdown = F2(
	function (dropdown, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bD: dropdown});
	});
var $author$project$Carwow$Theme$ChipDropdown$withLabel = F2(
	function (label, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{d3: label});
	});
var $author$project$Carwow$Search$Filters$viewChipFilter = F4(
	function (config, change, alwaysActive, filter) {
		var initialChipConfig = $author$project$Carwow$Theme$ChipDropdown$defaultConfig(
			function (chipType) {
				return $author$project$Carwow$Search$Filters$ToggleFilter(
					$author$project$Carwow$Search$Filters$Chip(chipType));
			});
		var filterSelected = !$elm$core$List$isEmpty(
			config.x(filter.g));
		var chipContent = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Carwow$Search$Filters$ChangeValue,
						A2(config.ab, filter.u, filter.g))
					]))
			]);
		var chipConfig = A2(
			$author$project$Carwow$Theme$ChipDropdown$withChipHidden,
			$author$project$Carwow$Search$Filters$filterHidden(filter),
			A2(
				$author$project$Carwow$Theme$ChipDropdown$withDropdown,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-dropdown__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(filter.d3)
							])),
						A2($author$project$Carwow$Search$Filters$viewFilterDescription, filter, 'chip-dropdown__description'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-dropdown__options')
							]),
						chipContent)
					]),
				A2(
					$author$project$Carwow$Theme$ChipDropdown$withChipAlwaysActive,
					filterSelected && alwaysActive,
					A2(
						$author$project$Carwow$Theme$ChipDropdown$withLabel,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Carwow$Search$Filters$viewChipLabel, config, filter))
							]),
						initialChipConfig))));
		return A2(
			$elm$html$Html$map,
			change(filter.u),
			A2($author$project$Carwow$Theme$ChipDropdown$view, chipConfig, filter.D));
	});
var $author$project$Carwow$Search$Filters$viewChipDropdowns = F4(
	function (change, keys, alwaysActive, _v0) {
		var filters = _v0;
		return A2(
			$elm$core$List$map,
			A3($author$project$Carwow$Search$Filters$viewChipFilter, filters, change, alwaysActive),
			A2($author$project$Carwow$Search$Filters$getFilters, filters, keys));
	});
var $author$project$Carwow$Search$viewChipFilters = F4(
	function (msg, keys, alwaysActive, _v0) {
		var filters = _v0.a;
		return A2($author$project$Carwow$Search$Filters$filtersNotPresent, keys, filters) ? _List_Nil : A2(
			$elm$core$List$map,
			$elm$html$Html$map(msg),
			A4($author$project$Carwow$Search$Filters$viewChipDropdowns, $author$project$Carwow$Search$ChangeFilter, keys, alwaysActive, filters));
	});
var $author$project$Carwow$StockSearch$filtersChipView = function (model) {
	var totalSelectedCount = A2($author$project$Carwow$Search$selectedFilterCount, $author$project$Carwow$StockSearch$allFilterKeys, model.d);
	var locationChipTooltip = _Utils_eq(model.E, $elm$core$Maybe$Nothing) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-filters__location-chip-tooltip')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				$author$project$Carwow$HtmlSafe$htmlSafe($author$project$AutomaticTranslations$StockSearch$Filters$locationTooltipHtml))
			])) : $elm$html$Html$text('');
	var locationChipText = function () {
		var _v0 = model.E;
		if (!_v0.$) {
			var location = _v0.a;
			return location.c1;
		} else {
			return $author$project$AutomaticTranslations$StockSearch$Filters$location;
		}
	}();
	var locationChipClass = _Utils_eq(model.E, $elm$core$Maybe$Nothing) ? 'chip' : 'chip chip--active';
	var locationChip = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-filters__location-chip')
			]),
		_List_fromArray(
			[
				locationChipTooltip,
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(locationChipClass),
						A2($elm$html$Html$Attributes$attribute, 'data-interaction-type', 'open modal'),
						A2($elm$html$Html$Attributes$attribute, 'for', 'location-filters-modal-open')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(locationChipText)
					]))
			]));
	var chipFiltersWithLocationChip = function (chips) {
		return model.ai ? $elm$core$Array$toList(
			A3(
				$elm_community$array_extra$Array$Extra$insertAt,
				1,
				locationChip,
				$elm$core$Array$fromList(chips))) : chips;
	};
	var chipFiltersSmallViewport = A3($author$project$Carwow$Search$viewActiveChipButtons, $author$project$Carwow$StockSearch$chipFilterKeys, $author$project$Carwow$StockSearch$OpenFiltersModal, model.d);
	var chipAlwaysActive = true;
	var chipFilters = A4($author$project$Carwow$Search$viewChipFilters, $author$project$Carwow$StockSearch$ChangeResponse, $author$project$Carwow$StockSearch$chipFilterKeys, chipAlwaysActive, model.d);
	var allFiltersChipClass = (!totalSelectedCount) ? 'chip' : 'chip chip--active chip--active-filled chip--gapped';
	var allFiltersChip = A2($author$project$Carwow$StockSearch$allFiltersBtn, allFiltersChipClass, model);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-filters__chips-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stock-filters__filter-group stock-filters__filter-group--show-on-small')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-group')
							]),
						A2(
							$elm$core$List$cons,
							allFiltersChip,
							chipFiltersWithLocationChip(chipFiltersSmallViewport)))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stock-filters__filter-group stock-filters__filter-group--show-on-medium-up')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-group')
							]),
						A2(
							$elm$core$List$cons,
							allFiltersChip,
							_Utils_ap(
								chipFiltersWithLocationChip(chipFilters),
								_List_fromArray(
									[
										$author$project$Carwow$StockSearch$viewClearAll('chip-filters__clear-all')
									]))))
					]))
			]));
};
var $author$project$AutomaticTranslations$StockSearch$Results$sortedBy = 'Sortiert nach';
var $author$project$AutomaticTranslations$StockSearch$Results$title = function (total_results) {
	return '' + (total_results + ' Ergebnisse');
};
var $author$project$Carwow$Search$ChangeSortOrder = function (a) {
	return {$: 2, a: a};
};
var $author$project$Carwow$Search$SortOrder$Close = {$: 2};
var $author$project$Carwow$Search$SortOrder$Toggle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Carwow$Search$SortOrder$buildSortName = F2(
	function (type_, context) {
		return A2(
			$elm$core$String$join,
			'-',
			_List_fromArray(
				['sorting', type_, context]));
	});
var $author$project$AutomaticTranslations$Search$done = 'Fertig';
var $author$project$Carwow$Search$SortOrder$ChangeValue = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Search$SortOrder$renderOption = F2(
	function (sortName, option) {
		var optionId = option.u + ('-' + option.bA);
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$id(optionId),
									$elm$html$Html$Attributes$name(sortName),
									$elm$html$Html$Attributes$checked(option.ek),
									$elm$html$Html$Events$onClick(
									$author$project$Carwow$Search$SortOrder$ChangeValue(option.u))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$for(optionId)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(option.d3)
								]))
						]))
				]));
	});
var $author$project$Carwow$Search$SortOrder$renderOptions = F3(
	function (_v0, msg, sortName) {
		var sortOrder = _v0;
		return A2(
			$elm$html$Html$map,
			msg,
			A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-unstyled')
					]),
				A2(
					$elm$core$List$map,
					$author$project$Carwow$Search$SortOrder$renderOption(sortName),
					sortOrder.o)));
	});
var $author$project$AutomaticTranslations$Search$SortOrder$sortBy = 'Sortieren nach';
var $author$project$Carwow$Theme$Modal$CloseButton = function (a) {
	return {$: 1, a: a};
};
var $author$project$Carwow$Theme$Modal$withCloseButton = F2(
	function (button, _v0) {
		var config = _v0;
		var _v1 = config.t;
		if (!_v1.$) {
			var action = _v1.a;
			var title = _v1.b;
			return _Utils_update(
				config,
				{
					t: A3(
						$author$project$Carwow$Theme$Modal$Header,
						action,
						title,
						$author$project$Carwow$Theme$Modal$CloseButton(button))
				});
		} else {
			return config;
		}
	});
var $author$project$Carwow$Theme$ChipDropdown$withModal = F2(
	function (modalConf, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{a3: modalConf});
	});
var $author$project$Carwow$Search$SortOrder$view = F3(
	function (sortOrder, msg, context) {
		var struct = sortOrder;
		var sortLabel = function () {
			var _v0 = $author$project$Carwow$Search$SortOrder$selected(sortOrder);
			if (!_v0.$) {
				var option = _v0.a;
				return option.d3;
			} else {
				return '';
			}
		}();
		var initialChipConfig = $author$project$Carwow$Theme$ChipDropdown$defaultConfig(
			function (chipType) {
				return msg(
					$author$project$Carwow$Search$SortOrder$Toggle(chipType));
			});
		var content = function (type_) {
			return A3(
				$author$project$Carwow$Search$SortOrder$renderOptions,
				sortOrder,
				msg,
				A2($author$project$Carwow$Search$SortOrder$buildSortName, type_, context));
		};
		var modal = A2(
			$author$project$Carwow$Theme$Modal$withBody,
			_List_fromArray(
				[
					content('modal')
				]),
			A2(
				$author$project$Carwow$Theme$Modal$withCloseButton,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal__open-link'),
								$elm$html$Html$Events$onClick(
								msg($author$project$Carwow$Search$SortOrder$Close))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$AutomaticTranslations$Search$done)
							]))
					]),
				A2(
					$author$project$Carwow$Theme$Modal$withSecondaryAction,
					_List_fromArray(
						[
							$elm$html$Html$text($author$project$AutomaticTranslations$Search$SortOrder$sortBy)
						]),
					$author$project$Carwow$Theme$Modal$asDrawer(
						$author$project$Carwow$Theme$Modal$defaultConfig(
							msg($author$project$Carwow$Search$SortOrder$Close))))));
		var chipConfig = A2(
			$author$project$Carwow$Theme$ChipDropdown$withModal,
			modal,
			A2(
				$author$project$Carwow$Theme$ChipDropdown$withDropdown,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-dropdown__title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$AutomaticTranslations$Search$SortOrder$sortBy)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chip-dropdown__options')
							]),
						_List_fromArray(
							[
								content('chip')
							]))
					]),
				A2(
					$author$project$Carwow$Theme$ChipDropdown$withLabel,
					_List_fromArray(
						[
							$elm$html$Html$text(sortLabel)
						]),
					initialChipConfig)));
		return A2($author$project$Carwow$Theme$ChipDropdown$view, chipConfig, struct.D);
	});
var $author$project$Carwow$Search$viewSort = F3(
	function (msg, context, _v0) {
		var sortOrder = _v0.h;
		return A2(
			$elm$html$Html$map,
			msg,
			A3($author$project$Carwow$Search$SortOrder$view, sortOrder, $author$project$Carwow$Search$ChangeSortOrder, context));
	});
var $author$project$Carwow$StockSearch$renderFilters = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-filters')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stock-filters__content grid-container')
					]),
				_List_fromArray(
					[
						$author$project$Carwow$StockSearch$filtersChipView(model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stock-filters__header-title')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stock-filters-header-title__total')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$AutomaticTranslations$StockSearch$Results$title(
											A2(
												$author$project$ThemeTranslations$Numbers$formatNumber,
												$author$project$Carwow$StockSearch$resultsCount(model),
												0)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stock-filters-header-title__sorting')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$AutomaticTranslations$StockSearch$Results$sortedBy + ' ')
											])),
										A3($author$project$Carwow$Search$viewSort, $author$project$Carwow$StockSearch$ChangeResponse, 'default-sort', model.d)
									]))
							]))
					]))
			]));
};
var $author$project$Carwow$StockSearch$renderSpinner = function (loading) {
	return loading ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('loading-overlay')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('carwow-spinner carwow-spinner-centered')
					]),
				_List_Nil)
			])) : $elm$html$Html$text('');
};
var $author$project$Carwow$StockSearch$searchResultView = function (model) {
	var cars = A2(
		$author$project$Carwow$Search$withData,
		$elm$core$List$map(
			model.bb(model.E)),
		model.d);
	var searchResultContent = $elm$core$List$isEmpty(cars) ? $author$project$Carwow$StockSearch$emptyStateView : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-car-search-results-container')
			]),
		_List_fromArray(
			[
				A3(
				$elm$html$Html$Keyed$node,
				'div',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stock-car-search-results')
					]),
				cars)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('stock-results-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('stock-results'),
						$elm$html$Html$Attributes$class('stock-cars-available')
					]),
				_List_fromArray(
					[
						$author$project$Carwow$StockSearch$renderFilters(model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('grid-container')
							]),
						_List_fromArray(
							[
								searchResultContent,
								$author$project$Carwow$StockSearch$recommendationsView(model),
								$author$project$Carwow$StockSearch$renderSpinner(model.S)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('grid-container')
					]),
				_List_fromArray(
					[
						$author$project$Carwow$StockSearch$paginationView(model)
					]))
			]));
};
var $author$project$Carwow$StockSearch$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Carwow$StockSearch$headerView(model),
				$author$project$Carwow$StockSearch$searchResultView(model),
				$author$project$Carwow$StockSearch$filtersModalView(model),
				$author$project$Carwow$StockSearch$jumbotronView(model)
			]));
};
var $author$project$Carwow$StockSearch$main = $elm$browser$Browser$element(
	{d1: $author$project$Carwow$StockSearch$init, ep: $author$project$Carwow$StockSearch$subscriptions, eD: $author$project$Carwow$StockSearch$update, ab: $author$project$Carwow$StockSearch$view});
_Platform_export({'Carwow':{'StockSearch':{'init':$author$project$Carwow$StockSearch$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (windowPath) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (windowOrigin) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (userPostcode) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (userLocation) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (stockSale) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (sourcePartner) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (showPriceConfidence) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (showPowerKw) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (showLocationChip) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (showHeader) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (showEfficiencyDetails) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (showAskForLeasingPrice) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (searchParams) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (searchData) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (researchSiteUrl) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (quotesSiteUrl) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (makeModelMenuModalId) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (hideDistance) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (filterOptions) {
																																							return A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (dealsServiceApiEndpoint) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (dealRootPath) {
																																											return A2(
																																												$elm$json$Json$Decode$andThen,
																																												function (dealRelativePath) {
																																													return A2(
																																														$elm$json$Json$Decode$andThen,
																																														function (carDataSiteUrl) {
																																															return A2(
																																																$elm$json$Json$Decode$andThen,
																																																function (appName) {
																																																	return $elm$json$Json$Decode$succeed(
																																																		{bo: appName, cp: carDataSiteUrl, bw: dealRelativePath, bx: dealRootPath, by: dealsServiceApiEndpoint, ax: filterOptions, bH: hideDistance, af: makeModelMenuModalId, ba: quotesSiteUrl, dd: researchSiteUrl, d: searchData, b1: searchParams, b4: showAskForLeasingPrice, b5: showEfficiencyDetails, ah: showHeader, ai: showLocationChip, b6: showPowerKw, b7: showPriceConfidence, ak: sourcePartner, Z: stockSale, bj: userLocation, cj: userPostcode, ap: windowOrigin, aq: windowPath});
																																																},
																																																A2($elm$json$Json$Decode$field, 'appName', $elm$json$Json$Decode$string));
																																														},
																																														A2($elm$json$Json$Decode$field, 'carDataSiteUrl', $elm$json$Json$Decode$string));
																																												},
																																												A2(
																																													$elm$json$Json$Decode$field,
																																													'dealRelativePath',
																																													$elm$json$Json$Decode$oneOf(
																																														_List_fromArray(
																																															[
																																																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																															]))));
																																										},
																																										A2(
																																											$elm$json$Json$Decode$field,
																																											'dealRootPath',
																																											$elm$json$Json$Decode$oneOf(
																																												_List_fromArray(
																																													[
																																														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																														A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																													]))));
																																								},
																																								A2($elm$json$Json$Decode$field, 'dealsServiceApiEndpoint', $elm$json$Json$Decode$string));
																																						},
																																						A2(
																																							$elm$json$Json$Decode$field,
																																							'filterOptions',
																																							$elm$json$Json$Decode$oneOf(
																																								_List_fromArray(
																																									[
																																										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																										A2(
																																										$elm$json$Json$Decode$map,
																																										$elm$core$Maybe$Just,
																																										A2(
																																											$elm$json$Json$Decode$andThen,
																																											function (hiddenFilters) {
																																												return A2(
																																													$elm$json$Json$Decode$andThen,
																																													function (excludedFilters) {
																																														return A2(
																																															$elm$json$Json$Decode$andThen,
																																															function (defaultModelSlugs) {
																																																return A2(
																																																	$elm$json$Json$Decode$andThen,
																																																	function (defaultMakeSlugs) {
																																																		return A2(
																																																			$elm$json$Json$Decode$andThen,
																																																			function (allowedStockTypes) {
																																																				return $elm$json$Json$Decode$succeed(
																																																					{dA: allowedStockTypes, dM: defaultMakeSlugs, dN: defaultModelSlugs, dT: excludedFilters, dZ: hiddenFilters});
																																																			},
																																																			A2(
																																																				$elm$json$Json$Decode$field,
																																																				'allowedStockTypes',
																																																				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																																																	},
																																																	A2(
																																																		$elm$json$Json$Decode$field,
																																																		'defaultMakeSlugs',
																																																		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																																															},
																																															A2(
																																																$elm$json$Json$Decode$field,
																																																'defaultModelSlugs',
																																																$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																																													},
																																													A2(
																																														$elm$json$Json$Decode$field,
																																														'excludedFilters',
																																														$elm$json$Json$Decode$list($elm$json$Json$Decode$string)));
																																											},
																																											A2(
																																												$elm$json$Json$Decode$field,
																																												'hiddenFilters',
																																												$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))
																																									]))));
																																				},
																																				A2($elm$json$Json$Decode$field, 'hideDistance', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'makeModelMenuModalId', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'quotesSiteUrl', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'researchSiteUrl', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'searchData', $elm$json$Json$Decode$string));
																										},
																										A2(
																											$elm$json$Json$Decode$field,
																											'searchParams',
																											$elm$json$Json$Decode$list(
																												A2(
																													$elm$json$Json$Decode$andThen,
																													function (_v0) {
																														return A2(
																															$elm$json$Json$Decode$andThen,
																															function (_v1) {
																																return $elm$json$Json$Decode$succeed(
																																	_Utils_Tuple2(_v0, _v1));
																															},
																															A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
																													},
																													A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)))));
																								},
																								A2($elm$json$Json$Decode$field, 'showAskForLeasingPrice', $elm$json$Json$Decode$string));
																						},
																						A2($elm$json$Json$Decode$field, 'showEfficiencyDetails', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'showHeader', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'showLocationChip', $elm$json$Json$Decode$bool));
																},
																A2($elm$json$Json$Decode$field, 'showPowerKw', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'showPriceConfidence', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'sourcePartner', $elm$json$Json$Decode$string));
										},
										A2(
											$elm$json$Json$Decode$field,
											'stockSale',
											$elm$json$Json$Decode$oneOf(
												_List_fromArray(
													[
														$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
														A2(
														$elm$json$Json$Decode$map,
														$elm$core$Maybe$Just,
														A2(
															$elm$json$Json$Decode$andThen,
															function (badge) {
																return $elm$json$Json$Decode$succeed(
																	{at: badge});
															},
															A2(
																$elm$json$Json$Decode$field,
																'badge',
																$elm$json$Json$Decode$oneOf(
																	_List_fromArray(
																		[
																			$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																			A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																		])))))
													]))));
								},
								A2($elm$json$Json$Decode$field, 'userLocation', $elm$json$Json$Decode$string));
						},
						A2(
							$elm$json$Json$Decode$field,
							'userPostcode',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2($elm$json$Json$Decode$field, 'windowOrigin', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'windowPath', $elm$json$Json$Decode$string)))(0)}}});}(this));